export const emojiList = [
  {
    code: ["1F600"],
    emoji: "😀",
    name: "grinning face",
    category: "Smileys & Emotion",
    subcategory: "face-smiling",
  },
  {
    code: ["1F603"],
    emoji: "😃",
    name: "grinning face with big eyes",
    category: "Smileys & Emotion",
    subcategory: "face-smiling",
  },
  {
    code: ["1F604"],
    emoji: "😄",
    name: "grinning face with smiling eyes",
    category: "Smileys & Emotion",
    subcategory: "face-smiling",
  },
  {
    code: ["1F601"],
    emoji: "😁",
    name: "beaming face with smiling eyes",
    category: "Smileys & Emotion",
    subcategory: "face-smiling",
  },
  {
    code: ["1F606"],
    emoji: "😆",
    name: "grinning squinting face",
    category: "Smileys & Emotion",
    subcategory: "face-smiling",
  },
  {
    code: ["1F605"],
    emoji: "😅",
    name: "grinning face with sweat",
    category: "Smileys & Emotion",
    subcategory: "face-smiling",
  },
  {
    code: ["1F923"],
    emoji: "🤣",
    name: "rolling on the floor laughing",
    category: "Smileys & Emotion",
    subcategory: "face-smiling",
  },
  {
    code: ["1F602"],
    emoji: "😂",
    name: "face with tears of joy",
    category: "Smileys & Emotion",
    subcategory: "face-smiling",
  },
  {
    code: ["1F642"],
    emoji: "🙂",
    name: "slightly smiling face",
    category: "Smileys & Emotion",
    subcategory: "face-smiling",
  },
  {
    code: ["1F643"],
    emoji: "🙃",
    name: "upside-down face",
    category: "Smileys & Emotion",
    subcategory: "face-smiling",
  },
  {
    code: ["1FAE0"],
    emoji: "🫠",
    name: "melting face",
    category: "Smileys & Emotion",
    subcategory: "face-smiling",
  },
  {
    code: ["1F609"],
    emoji: "😉",
    name: "winking face",
    category: "Smileys & Emotion",
    subcategory: "face-smiling",
  },
  {
    code: ["1F60A"],
    emoji: "😊",
    name: "smiling face with smiling eyes",
    category: "Smileys & Emotion",
    subcategory: "face-smiling",
  },
  {
    code: ["1F607"],
    emoji: "😇",
    name: "smiling face with halo",
    category: "Smileys & Emotion",
    subcategory: "face-smiling",
  },
  {
    code: ["1F970"],
    emoji: "🥰",
    name: "smiling face with hearts",
    category: "Smileys & Emotion",
    subcategory: "face-affection",
  },
  {
    code: ["1F60D"],
    emoji: "😍",
    name: "smiling face with heart-eyes",
    category: "Smileys & Emotion",
    subcategory: "face-affection",
  },
  {
    code: ["1F929"],
    emoji: "🤩",
    name: "star-struck",
    category: "Smileys & Emotion",
    subcategory: "face-affection",
  },
  {
    code: ["1F618"],
    emoji: "😘",
    name: "face blowing a kiss",
    category: "Smileys & Emotion",
    subcategory: "face-affection",
  },
  {
    code: ["1F617"],
    emoji: "😗",
    name: "kissing face",
    category: "Smileys & Emotion",
    subcategory: "face-affection",
  },
  {
    code: ["263A"],
    emoji: "☺",
    name: "smiling face",
    category: "Smileys & Emotion",
    subcategory: "face-affection",
  },
  {
    code: ["1F61A"],
    emoji: "😚",
    name: "kissing face with closed eyes",
    category: "Smileys & Emotion",
    subcategory: "face-affection",
  },
  {
    code: ["1F619"],
    emoji: "😙",
    name: "kissing face with smiling eyes",
    category: "Smileys & Emotion",
    subcategory: "face-affection",
  },
  {
    code: ["1F972"],
    emoji: "🥲",
    name: "smiling face with tear",
    category: "Smileys & Emotion",
    subcategory: "face-affection",
  },
  {
    code: ["1F60B"],
    emoji: "😋",
    name: "face savoring food",
    category: "Smileys & Emotion",
    subcategory: "face-tongue",
  },
  {
    code: ["1F61B"],
    emoji: "😛",
    name: "face with tongue",
    category: "Smileys & Emotion",
    subcategory: "face-tongue",
  },
  {
    code: ["1F61C"],
    emoji: "😜",
    name: "winking face with tongue",
    category: "Smileys & Emotion",
    subcategory: "face-tongue",
  },
  {
    code: ["1F92A"],
    emoji: "🤪",
    name: "zany face",
    category: "Smileys & Emotion",
    subcategory: "face-tongue",
  },
  {
    code: ["1F61D"],
    emoji: "😝",
    name: "squinting face with tongue",
    category: "Smileys & Emotion",
    subcategory: "face-tongue",
  },
  {
    code: ["1F911"],
    emoji: "🤑",
    name: "money-mouth face",
    category: "Smileys & Emotion",
    subcategory: "face-tongue",
  },
  {
    code: ["1F917"],
    emoji: "🤗",
    name: "smiling face with open hands",
    category: "Smileys & Emotion",
    subcategory: "face-hand",
  },
  {
    code: ["1F92D"],
    emoji: "🤭",
    name: "face with hand over mouth",
    category: "Smileys & Emotion",
    subcategory: "face-hand",
  },
  {
    code: ["1FAE2"],
    emoji: "🫢",
    name: "face with open eyes and hand over mouth",
    category: "Smileys & Emotion",
    subcategory: "face-hand",
  },
  {
    code: ["1FAE3"],
    emoji: "🫣",
    name: "face with peeking eye",
    category: "Smileys & Emotion",
    subcategory: "face-hand",
  },
  {
    code: ["1F92B"],
    emoji: "🤫",
    name: "shushing face",
    category: "Smileys & Emotion",
    subcategory: "face-hand",
  },
  {
    code: ["1F914"],
    emoji: "🤔",
    name: "thinking face",
    category: "Smileys & Emotion",
    subcategory: "face-hand",
  },
  {
    code: ["1FAE1"],
    emoji: "🫡",
    name: "saluting face",
    category: "Smileys & Emotion",
    subcategory: "face-hand",
  },
  {
    code: ["1F910"],
    emoji: "🤐",
    name: "zipper-mouth face",
    category: "Smileys & Emotion",
    subcategory: "face-neutral-skeptical",
  },
  {
    code: ["1F928"],
    emoji: "🤨",
    name: "face with raised eyebrow",
    category: "Smileys & Emotion",
    subcategory: "face-neutral-skeptical",
  },
  {
    code: ["1F610"],
    emoji: "😐",
    name: "neutral face",
    category: "Smileys & Emotion",
    subcategory: "face-neutral-skeptical",
  },
  {
    code: ["1F611"],
    emoji: "😑",
    name: "expressionless face",
    category: "Smileys & Emotion",
    subcategory: "face-neutral-skeptical",
  },
  {
    code: ["1F636"],
    emoji: "😶",
    name: "face without mouth",
    category: "Smileys & Emotion",
    subcategory: "face-neutral-skeptical",
  },
  {
    code: ["1FAE5"],
    emoji: "🫥",
    name: "dotted line face",
    category: "Smileys & Emotion",
    subcategory: "face-neutral-skeptical",
  },
  {
    code: ["1F636", "200D", "1F32B", "FE0F"],
    emoji: "😶‍🌫️",
    name: "face in clouds",
    category: "Smileys & Emotion",
    subcategory: "face-neutral-skeptical",
  },
  {
    code: ["1F60F"],
    emoji: "😏",
    name: "smirking face",
    category: "Smileys & Emotion",
    subcategory: "face-neutral-skeptical",
  },
  {
    code: ["1F612"],
    emoji: "😒",
    name: "unamused face",
    category: "Smileys & Emotion",
    subcategory: "face-neutral-skeptical",
  },
  {
    code: ["1F644"],
    emoji: "🙄",
    name: "face with rolling eyes",
    category: "Smileys & Emotion",
    subcategory: "face-neutral-skeptical",
  },
  {
    code: ["1F62C"],
    emoji: "😬",
    name: "grimacing face",
    category: "Smileys & Emotion",
    subcategory: "face-neutral-skeptical",
  },
  {
    code: ["1F62E", "200D", "1F4A8"],
    emoji: "😮‍💨",
    name: "face exhaling",
    category: "Smileys & Emotion",
    subcategory: "face-neutral-skeptical",
  },
  {
    code: ["1F925"],
    emoji: "🤥",
    name: "lying face",
    category: "Smileys & Emotion",
    subcategory: "face-neutral-skeptical",
  },
  {
    code: ["1FAE8"],
    emoji: "🫨",
    name: "shaking face",
    category: "Smileys & Emotion",
    subcategory: "face-neutral-skeptical",
  },
  {
    code: ["1F642", "200D", "2194", "FE0F"],
    emoji: "🙂‍↔️",
    name: "head shaking horizontally",
    category: "Smileys & Emotion",
    subcategory: "face-neutral-skeptical",
  },
  {
    code: ["1F642", "200D", "2195", "FE0F"],
    emoji: "🙂‍↕️",
    name: "head shaking vertically",
    category: "Smileys & Emotion",
    subcategory: "face-neutral-skeptical",
  },
  {
    code: ["1F60C"],
    emoji: "😌",
    name: "relieved face",
    category: "Smileys & Emotion",
    subcategory: "face-sleepy",
  },
  {
    code: ["1F614"],
    emoji: "😔",
    name: "pensive face",
    category: "Smileys & Emotion",
    subcategory: "face-sleepy",
  },
  {
    code: ["1F62A"],
    emoji: "😪",
    name: "sleepy face",
    category: "Smileys & Emotion",
    subcategory: "face-sleepy",
  },
  {
    code: ["1F924"],
    emoji: "🤤",
    name: "drooling face",
    category: "Smileys & Emotion",
    subcategory: "face-sleepy",
  },
  {
    code: ["1F634"],
    emoji: "😴",
    name: "sleeping face",
    category: "Smileys & Emotion",
    subcategory: "face-sleepy",
  },
  {
    code: ["1FAE9"],
    emoji: "🫩",
    name: "face with bags under eyes",
    category: "Smileys & Emotion",
    subcategory: "face-sleepy",
  },
  {
    code: ["1F637"],
    emoji: "😷",
    name: "face with medical mask",
    category: "Smileys & Emotion",
    subcategory: "face-unwell",
  },
  {
    code: ["1F912"],
    emoji: "🤒",
    name: "face with thermometer",
    category: "Smileys & Emotion",
    subcategory: "face-unwell",
  },
  {
    code: ["1F915"],
    emoji: "🤕",
    name: "face with head-bandage",
    category: "Smileys & Emotion",
    subcategory: "face-unwell",
  },
  {
    code: ["1F922"],
    emoji: "🤢",
    name: "nauseated face",
    category: "Smileys & Emotion",
    subcategory: "face-unwell",
  },
  {
    code: ["1F92E"],
    emoji: "🤮",
    name: "face vomiting",
    category: "Smileys & Emotion",
    subcategory: "face-unwell",
  },
  {
    code: ["1F927"],
    emoji: "🤧",
    name: "sneezing face",
    category: "Smileys & Emotion",
    subcategory: "face-unwell",
  },
  {
    code: ["1F975"],
    emoji: "🥵",
    name: "hot face",
    category: "Smileys & Emotion",
    subcategory: "face-unwell",
  },
  {
    code: ["1F976"],
    emoji: "🥶",
    name: "cold face",
    category: "Smileys & Emotion",
    subcategory: "face-unwell",
  },
  {
    code: ["1F974"],
    emoji: "🥴",
    name: "woozy face",
    category: "Smileys & Emotion",
    subcategory: "face-unwell",
  },
  {
    code: ["1F635"],
    emoji: "😵",
    name: "face with crossed-out eyes",
    category: "Smileys & Emotion",
    subcategory: "face-unwell",
  },
  {
    code: ["1F635", "200D", "1F4AB"],
    emoji: "😵‍💫",
    name: "face with spiral eyes",
    category: "Smileys & Emotion",
    subcategory: "face-unwell",
  },
  {
    code: ["1F92F"],
    emoji: "🤯",
    name: "exploding head",
    category: "Smileys & Emotion",
    subcategory: "face-unwell",
  },
  {
    code: ["1F920"],
    emoji: "🤠",
    name: "cowboy hat face",
    category: "Smileys & Emotion",
    subcategory: "face-hat",
  },
  {
    code: ["1F973"],
    emoji: "🥳",
    name: "partying face",
    category: "Smileys & Emotion",
    subcategory: "face-hat",
  },
  {
    code: ["1F978"],
    emoji: "🥸",
    name: "disguised face",
    category: "Smileys & Emotion",
    subcategory: "face-hat",
  },
  {
    code: ["1F60E"],
    emoji: "😎",
    name: "smiling face with sunglasses",
    category: "Smileys & Emotion",
    subcategory: "face-glasses",
  },
  {
    code: ["1F913"],
    emoji: "🤓",
    name: "nerd face",
    category: "Smileys & Emotion",
    subcategory: "face-glasses",
  },
  {
    code: ["1F9D0"],
    emoji: "🧐",
    name: "face with monocle",
    category: "Smileys & Emotion",
    subcategory: "face-glasses",
  },
  {
    code: ["1F615"],
    emoji: "😕",
    name: "confused face",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1FAE4"],
    emoji: "🫤",
    name: "face with diagonal mouth",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F61F"],
    emoji: "😟",
    name: "worried face",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F641"],
    emoji: "🙁",
    name: "slightly frowning face",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["2639"],
    emoji: "☹",
    name: "frowning face",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F62E"],
    emoji: "😮",
    name: "face with open mouth",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F62F"],
    emoji: "😯",
    name: "hushed face",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F632"],
    emoji: "😲",
    name: "astonished face",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F633"],
    emoji: "😳",
    name: "flushed face",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F97A"],
    emoji: "🥺",
    name: "pleading face",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F979"],
    emoji: "🥹",
    name: "face holding back tears",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F626"],
    emoji: "😦",
    name: "frowning face with open mouth",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F627"],
    emoji: "😧",
    name: "anguished face",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F628"],
    emoji: "😨",
    name: "fearful face",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F630"],
    emoji: "😰",
    name: "anxious face with sweat",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F625"],
    emoji: "😥",
    name: "sad but relieved face",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F622"],
    emoji: "😢",
    name: "crying face",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F62D"],
    emoji: "😭",
    name: "loudly crying face",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F631"],
    emoji: "😱",
    name: "face screaming in fear",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F616"],
    emoji: "😖",
    name: "confounded face",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F623"],
    emoji: "😣",
    name: "persevering face",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F61E"],
    emoji: "😞",
    name: "disappointed face",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F613"],
    emoji: "😓",
    name: "downcast face with sweat",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F629"],
    emoji: "😩",
    name: "weary face",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F62B"],
    emoji: "😫",
    name: "tired face",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F971"],
    emoji: "🥱",
    name: "yawning face",
    category: "Smileys & Emotion",
    subcategory: "face-concerned",
  },
  {
    code: ["1F624"],
    emoji: "😤",
    name: "face with steam from nose",
    category: "Smileys & Emotion",
    subcategory: "face-negative",
  },
  {
    code: ["1F621"],
    emoji: "😡",
    name: "enraged face",
    category: "Smileys & Emotion",
    subcategory: "face-negative",
  },
  {
    code: ["1F620"],
    emoji: "😠",
    name: "angry face",
    category: "Smileys & Emotion",
    subcategory: "face-negative",
  },
  {
    code: ["1F92C"],
    emoji: "🤬",
    name: "face with symbols on mouth",
    category: "Smileys & Emotion",
    subcategory: "face-negative",
  },
  {
    code: ["1F608"],
    emoji: "😈",
    name: "smiling face with horns",
    category: "Smileys & Emotion",
    subcategory: "face-negative",
  },
  {
    code: ["1F47F"],
    emoji: "👿",
    name: "angry face with horns",
    category: "Smileys & Emotion",
    subcategory: "face-negative",
  },
  {
    code: ["1F480"],
    emoji: "💀",
    name: "skull",
    category: "Smileys & Emotion",
    subcategory: "face-negative",
  },
  {
    code: ["2620"],
    emoji: "☠",
    name: "skull and crossbones",
    category: "Smileys & Emotion",
    subcategory: "face-negative",
  },
  {
    code: ["1F4A9"],
    emoji: "💩",
    name: "pile of poo",
    category: "Smileys & Emotion",
    subcategory: "face-costume",
  },
  {
    code: ["1F921"],
    emoji: "🤡",
    name: "clown face",
    category: "Smileys & Emotion",
    subcategory: "face-costume",
  },
  {
    code: ["1F479"],
    emoji: "👹",
    name: "ogre",
    category: "Smileys & Emotion",
    subcategory: "face-costume",
  },
  {
    code: ["1F47A"],
    emoji: "👺",
    name: "goblin",
    category: "Smileys & Emotion",
    subcategory: "face-costume",
  },
  {
    code: ["1F47B"],
    emoji: "👻",
    name: "ghost",
    category: "Smileys & Emotion",
    subcategory: "face-costume",
  },
  {
    code: ["1F47D"],
    emoji: "👽",
    name: "alien",
    category: "Smileys & Emotion",
    subcategory: "face-costume",
  },
  {
    code: ["1F47E"],
    emoji: "👾",
    name: "alien monster",
    category: "Smileys & Emotion",
    subcategory: "face-costume",
  },
  {
    code: ["1F916"],
    emoji: "🤖",
    name: "robot",
    category: "Smileys & Emotion",
    subcategory: "face-costume",
  },
  {
    code: ["1F63A"],
    emoji: "😺",
    name: "grinning cat",
    category: "Smileys & Emotion",
    subcategory: "cat-face",
  },
  {
    code: ["1F638"],
    emoji: "😸",
    name: "grinning cat with smiling eyes",
    category: "Smileys & Emotion",
    subcategory: "cat-face",
  },
  {
    code: ["1F639"],
    emoji: "😹",
    name: "cat with tears of joy",
    category: "Smileys & Emotion",
    subcategory: "cat-face",
  },
  {
    code: ["1F63B"],
    emoji: "😻",
    name: "smiling cat with heart-eyes",
    category: "Smileys & Emotion",
    subcategory: "cat-face",
  },
  {
    code: ["1F63C"],
    emoji: "😼",
    name: "cat with wry smile",
    category: "Smileys & Emotion",
    subcategory: "cat-face",
  },
  {
    code: ["1F63D"],
    emoji: "😽",
    name: "kissing cat",
    category: "Smileys & Emotion",
    subcategory: "cat-face",
  },
  {
    code: ["1F640"],
    emoji: "🙀",
    name: "weary cat",
    category: "Smileys & Emotion",
    subcategory: "cat-face",
  },
  {
    code: ["1F63F"],
    emoji: "😿",
    name: "crying cat",
    category: "Smileys & Emotion",
    subcategory: "cat-face",
  },
  {
    code: ["1F63E"],
    emoji: "😾",
    name: "pouting cat",
    category: "Smileys & Emotion",
    subcategory: "cat-face",
  },
  {
    code: ["1F648"],
    emoji: "🙈",
    name: "see-no-evil monkey",
    category: "Smileys & Emotion",
    subcategory: "monkey-face",
  },
  {
    code: ["1F649"],
    emoji: "🙉",
    name: "hear-no-evil monkey",
    category: "Smileys & Emotion",
    subcategory: "monkey-face",
  },
  {
    code: ["1F64A"],
    emoji: "🙊",
    name: "speak-no-evil monkey",
    category: "Smileys & Emotion",
    subcategory: "monkey-face",
  },
  {
    code: ["1F48C"],
    emoji: "💌",
    name: "love letter",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["1F498"],
    emoji: "💘",
    name: "heart with arrow",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["1F49D"],
    emoji: "💝",
    name: "heart with ribbon",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["1F496"],
    emoji: "💖",
    name: "sparkling heart",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["1F497"],
    emoji: "💗",
    name: "growing heart",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["1F493"],
    emoji: "💓",
    name: "beating heart",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["1F49E"],
    emoji: "💞",
    name: "revolving hearts",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["1F495"],
    emoji: "💕",
    name: "two hearts",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["1F49F"],
    emoji: "💟",
    name: "heart decoration",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["2763"],
    emoji: "❣",
    name: "heart exclamation",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["1F494"],
    emoji: "💔",
    name: "broken heart",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["2764", "FE0F", "200D", "1F525"],
    emoji: "❤️‍🔥",
    name: "heart on fire",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["2764", "FE0F", "200D", "1FA79"],
    emoji: "❤️‍🩹",
    name: "mending heart",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["2764"],
    emoji: "❤",
    name: "red heart",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["1FA77"],
    emoji: "🩷",
    name: "pink heart",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["1F9E1"],
    emoji: "🧡",
    name: "orange heart",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["1F49B"],
    emoji: "💛",
    name: "yellow heart",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["1F49A"],
    emoji: "💚",
    name: "green heart",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["1F499"],
    emoji: "💙",
    name: "blue heart",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["1FA75"],
    emoji: "🩵",
    name: "light blue heart",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["1F49C"],
    emoji: "💜",
    name: "purple heart",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["1F90E"],
    emoji: "🤎",
    name: "brown heart",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["1F5A4"],
    emoji: "🖤",
    name: "black heart",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["1FA76"],
    emoji: "🩶",
    name: "grey heart",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["1F90D"],
    emoji: "🤍",
    name: "white heart",
    category: "Smileys & Emotion",
    subcategory: "heart",
  },
  {
    code: ["1F48B"],
    emoji: "💋",
    name: "kiss mark",
    category: "Smileys & Emotion",
    subcategory: "emotion",
  },
  {
    code: ["1F4AF"],
    emoji: "💯",
    name: "hundred points",
    category: "Smileys & Emotion",
    subcategory: "emotion",
  },
  {
    code: ["1F4A2"],
    emoji: "💢",
    name: "anger symbol",
    category: "Smileys & Emotion",
    subcategory: "emotion",
  },
  {
    code: ["1F4A5"],
    emoji: "💥",
    name: "collision",
    category: "Smileys & Emotion",
    subcategory: "emotion",
  },
  {
    code: ["1F4AB"],
    emoji: "💫",
    name: "dizzy",
    category: "Smileys & Emotion",
    subcategory: "emotion",
  },
  {
    code: ["1F4A6"],
    emoji: "💦",
    name: "sweat droplets",
    category: "Smileys & Emotion",
    subcategory: "emotion",
  },
  {
    code: ["1F4A8"],
    emoji: "💨",
    name: "dashing away",
    category: "Smileys & Emotion",
    subcategory: "emotion",
  },
  {
    code: ["1F573"],
    emoji: "🕳",
    name: "hole",
    category: "Smileys & Emotion",
    subcategory: "emotion",
  },
  {
    code: ["1F4AC"],
    emoji: "💬",
    name: "speech balloon",
    category: "Smileys & Emotion",
    subcategory: "emotion",
  },
  {
    code: ["1F441", "FE0F", "200D", "1F5E8", "FE0F"],
    emoji: "👁️‍🗨️",
    name: "eye in speech bubble",
    category: "Smileys & Emotion",
    subcategory: "emotion",
  },
  {
    code: ["1F5E8"],
    emoji: "🗨",
    name: "left speech bubble",
    category: "Smileys & Emotion",
    subcategory: "emotion",
  },
  {
    code: ["1F5EF"],
    emoji: "🗯",
    name: "right anger bubble",
    category: "Smileys & Emotion",
    subcategory: "emotion",
  },
  {
    code: ["1F4AD"],
    emoji: "💭",
    name: "thought balloon",
    category: "Smileys & Emotion",
    subcategory: "emotion",
  },
  {
    code: ["1F4A4"],
    emoji: "💤",
    name: "ZZZ",
    category: "Smileys & Emotion",
    subcategory: "emotion",
  },
  {
    code: ["1F44B"],
    emoji: "👋",
    name: "waving hand",
    category: "People & Body",
    subcategory: "hand-fingers-open",
  },
  {
    code: ["1F91A"],
    emoji: "🤚",
    name: "raised back of hand",
    category: "People & Body",
    subcategory: "hand-fingers-open",
  },
  {
    code: ["1F590"],
    emoji: "🖐",
    name: "hand with fingers splayed",
    category: "People & Body",
    subcategory: "hand-fingers-open",
  },
  {
    code: ["270B"],
    emoji: "✋",
    name: "raised hand",
    category: "People & Body",
    subcategory: "hand-fingers-open",
  },
  {
    code: ["1F596"],
    emoji: "🖖",
    name: "vulcan salute",
    category: "People & Body",
    subcategory: "hand-fingers-open",
  },
  {
    code: ["1FAF1"],
    emoji: "🫱",
    name: "rightwards hand",
    category: "People & Body",
    subcategory: "hand-fingers-open",
  },
  {
    code: ["1FAF2"],
    emoji: "🫲",
    name: "leftwards hand",
    category: "People & Body",
    subcategory: "hand-fingers-open",
  },
  {
    code: ["1FAF3"],
    emoji: "🫳",
    name: "palm down hand",
    category: "People & Body",
    subcategory: "hand-fingers-open",
  },
  {
    code: ["1FAF4"],
    emoji: "🫴",
    name: "palm up hand",
    category: "People & Body",
    subcategory: "hand-fingers-open",
  },
  {
    code: ["1FAF7"],
    emoji: "🫷",
    name: "leftwards pushing hand",
    category: "People & Body",
    subcategory: "hand-fingers-open",
  },
  {
    code: ["1FAF8"],
    emoji: "🫸",
    name: "rightwards pushing hand",
    category: "People & Body",
    subcategory: "hand-fingers-open",
  },
  {
    code: ["1F44C"],
    emoji: "👌",
    name: "OK hand",
    category: "People & Body",
    subcategory: "hand-fingers-partial",
  },
  {
    code: ["1F90C"],
    emoji: "🤌",
    name: "pinched fingers",
    category: "People & Body",
    subcategory: "hand-fingers-partial",
  },
  {
    code: ["1F90F"],
    emoji: "🤏",
    name: "pinching hand",
    category: "People & Body",
    subcategory: "hand-fingers-partial",
  },
  {
    code: ["270C"],
    emoji: "✌",
    name: "victory hand",
    category: "People & Body",
    subcategory: "hand-fingers-partial",
  },
  {
    code: ["1F91E"],
    emoji: "🤞",
    name: "crossed fingers",
    category: "People & Body",
    subcategory: "hand-fingers-partial",
  },
  {
    code: ["1FAF0"],
    emoji: "🫰",
    name: "hand with index finger and thumb crossed",
    category: "People & Body",
    subcategory: "hand-fingers-partial",
  },
  {
    code: ["1F91F"],
    emoji: "🤟",
    name: "love-you gesture",
    category: "People & Body",
    subcategory: "hand-fingers-partial",
  },
  {
    code: ["1F918"],
    emoji: "🤘",
    name: "sign of the horns",
    category: "People & Body",
    subcategory: "hand-fingers-partial",
  },
  {
    code: ["1F919"],
    emoji: "🤙",
    name: "call me hand",
    category: "People & Body",
    subcategory: "hand-fingers-partial",
  },
  {
    code: ["1F448"],
    emoji: "👈",
    name: "backhand index pointing left",
    category: "People & Body",
    subcategory: "hand-single-finger",
  },
  {
    code: ["1F449"],
    emoji: "👉",
    name: "backhand index pointing right",
    category: "People & Body",
    subcategory: "hand-single-finger",
  },
  {
    code: ["1F446"],
    emoji: "👆",
    name: "backhand index pointing up",
    category: "People & Body",
    subcategory: "hand-single-finger",
  },
  {
    code: ["1F595"],
    emoji: "🖕",
    name: "middle finger",
    category: "People & Body",
    subcategory: "hand-single-finger",
  },
  {
    code: ["1F447"],
    emoji: "👇",
    name: "backhand index pointing down",
    category: "People & Body",
    subcategory: "hand-single-finger",
  },
  {
    code: ["261D"],
    emoji: "☝",
    name: "index pointing up",
    category: "People & Body",
    subcategory: "hand-single-finger",
  },
  {
    code: ["1FAF5"],
    emoji: "🫵",
    name: "index pointing at the viewer",
    category: "People & Body",
    subcategory: "hand-single-finger",
  },
  {
    code: ["1F44D"],
    emoji: "👍",
    name: "thumbs up",
    category: "People & Body",
    subcategory: "hand-fingers-closed",
  },
  {
    code: ["1F44E"],
    emoji: "👎",
    name: "thumbs down",
    category: "People & Body",
    subcategory: "hand-fingers-closed",
  },
  {
    code: ["270A"],
    emoji: "✊",
    name: "raised fist",
    category: "People & Body",
    subcategory: "hand-fingers-closed",
  },
  {
    code: ["1F44A"],
    emoji: "👊",
    name: "oncoming fist",
    category: "People & Body",
    subcategory: "hand-fingers-closed",
  },
  {
    code: ["1F91B"],
    emoji: "🤛",
    name: "left-facing fist",
    category: "People & Body",
    subcategory: "hand-fingers-closed",
  },
  {
    code: ["1F91C"],
    emoji: "🤜",
    name: "right-facing fist",
    category: "People & Body",
    subcategory: "hand-fingers-closed",
  },
  {
    code: ["1F44F"],
    emoji: "👏",
    name: "clapping hands",
    category: "People & Body",
    subcategory: "hands",
  },
  {
    code: ["1F64C"],
    emoji: "🙌",
    name: "raising hands",
    category: "People & Body",
    subcategory: "hands",
  },
  {
    code: ["1FAF6"],
    emoji: "🫶",
    name: "heart hands",
    category: "People & Body",
    subcategory: "hands",
  },
  {
    code: ["1F450"],
    emoji: "👐",
    name: "open hands",
    category: "People & Body",
    subcategory: "hands",
  },
  {
    code: ["1F932"],
    emoji: "🤲",
    name: "palms up together",
    category: "People & Body",
    subcategory: "hands",
  },
  {
    code: ["1F91D"],
    emoji: "🤝",
    name: "handshake",
    category: "People & Body",
    subcategory: "hands",
  },
  {
    code: ["1F64F"],
    emoji: "🙏",
    name: "folded hands",
    category: "People & Body",
    subcategory: "hands",
  },
  {
    code: ["270D"],
    emoji: "✍",
    name: "writing hand",
    category: "People & Body",
    subcategory: "hand-prop",
  },
  {
    code: ["1F485"],
    emoji: "💅",
    name: "nail polish",
    category: "People & Body",
    subcategory: "hand-prop",
  },
  {
    code: ["1F933"],
    emoji: "🤳",
    name: "selfie",
    category: "People & Body",
    subcategory: "hand-prop",
  },
  {
    code: ["1F4AA"],
    emoji: "💪",
    name: "flexed biceps",
    category: "People & Body",
    subcategory: "body-parts",
  },
  {
    code: ["1F9BE"],
    emoji: "🦾",
    name: "mechanical arm",
    category: "People & Body",
    subcategory: "body-parts",
  },
  {
    code: ["1F9BF"],
    emoji: "🦿",
    name: "mechanical leg",
    category: "People & Body",
    subcategory: "body-parts",
  },
  {
    code: ["1F9B5"],
    emoji: "🦵",
    name: "leg",
    category: "People & Body",
    subcategory: "body-parts",
  },
  {
    code: ["1F9B6"],
    emoji: "🦶",
    name: "foot",
    category: "People & Body",
    subcategory: "body-parts",
  },
  {
    code: ["1F442"],
    emoji: "👂",
    name: "ear",
    category: "People & Body",
    subcategory: "body-parts",
  },
  {
    code: ["1F9BB"],
    emoji: "🦻",
    name: "ear with hearing aid",
    category: "People & Body",
    subcategory: "body-parts",
  },
  {
    code: ["1F443"],
    emoji: "👃",
    name: "nose",
    category: "People & Body",
    subcategory: "body-parts",
  },
  {
    code: ["1F9E0"],
    emoji: "🧠",
    name: "brain",
    category: "People & Body",
    subcategory: "body-parts",
  },
  {
    code: ["1FAC0"],
    emoji: "🫀",
    name: "anatomical heart",
    category: "People & Body",
    subcategory: "body-parts",
  },
  {
    code: ["1FAC1"],
    emoji: "🫁",
    name: "lungs",
    category: "People & Body",
    subcategory: "body-parts",
  },
  {
    code: ["1F9B7"],
    emoji: "🦷",
    name: "tooth",
    category: "People & Body",
    subcategory: "body-parts",
  },
  {
    code: ["1F9B4"],
    emoji: "🦴",
    name: "bone",
    category: "People & Body",
    subcategory: "body-parts",
  },
  {
    code: ["1F440"],
    emoji: "👀",
    name: "eyes",
    category: "People & Body",
    subcategory: "body-parts",
  },
  {
    code: ["1F441"],
    emoji: "👁",
    name: "eye",
    category: "People & Body",
    subcategory: "body-parts",
  },
  {
    code: ["1F445"],
    emoji: "👅",
    name: "tongue",
    category: "People & Body",
    subcategory: "body-parts",
  },
  {
    code: ["1F444"],
    emoji: "👄",
    name: "mouth",
    category: "People & Body",
    subcategory: "body-parts",
  },
  {
    code: ["1FAE6"],
    emoji: "🫦",
    name: "biting lip",
    category: "People & Body",
    subcategory: "body-parts",
  },
  {
    code: ["1F476"],
    emoji: "👶",
    name: "baby",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F9D2"],
    emoji: "🧒",
    name: "child",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F466"],
    emoji: "👦",
    name: "boy",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F467"],
    emoji: "👧",
    name: "girl",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F9D1"],
    emoji: "🧑",
    name: "person",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F471"],
    emoji: "👱",
    name: "person: blond hair",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F468"],
    emoji: "👨",
    name: "man",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F9D4"],
    emoji: "🧔",
    name: "person: beard",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F9D4", "200D", "2642", "FE0F"],
    emoji: "🧔‍♂️",
    name: "man: beard",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F9D4", "200D", "2640", "FE0F"],
    emoji: "🧔‍♀️",
    name: "woman: beard",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F468", "200D", "1F9B0"],
    emoji: "👨‍🦰",
    name: "man: red hair",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F468", "200D", "1F9B1"],
    emoji: "👨‍🦱",
    name: "man: curly hair",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F468", "200D", "1F9B3"],
    emoji: "👨‍🦳",
    name: "man: white hair",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F468", "200D", "1F9B2"],
    emoji: "👨‍🦲",
    name: "man: bald",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F469"],
    emoji: "👩",
    name: "woman",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F469", "200D", "1F9B0"],
    emoji: "👩‍🦰",
    name: "woman: red hair",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F9D1", "200D", "1F9B0"],
    emoji: "🧑‍🦰",
    name: "person: red hair",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F469", "200D", "1F9B1"],
    emoji: "👩‍🦱",
    name: "woman: curly hair",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F9D1", "200D", "1F9B1"],
    emoji: "🧑‍🦱",
    name: "person: curly hair",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F469", "200D", "1F9B3"],
    emoji: "👩‍🦳",
    name: "woman: white hair",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F9D1", "200D", "1F9B3"],
    emoji: "🧑‍🦳",
    name: "person: white hair",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F469", "200D", "1F9B2"],
    emoji: "👩‍🦲",
    name: "woman: bald",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F9D1", "200D", "1F9B2"],
    emoji: "🧑‍🦲",
    name: "person: bald",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F471", "200D", "2640", "FE0F"],
    emoji: "👱‍♀️",
    name: "woman: blond hair",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F471", "200D", "2642", "FE0F"],
    emoji: "👱‍♂️",
    name: "man: blond hair",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F9D3"],
    emoji: "🧓",
    name: "older person",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F474"],
    emoji: "👴",
    name: "old man",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F475"],
    emoji: "👵",
    name: "old woman",
    category: "People & Body",
    subcategory: "person",
  },
  {
    code: ["1F64D"],
    emoji: "🙍",
    name: "person frowning",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F64D", "200D", "2642", "FE0F"],
    emoji: "🙍‍♂️",
    name: "man frowning",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F64D", "200D", "2640", "FE0F"],
    emoji: "🙍‍♀️",
    name: "woman frowning",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F64E"],
    emoji: "🙎",
    name: "person pouting",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F64E", "200D", "2642", "FE0F"],
    emoji: "🙎‍♂️",
    name: "man pouting",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F64E", "200D", "2640", "FE0F"],
    emoji: "🙎‍♀️",
    name: "woman pouting",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F645"],
    emoji: "🙅",
    name: "person gesturing NO",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F645", "200D", "2642", "FE0F"],
    emoji: "🙅‍♂️",
    name: "man gesturing NO",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F645", "200D", "2640", "FE0F"],
    emoji: "🙅‍♀️",
    name: "woman gesturing NO",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F646"],
    emoji: "🙆",
    name: "person gesturing OK",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F646", "200D", "2642", "FE0F"],
    emoji: "🙆‍♂️",
    name: "man gesturing OK",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F646", "200D", "2640", "FE0F"],
    emoji: "🙆‍♀️",
    name: "woman gesturing OK",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F481"],
    emoji: "💁",
    name: "person tipping hand",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F481", "200D", "2642", "FE0F"],
    emoji: "💁‍♂️",
    name: "man tipping hand",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F481", "200D", "2640", "FE0F"],
    emoji: "💁‍♀️",
    name: "woman tipping hand",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F64B"],
    emoji: "🙋",
    name: "person raising hand",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F64B", "200D", "2642", "FE0F"],
    emoji: "🙋‍♂️",
    name: "man raising hand",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F64B", "200D", "2640", "FE0F"],
    emoji: "🙋‍♀️",
    name: "woman raising hand",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F9CF"],
    emoji: "🧏",
    name: "deaf person",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F9CF", "200D", "2642", "FE0F"],
    emoji: "🧏‍♂️",
    name: "deaf man",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F9CF", "200D", "2640", "FE0F"],
    emoji: "🧏‍♀️",
    name: "deaf woman",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F647"],
    emoji: "🙇",
    name: "person bowing",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F647", "200D", "2642", "FE0F"],
    emoji: "🙇‍♂️",
    name: "man bowing",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F647", "200D", "2640", "FE0F"],
    emoji: "🙇‍♀️",
    name: "woman bowing",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F926"],
    emoji: "🤦",
    name: "person facepalming",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F926", "200D", "2642", "FE0F"],
    emoji: "🤦‍♂️",
    name: "man facepalming",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F926", "200D", "2640", "FE0F"],
    emoji: "🤦‍♀️",
    name: "woman facepalming",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F937"],
    emoji: "🤷",
    name: "person shrugging",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F937", "200D", "2642", "FE0F"],
    emoji: "🤷‍♂️",
    name: "man shrugging",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F937", "200D", "2640", "FE0F"],
    emoji: "🤷‍♀️",
    name: "woman shrugging",
    category: "People & Body",
    subcategory: "person-gesture",
  },
  {
    code: ["1F9D1", "200D", "2695", "FE0F"],
    emoji: "🧑‍⚕️",
    name: "health worker",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F468", "200D", "2695", "FE0F"],
    emoji: "👨‍⚕️",
    name: "man health worker",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F469", "200D", "2695", "FE0F"],
    emoji: "👩‍⚕️",
    name: "woman health worker",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F9D1", "200D", "1F393"],
    emoji: "🧑‍🎓",
    name: "student",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F468", "200D", "1F393"],
    emoji: "👨‍🎓",
    name: "man student",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F469", "200D", "1F393"],
    emoji: "👩‍🎓",
    name: "woman student",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F9D1", "200D", "1F3EB"],
    emoji: "🧑‍🏫",
    name: "teacher",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F468", "200D", "1F3EB"],
    emoji: "👨‍🏫",
    name: "man teacher",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F469", "200D", "1F3EB"],
    emoji: "👩‍🏫",
    name: "woman teacher",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F9D1", "200D", "2696", "FE0F"],
    emoji: "🧑‍⚖️",
    name: "judge",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F468", "200D", "2696", "FE0F"],
    emoji: "👨‍⚖️",
    name: "man judge",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F469", "200D", "2696", "FE0F"],
    emoji: "👩‍⚖️",
    name: "woman judge",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F9D1", "200D", "1F33E"],
    emoji: "🧑‍🌾",
    name: "farmer",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F468", "200D", "1F33E"],
    emoji: "👨‍🌾",
    name: "man farmer",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F469", "200D", "1F33E"],
    emoji: "👩‍🌾",
    name: "woman farmer",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F9D1", "200D", "1F373"],
    emoji: "🧑‍🍳",
    name: "cook",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F468", "200D", "1F373"],
    emoji: "👨‍🍳",
    name: "man cook",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F469", "200D", "1F373"],
    emoji: "👩‍🍳",
    name: "woman cook",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F9D1", "200D", "1F527"],
    emoji: "🧑‍🔧",
    name: "mechanic",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F468", "200D", "1F527"],
    emoji: "👨‍🔧",
    name: "man mechanic",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F469", "200D", "1F527"],
    emoji: "👩‍🔧",
    name: "woman mechanic",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F9D1", "200D", "1F3ED"],
    emoji: "🧑‍🏭",
    name: "factory worker",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F468", "200D", "1F3ED"],
    emoji: "👨‍🏭",
    name: "man factory worker",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F469", "200D", "1F3ED"],
    emoji: "👩‍🏭",
    name: "woman factory worker",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F9D1", "200D", "1F4BC"],
    emoji: "🧑‍💼",
    name: "office worker",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F468", "200D", "1F4BC"],
    emoji: "👨‍💼",
    name: "man office worker",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F469", "200D", "1F4BC"],
    emoji: "👩‍💼",
    name: "woman office worker",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F9D1", "200D", "1F52C"],
    emoji: "🧑‍🔬",
    name: "scientist",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F468", "200D", "1F52C"],
    emoji: "👨‍🔬",
    name: "man scientist",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F469", "200D", "1F52C"],
    emoji: "👩‍🔬",
    name: "woman scientist",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F9D1", "200D", "1F4BB"],
    emoji: "🧑‍💻",
    name: "technologist",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F468", "200D", "1F4BB"],
    emoji: "👨‍💻",
    name: "man technologist",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F469", "200D", "1F4BB"],
    emoji: "👩‍💻",
    name: "woman technologist",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F9D1", "200D", "1F3A4"],
    emoji: "🧑‍🎤",
    name: "singer",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F468", "200D", "1F3A4"],
    emoji: "👨‍🎤",
    name: "man singer",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F469", "200D", "1F3A4"],
    emoji: "👩‍🎤",
    name: "woman singer",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F9D1", "200D", "1F3A8"],
    emoji: "🧑‍🎨",
    name: "artist",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F468", "200D", "1F3A8"],
    emoji: "👨‍🎨",
    name: "man artist",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F469", "200D", "1F3A8"],
    emoji: "👩‍🎨",
    name: "woman artist",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F9D1", "200D", "2708", "FE0F"],
    emoji: "🧑‍✈️",
    name: "pilot",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F468", "200D", "2708", "FE0F"],
    emoji: "👨‍✈️",
    name: "man pilot",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F469", "200D", "2708", "FE0F"],
    emoji: "👩‍✈️",
    name: "woman pilot",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F9D1", "200D", "1F680"],
    emoji: "🧑‍🚀",
    name: "astronaut",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F468", "200D", "1F680"],
    emoji: "👨‍🚀",
    name: "man astronaut",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F469", "200D", "1F680"],
    emoji: "👩‍🚀",
    name: "woman astronaut",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F9D1", "200D", "1F692"],
    emoji: "🧑‍🚒",
    name: "firefighter",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F468", "200D", "1F692"],
    emoji: "👨‍🚒",
    name: "man firefighter",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F469", "200D", "1F692"],
    emoji: "👩‍🚒",
    name: "woman firefighter",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F46E"],
    emoji: "👮",
    name: "police officer",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F46E", "200D", "2642", "FE0F"],
    emoji: "👮‍♂️",
    name: "man police officer",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F46E", "200D", "2640", "FE0F"],
    emoji: "👮‍♀️",
    name: "woman police officer",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F575"],
    emoji: "🕵",
    name: "detective",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F575", "FE0F", "200D", "2642", "FE0F"],
    emoji: "🕵️‍♂️",
    name: "man detective",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F575", "FE0F", "200D", "2640", "FE0F"],
    emoji: "🕵️‍♀️",
    name: "woman detective",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F482"],
    emoji: "💂",
    name: "guard",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F482", "200D", "2642", "FE0F"],
    emoji: "💂‍♂️",
    name: "man guard",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F482", "200D", "2640", "FE0F"],
    emoji: "💂‍♀️",
    name: "woman guard",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F977"],
    emoji: "🥷",
    name: "ninja",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F477"],
    emoji: "👷",
    name: "construction worker",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F477", "200D", "2642", "FE0F"],
    emoji: "👷‍♂️",
    name: "man construction worker",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F477", "200D", "2640", "FE0F"],
    emoji: "👷‍♀️",
    name: "woman construction worker",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1FAC5"],
    emoji: "🫅",
    name: "person with crown",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F934"],
    emoji: "🤴",
    name: "prince",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F478"],
    emoji: "👸",
    name: "princess",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F473"],
    emoji: "👳",
    name: "person wearing turban",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F473", "200D", "2642", "FE0F"],
    emoji: "👳‍♂️",
    name: "man wearing turban",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F473", "200D", "2640", "FE0F"],
    emoji: "👳‍♀️",
    name: "woman wearing turban",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F472"],
    emoji: "👲",
    name: "person with skullcap",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F9D5"],
    emoji: "🧕",
    name: "woman with headscarf",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F935"],
    emoji: "🤵",
    name: "person in tuxedo",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F935", "200D", "2642", "FE0F"],
    emoji: "🤵‍♂️",
    name: "man in tuxedo",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F935", "200D", "2640", "FE0F"],
    emoji: "🤵‍♀️",
    name: "woman in tuxedo",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F470"],
    emoji: "👰",
    name: "person with veil",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F470", "200D", "2642", "FE0F"],
    emoji: "👰‍♂️",
    name: "man with veil",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F470", "200D", "2640", "FE0F"],
    emoji: "👰‍♀️",
    name: "woman with veil",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F930"],
    emoji: "🤰",
    name: "pregnant woman",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1FAC3"],
    emoji: "🫃",
    name: "pregnant man",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1FAC4"],
    emoji: "🫄",
    name: "pregnant person",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F931"],
    emoji: "🤱",
    name: "breast-feeding",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F469", "200D", "1F37C"],
    emoji: "👩‍🍼",
    name: "woman feeding baby",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F468", "200D", "1F37C"],
    emoji: "👨‍🍼",
    name: "man feeding baby",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F9D1", "200D", "1F37C"],
    emoji: "🧑‍🍼",
    name: "person feeding baby",
    category: "People & Body",
    subcategory: "person-role",
  },
  {
    code: ["1F47C"],
    emoji: "👼",
    name: "baby angel",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F385"],
    emoji: "🎅",
    name: "Santa Claus",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F936"],
    emoji: "🤶",
    name: "Mrs. Claus",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9D1", "200D", "1F384"],
    emoji: "🧑‍🎄",
    name: "Mx Claus",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9B8"],
    emoji: "🦸",
    name: "superhero",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9B8", "200D", "2642", "FE0F"],
    emoji: "🦸‍♂️",
    name: "man superhero",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9B8", "200D", "2640", "FE0F"],
    emoji: "🦸‍♀️",
    name: "woman superhero",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9B9"],
    emoji: "🦹",
    name: "supervillain",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9B9", "200D", "2642", "FE0F"],
    emoji: "🦹‍♂️",
    name: "man supervillain",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9B9", "200D", "2640", "FE0F"],
    emoji: "🦹‍♀️",
    name: "woman supervillain",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9D9"],
    emoji: "🧙",
    name: "mage",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9D9", "200D", "2642", "FE0F"],
    emoji: "🧙‍♂️",
    name: "man mage",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9D9", "200D", "2640", "FE0F"],
    emoji: "🧙‍♀️",
    name: "woman mage",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9DA"],
    emoji: "🧚",
    name: "fairy",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9DA", "200D", "2642", "FE0F"],
    emoji: "🧚‍♂️",
    name: "man fairy",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9DA", "200D", "2640", "FE0F"],
    emoji: "🧚‍♀️",
    name: "woman fairy",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9DB"],
    emoji: "🧛",
    name: "vampire",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9DB", "200D", "2642", "FE0F"],
    emoji: "🧛‍♂️",
    name: "man vampire",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9DB", "200D", "2640", "FE0F"],
    emoji: "🧛‍♀️",
    name: "woman vampire",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9DC"],
    emoji: "🧜",
    name: "merperson",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9DC", "200D", "2642", "FE0F"],
    emoji: "🧜‍♂️",
    name: "merman",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9DC", "200D", "2640", "FE0F"],
    emoji: "🧜‍♀️",
    name: "mermaid",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9DD"],
    emoji: "🧝",
    name: "elf",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9DD", "200D", "2642", "FE0F"],
    emoji: "🧝‍♂️",
    name: "man elf",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9DD", "200D", "2640", "FE0F"],
    emoji: "🧝‍♀️",
    name: "woman elf",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9DE"],
    emoji: "🧞",
    name: "genie",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9DE", "200D", "2642", "FE0F"],
    emoji: "🧞‍♂️",
    name: "man genie",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9DE", "200D", "2640", "FE0F"],
    emoji: "🧞‍♀️",
    name: "woman genie",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9DF"],
    emoji: "🧟",
    name: "zombie",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9DF", "200D", "2642", "FE0F"],
    emoji: "🧟‍♂️",
    name: "man zombie",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9DF", "200D", "2640", "FE0F"],
    emoji: "🧟‍♀️",
    name: "woman zombie",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F9CC"],
    emoji: "🧌",
    name: "troll",
    category: "People & Body",
    subcategory: "person-fantasy",
  },
  {
    code: ["1F486"],
    emoji: "💆",
    name: "person getting massage",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F486", "200D", "2642", "FE0F"],
    emoji: "💆‍♂️",
    name: "man getting massage",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F486", "200D", "2640", "FE0F"],
    emoji: "💆‍♀️",
    name: "woman getting massage",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F487"],
    emoji: "💇",
    name: "person getting haircut",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F487", "200D", "2642", "FE0F"],
    emoji: "💇‍♂️",
    name: "man getting haircut",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F487", "200D", "2640", "FE0F"],
    emoji: "💇‍♀️",
    name: "woman getting haircut",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F6B6"],
    emoji: "🚶",
    name: "person walking",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F6B6", "200D", "2642", "FE0F"],
    emoji: "🚶‍♂️",
    name: "man walking",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F6B6", "200D", "2640", "FE0F"],
    emoji: "🚶‍♀️",
    name: "woman walking",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F6B6", "200D", "27A1", "FE0F"],
    emoji: "🚶‍➡️",
    name: "person walking facing right",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F6B6", "200D", "2640", "FE0F", "200D", "27A1", "FE0F"],
    emoji: "🚶‍♀️‍➡️",
    name: "woman walking facing right",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F6B6", "200D", "2642", "FE0F", "200D", "27A1", "FE0F"],
    emoji: "🚶‍♂️‍➡️",
    name: "man walking facing right",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F9CD"],
    emoji: "🧍",
    name: "person standing",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F9CD", "200D", "2642", "FE0F"],
    emoji: "🧍‍♂️",
    name: "man standing",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F9CD", "200D", "2640", "FE0F"],
    emoji: "🧍‍♀️",
    name: "woman standing",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F9CE"],
    emoji: "🧎",
    name: "person kneeling",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F9CE", "200D", "2642", "FE0F"],
    emoji: "🧎‍♂️",
    name: "man kneeling",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F9CE", "200D", "2640", "FE0F"],
    emoji: "🧎‍♀️",
    name: "woman kneeling",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F9CE", "200D", "27A1", "FE0F"],
    emoji: "🧎‍➡️",
    name: "person kneeling facing right",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F9CE", "200D", "2640", "FE0F", "200D", "27A1", "FE0F"],
    emoji: "🧎‍♀️‍➡️",
    name: "woman kneeling facing right",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F9CE", "200D", "2642", "FE0F", "200D", "27A1", "FE0F"],
    emoji: "🧎‍♂️‍➡️",
    name: "man kneeling facing right",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F9D1", "200D", "1F9AF"],
    emoji: "🧑‍🦯",
    name: "person with white cane",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F9D1", "200D", "1F9AF", "200D", "27A1", "FE0F"],
    emoji: "🧑‍🦯‍➡️",
    name: "person with white cane facing right",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F468", "200D", "1F9AF"],
    emoji: "👨‍🦯",
    name: "man with white cane",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F468", "200D", "1F9AF", "200D", "27A1", "FE0F"],
    emoji: "👨‍🦯‍➡️",
    name: "man with white cane facing right",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F469", "200D", "1F9AF"],
    emoji: "👩‍🦯",
    name: "woman with white cane",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F469", "200D", "1F9AF", "200D", "27A1", "FE0F"],
    emoji: "👩‍🦯‍➡️",
    name: "woman with white cane facing right",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F9D1", "200D", "1F9BC"],
    emoji: "🧑‍🦼",
    name: "person in motorized wheelchair",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F9D1", "200D", "1F9BC", "200D", "27A1", "FE0F"],
    emoji: "🧑‍🦼‍➡️",
    name: "person in motorized wheelchair facing right",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F468", "200D", "1F9BC"],
    emoji: "👨‍🦼",
    name: "man in motorized wheelchair",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F468", "200D", "1F9BC", "200D", "27A1", "FE0F"],
    emoji: "👨‍🦼‍➡️",
    name: "man in motorized wheelchair facing right",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F469", "200D", "1F9BC"],
    emoji: "👩‍🦼",
    name: "woman in motorized wheelchair",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F469", "200D", "1F9BC", "200D", "27A1", "FE0F"],
    emoji: "👩‍🦼‍➡️",
    name: "woman in motorized wheelchair facing right",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F9D1", "200D", "1F9BD"],
    emoji: "🧑‍🦽",
    name: "person in manual wheelchair",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F9D1", "200D", "1F9BD", "200D", "27A1", "FE0F"],
    emoji: "🧑‍🦽‍➡️",
    name: "person in manual wheelchair facing right",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F468", "200D", "1F9BD"],
    emoji: "👨‍🦽",
    name: "man in manual wheelchair",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F468", "200D", "1F9BD", "200D", "27A1", "FE0F"],
    emoji: "👨‍🦽‍➡️",
    name: "man in manual wheelchair facing right",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F469", "200D", "1F9BD"],
    emoji: "👩‍🦽",
    name: "woman in manual wheelchair",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F469", "200D", "1F9BD", "200D", "27A1", "FE0F"],
    emoji: "👩‍🦽‍➡️",
    name: "woman in manual wheelchair facing right",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F3C3"],
    emoji: "🏃",
    name: "person running",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F3C3", "200D", "2642", "FE0F"],
    emoji: "🏃‍♂️",
    name: "man running",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F3C3", "200D", "2640", "FE0F"],
    emoji: "🏃‍♀️",
    name: "woman running",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F3C3", "200D", "27A1", "FE0F"],
    emoji: "🏃‍➡️",
    name: "person running facing right",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F3C3", "200D", "2640", "FE0F", "200D", "27A1", "FE0F"],
    emoji: "🏃‍♀️‍➡️",
    name: "woman running facing right",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F3C3", "200D", "2642", "FE0F", "200D", "27A1", "FE0F"],
    emoji: "🏃‍♂️‍➡️",
    name: "man running facing right",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F483"],
    emoji: "💃",
    name: "woman dancing",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F57A"],
    emoji: "🕺",
    name: "man dancing",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F574"],
    emoji: "🕴",
    name: "person in suit levitating",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F46F"],
    emoji: "👯",
    name: "people with bunny ears",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F46F", "200D", "2642", "FE0F"],
    emoji: "👯‍♂️",
    name: "men with bunny ears",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F46F", "200D", "2640", "FE0F"],
    emoji: "👯‍♀️",
    name: "women with bunny ears",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F9D6"],
    emoji: "🧖",
    name: "person in steamy room",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F9D6", "200D", "2642", "FE0F"],
    emoji: "🧖‍♂️",
    name: "man in steamy room",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F9D6", "200D", "2640", "FE0F"],
    emoji: "🧖‍♀️",
    name: "woman in steamy room",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F9D7"],
    emoji: "🧗",
    name: "person climbing",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F9D7", "200D", "2642", "FE0F"],
    emoji: "🧗‍♂️",
    name: "man climbing",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F9D7", "200D", "2640", "FE0F"],
    emoji: "🧗‍♀️",
    name: "woman climbing",
    category: "People & Body",
    subcategory: "person-activity",
  },
  {
    code: ["1F93A"],
    emoji: "🤺",
    name: "person fencing",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F3C7"],
    emoji: "🏇",
    name: "horse racing",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["26F7"],
    emoji: "⛷",
    name: "skier",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F3C2"],
    emoji: "🏂",
    name: "snowboarder",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F3CC"],
    emoji: "🏌",
    name: "person golfing",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F3CC", "FE0F", "200D", "2642", "FE0F"],
    emoji: "🏌️‍♂️",
    name: "man golfing",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F3CC", "FE0F", "200D", "2640", "FE0F"],
    emoji: "🏌️‍♀️",
    name: "woman golfing",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F3C4"],
    emoji: "🏄",
    name: "person surfing",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F3C4", "200D", "2642", "FE0F"],
    emoji: "🏄‍♂️",
    name: "man surfing",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F3C4", "200D", "2640", "FE0F"],
    emoji: "🏄‍♀️",
    name: "woman surfing",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F6A3"],
    emoji: "🚣",
    name: "person rowing boat",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F6A3", "200D", "2642", "FE0F"],
    emoji: "🚣‍♂️",
    name: "man rowing boat",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F6A3", "200D", "2640", "FE0F"],
    emoji: "🚣‍♀️",
    name: "woman rowing boat",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F3CA"],
    emoji: "🏊",
    name: "person swimming",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F3CA", "200D", "2642", "FE0F"],
    emoji: "🏊‍♂️",
    name: "man swimming",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F3CA", "200D", "2640", "FE0F"],
    emoji: "🏊‍♀️",
    name: "woman swimming",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["26F9"],
    emoji: "⛹",
    name: "person bouncing ball",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["26F9", "FE0F", "200D", "2642", "FE0F"],
    emoji: "⛹️‍♂️",
    name: "man bouncing ball",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["26F9", "FE0F", "200D", "2640", "FE0F"],
    emoji: "⛹️‍♀️",
    name: "woman bouncing ball",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F3CB"],
    emoji: "🏋",
    name: "person lifting weights",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F3CB", "FE0F", "200D", "2642", "FE0F"],
    emoji: "🏋️‍♂️",
    name: "man lifting weights",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F3CB", "FE0F", "200D", "2640", "FE0F"],
    emoji: "🏋️‍♀️",
    name: "woman lifting weights",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F6B4"],
    emoji: "🚴",
    name: "person biking",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F6B4", "200D", "2642", "FE0F"],
    emoji: "🚴‍♂️",
    name: "man biking",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F6B4", "200D", "2640", "FE0F"],
    emoji: "🚴‍♀️",
    name: "woman biking",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F6B5"],
    emoji: "🚵",
    name: "person mountain biking",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F6B5", "200D", "2642", "FE0F"],
    emoji: "🚵‍♂️",
    name: "man mountain biking",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F6B5", "200D", "2640", "FE0F"],
    emoji: "🚵‍♀️",
    name: "woman mountain biking",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F938"],
    emoji: "🤸",
    name: "person cartwheeling",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F938", "200D", "2642", "FE0F"],
    emoji: "🤸‍♂️",
    name: "man cartwheeling",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F938", "200D", "2640", "FE0F"],
    emoji: "🤸‍♀️",
    name: "woman cartwheeling",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F93C"],
    emoji: "🤼",
    name: "people wrestling",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F93C", "200D", "2642", "FE0F"],
    emoji: "🤼‍♂️",
    name: "men wrestling",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F93C", "200D", "2640", "FE0F"],
    emoji: "🤼‍♀️",
    name: "women wrestling",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F93D"],
    emoji: "🤽",
    name: "person playing water polo",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F93D", "200D", "2642", "FE0F"],
    emoji: "🤽‍♂️",
    name: "man playing water polo",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F93D", "200D", "2640", "FE0F"],
    emoji: "🤽‍♀️",
    name: "woman playing water polo",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F93E"],
    emoji: "🤾",
    name: "person playing handball",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F93E", "200D", "2642", "FE0F"],
    emoji: "🤾‍♂️",
    name: "man playing handball",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F93E", "200D", "2640", "FE0F"],
    emoji: "🤾‍♀️",
    name: "woman playing handball",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F939"],
    emoji: "🤹",
    name: "person juggling",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F939", "200D", "2642", "FE0F"],
    emoji: "🤹‍♂️",
    name: "man juggling",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F939", "200D", "2640", "FE0F"],
    emoji: "🤹‍♀️",
    name: "woman juggling",
    category: "People & Body",
    subcategory: "person-sport",
  },
  {
    code: ["1F9D8"],
    emoji: "🧘",
    name: "person in lotus position",
    category: "People & Body",
    subcategory: "person-resting",
  },
  {
    code: ["1F9D8", "200D", "2642", "FE0F"],
    emoji: "🧘‍♂️",
    name: "man in lotus position",
    category: "People & Body",
    subcategory: "person-resting",
  },
  {
    code: ["1F9D8", "200D", "2640", "FE0F"],
    emoji: "🧘‍♀️",
    name: "woman in lotus position",
    category: "People & Body",
    subcategory: "person-resting",
  },
  {
    code: ["1F6C0"],
    emoji: "🛀",
    name: "person taking bath",
    category: "People & Body",
    subcategory: "person-resting",
  },
  {
    code: ["1F6CC"],
    emoji: "🛌",
    name: "person in bed",
    category: "People & Body",
    subcategory: "person-resting",
  },
  {
    code: ["1F9D1", "200D", "1F91D", "200D", "1F9D1"],
    emoji: "🧑‍🤝‍🧑",
    name: "people holding hands",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F46D"],
    emoji: "👭",
    name: "women holding hands",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F46B"],
    emoji: "👫",
    name: "woman and man holding hands",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F46C"],
    emoji: "👬",
    name: "men holding hands",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F48F"],
    emoji: "💏",
    name: "kiss",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F469", "200D", "2764", "FE0F", "200D", "1F48B", "200D", "1F468"],
    emoji: "👩‍❤️‍💋‍👨",
    name: "kiss: woman, man",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F468", "200D", "2764", "FE0F", "200D", "1F48B", "200D", "1F468"],
    emoji: "👨‍❤️‍💋‍👨",
    name: "kiss: man, man",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F469", "200D", "2764", "FE0F", "200D", "1F48B", "200D", "1F469"],
    emoji: "👩‍❤️‍💋‍👩",
    name: "kiss: woman, woman",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F491"],
    emoji: "💑",
    name: "couple with heart",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F469", "200D", "2764", "FE0F", "200D", "1F468"],
    emoji: "👩‍❤️‍👨",
    name: "couple with heart: woman, man",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F468", "200D", "2764", "FE0F", "200D", "1F468"],
    emoji: "👨‍❤️‍👨",
    name: "couple with heart: man, man",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F469", "200D", "2764", "FE0F", "200D", "1F469"],
    emoji: "👩‍❤️‍👩",
    name: "couple with heart: woman, woman",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F468", "200D", "1F469", "200D", "1F466"],
    emoji: "👨‍👩‍👦",
    name: "family: man, woman, boy",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F468", "200D", "1F469", "200D", "1F467"],
    emoji: "👨‍👩‍👧",
    name: "family: man, woman, girl",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F468", "200D", "1F469", "200D", "1F467", "200D", "1F466"],
    emoji: "👨‍👩‍👧‍👦",
    name: "family: man, woman, girl, boy",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F468", "200D", "1F469", "200D", "1F466", "200D", "1F466"],
    emoji: "👨‍👩‍👦‍👦",
    name: "family: man, woman, boy, boy",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F468", "200D", "1F469", "200D", "1F467", "200D", "1F467"],
    emoji: "👨‍👩‍👧‍👧",
    name: "family: man, woman, girl, girl",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F468", "200D", "1F468", "200D", "1F466"],
    emoji: "👨‍👨‍👦",
    name: "family: man, man, boy",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F468", "200D", "1F468", "200D", "1F467"],
    emoji: "👨‍👨‍👧",
    name: "family: man, man, girl",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F468", "200D", "1F468", "200D", "1F467", "200D", "1F466"],
    emoji: "👨‍👨‍👧‍👦",
    name: "family: man, man, girl, boy",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F468", "200D", "1F468", "200D", "1F466", "200D", "1F466"],
    emoji: "👨‍👨‍👦‍👦",
    name: "family: man, man, boy, boy",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F468", "200D", "1F468", "200D", "1F467", "200D", "1F467"],
    emoji: "👨‍👨‍👧‍👧",
    name: "family: man, man, girl, girl",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F469", "200D", "1F469", "200D", "1F466"],
    emoji: "👩‍👩‍👦",
    name: "family: woman, woman, boy",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F469", "200D", "1F469", "200D", "1F467"],
    emoji: "👩‍👩‍👧",
    name: "family: woman, woman, girl",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F469", "200D", "1F469", "200D", "1F467", "200D", "1F466"],
    emoji: "👩‍👩‍👧‍👦",
    name: "family: woman, woman, girl, boy",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F469", "200D", "1F469", "200D", "1F466", "200D", "1F466"],
    emoji: "👩‍👩‍👦‍👦",
    name: "family: woman, woman, boy, boy",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F469", "200D", "1F469", "200D", "1F467", "200D", "1F467"],
    emoji: "👩‍👩‍👧‍👧",
    name: "family: woman, woman, girl, girl",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F468", "200D", "1F466"],
    emoji: "👨‍👦",
    name: "family: man, boy",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F468", "200D", "1F466", "200D", "1F466"],
    emoji: "👨‍👦‍👦",
    name: "family: man, boy, boy",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F468", "200D", "1F467"],
    emoji: "👨‍👧",
    name: "family: man, girl",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F468", "200D", "1F467", "200D", "1F466"],
    emoji: "👨‍👧‍👦",
    name: "family: man, girl, boy",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F468", "200D", "1F467", "200D", "1F467"],
    emoji: "👨‍👧‍👧",
    name: "family: man, girl, girl",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F469", "200D", "1F466"],
    emoji: "👩‍👦",
    name: "family: woman, boy",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F469", "200D", "1F466", "200D", "1F466"],
    emoji: "👩‍👦‍👦",
    name: "family: woman, boy, boy",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F469", "200D", "1F467"],
    emoji: "👩‍👧",
    name: "family: woman, girl",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F469", "200D", "1F467", "200D", "1F466"],
    emoji: "👩‍👧‍👦",
    name: "family: woman, girl, boy",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F469", "200D", "1F467", "200D", "1F467"],
    emoji: "👩‍👧‍👧",
    name: "family: woman, girl, girl",
    category: "People & Body",
    subcategory: "family",
  },
  {
    code: ["1F5E3"],
    emoji: "🗣",
    name: "speaking head",
    category: "People & Body",
    subcategory: "person-symbol",
  },
  {
    code: ["1F464"],
    emoji: "👤",
    name: "bust in silhouette",
    category: "People & Body",
    subcategory: "person-symbol",
  },
  {
    code: ["1F465"],
    emoji: "👥",
    name: "busts in silhouette",
    category: "People & Body",
    subcategory: "person-symbol",
  },
  {
    code: ["1FAC2"],
    emoji: "🫂",
    name: "people hugging",
    category: "People & Body",
    subcategory: "person-symbol",
  },
  {
    code: ["1F46A"],
    emoji: "👪",
    name: "family",
    category: "People & Body",
    subcategory: "person-symbol",
  },
  {
    code: ["1F9D1", "200D", "1F9D1", "200D", "1F9D2"],
    emoji: "🧑‍🧑‍🧒",
    name: "family: adult, adult, child",
    category: "People & Body",
    subcategory: "person-symbol",
  },
  {
    code: ["1F9D1", "200D", "1F9D1", "200D", "1F9D2", "200D", "1F9D2"],
    emoji: "🧑‍🧑‍🧒‍🧒",
    name: "family: adult, adult, child, child",
    category: "People & Body",
    subcategory: "person-symbol",
  },
  {
    code: ["1F9D1", "200D", "1F9D2"],
    emoji: "🧑‍🧒",
    name: "family: adult, child",
    category: "People & Body",
    subcategory: "person-symbol",
  },
  {
    code: ["1F9D1", "200D", "1F9D2", "200D", "1F9D2"],
    emoji: "🧑‍🧒‍🧒",
    name: "family: adult, child, child",
    category: "People & Body",
    subcategory: "person-symbol",
  },
  {
    code: ["1F463"],
    emoji: "👣",
    name: "footprints",
    category: "People & Body",
    subcategory: "person-symbol",
  },
  {
    code: ["1FAC6"],
    emoji: "🫆",
    name: "fingerprint",
    category: "People & Body",
    subcategory: "person-symbol",
  },
  {
    code: ["1F9B0"],
    emoji: "🦰",
    name: "red hair",
    category: "Component",
    subcategory: "hair-style",
  },
  {
    code: ["1F9B1"],
    emoji: "🦱",
    name: "curly hair",
    category: "Component",
    subcategory: "hair-style",
  },
  {
    code: ["1F9B3"],
    emoji: "🦳",
    name: "white hair",
    category: "Component",
    subcategory: "hair-style",
  },
  {
    code: ["1F9B2"],
    emoji: "🦲",
    name: "bald",
    category: "Component",
    subcategory: "hair-style",
  },
  {
    code: ["1F435"],
    emoji: "🐵",
    name: "monkey face",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F412"],
    emoji: "🐒",
    name: "monkey",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F98D"],
    emoji: "🦍",
    name: "gorilla",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F9A7"],
    emoji: "🦧",
    name: "orangutan",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F436"],
    emoji: "🐶",
    name: "dog face",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F415"],
    emoji: "🐕",
    name: "dog",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F9AE"],
    emoji: "🦮",
    name: "guide dog",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F415", "200D", "1F9BA"],
    emoji: "🐕‍🦺",
    name: "service dog",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F429"],
    emoji: "🐩",
    name: "poodle",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F43A"],
    emoji: "🐺",
    name: "wolf",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F98A"],
    emoji: "🦊",
    name: "fox",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F99D"],
    emoji: "🦝",
    name: "raccoon",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F431"],
    emoji: "🐱",
    name: "cat face",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F408"],
    emoji: "🐈",
    name: "cat",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F408", "200D", "2B1B"],
    emoji: "🐈‍⬛",
    name: "black cat",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F981"],
    emoji: "🦁",
    name: "lion",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F42F"],
    emoji: "🐯",
    name: "tiger face",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F405"],
    emoji: "🐅",
    name: "tiger",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F406"],
    emoji: "🐆",
    name: "leopard",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F434"],
    emoji: "🐴",
    name: "horse face",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1FACE"],
    emoji: "🫎",
    name: "moose",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1FACF"],
    emoji: "🫏",
    name: "donkey",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F40E"],
    emoji: "🐎",
    name: "horse",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F984"],
    emoji: "🦄",
    name: "unicorn",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F993"],
    emoji: "🦓",
    name: "zebra",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F98C"],
    emoji: "🦌",
    name: "deer",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F9AC"],
    emoji: "🦬",
    name: "bison",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F42E"],
    emoji: "🐮",
    name: "cow face",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F402"],
    emoji: "🐂",
    name: "ox",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F403"],
    emoji: "🐃",
    name: "water buffalo",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F404"],
    emoji: "🐄",
    name: "cow",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F437"],
    emoji: "🐷",
    name: "pig face",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F416"],
    emoji: "🐖",
    name: "pig",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F417"],
    emoji: "🐗",
    name: "boar",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F43D"],
    emoji: "🐽",
    name: "pig nose",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F40F"],
    emoji: "🐏",
    name: "ram",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F411"],
    emoji: "🐑",
    name: "ewe",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F410"],
    emoji: "🐐",
    name: "goat",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F42A"],
    emoji: "🐪",
    name: "camel",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F42B"],
    emoji: "🐫",
    name: "two-hump camel",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F999"],
    emoji: "🦙",
    name: "llama",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F992"],
    emoji: "🦒",
    name: "giraffe",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F418"],
    emoji: "🐘",
    name: "elephant",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F9A3"],
    emoji: "🦣",
    name: "mammoth",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F98F"],
    emoji: "🦏",
    name: "rhinoceros",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F99B"],
    emoji: "🦛",
    name: "hippopotamus",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F42D"],
    emoji: "🐭",
    name: "mouse face",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F401"],
    emoji: "🐁",
    name: "mouse",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F400"],
    emoji: "🐀",
    name: "rat",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F439"],
    emoji: "🐹",
    name: "hamster",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F430"],
    emoji: "🐰",
    name: "rabbit face",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F407"],
    emoji: "🐇",
    name: "rabbit",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F43F"],
    emoji: "🐿",
    name: "chipmunk",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F9AB"],
    emoji: "🦫",
    name: "beaver",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F994"],
    emoji: "🦔",
    name: "hedgehog",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F987"],
    emoji: "🦇",
    name: "bat",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F43B"],
    emoji: "🐻",
    name: "bear",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F43B", "200D", "2744", "FE0F"],
    emoji: "🐻‍❄️",
    name: "polar bear",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F428"],
    emoji: "🐨",
    name: "koala",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F43C"],
    emoji: "🐼",
    name: "panda",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F9A5"],
    emoji: "🦥",
    name: "sloth",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F9A6"],
    emoji: "🦦",
    name: "otter",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F9A8"],
    emoji: "🦨",
    name: "skunk",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F998"],
    emoji: "🦘",
    name: "kangaroo",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F9A1"],
    emoji: "🦡",
    name: "badger",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F43E"],
    emoji: "🐾",
    name: "paw prints",
    category: "Animals & Nature",
    subcategory: "animal-mammal",
  },
  {
    code: ["1F983"],
    emoji: "🦃",
    name: "turkey",
    category: "Animals & Nature",
    subcategory: "animal-bird",
  },
  {
    code: ["1F414"],
    emoji: "🐔",
    name: "chicken",
    category: "Animals & Nature",
    subcategory: "animal-bird",
  },
  {
    code: ["1F413"],
    emoji: "🐓",
    name: "rooster",
    category: "Animals & Nature",
    subcategory: "animal-bird",
  },
  {
    code: ["1F423"],
    emoji: "🐣",
    name: "hatching chick",
    category: "Animals & Nature",
    subcategory: "animal-bird",
  },
  {
    code: ["1F424"],
    emoji: "🐤",
    name: "baby chick",
    category: "Animals & Nature",
    subcategory: "animal-bird",
  },
  {
    code: ["1F425"],
    emoji: "🐥",
    name: "front-facing baby chick",
    category: "Animals & Nature",
    subcategory: "animal-bird",
  },
  {
    code: ["1F426"],
    emoji: "🐦",
    name: "bird",
    category: "Animals & Nature",
    subcategory: "animal-bird",
  },
  {
    code: ["1F427"],
    emoji: "🐧",
    name: "penguin",
    category: "Animals & Nature",
    subcategory: "animal-bird",
  },
  {
    code: ["1F54A"],
    emoji: "🕊",
    name: "dove",
    category: "Animals & Nature",
    subcategory: "animal-bird",
  },
  {
    code: ["1F985"],
    emoji: "🦅",
    name: "eagle",
    category: "Animals & Nature",
    subcategory: "animal-bird",
  },
  {
    code: ["1F986"],
    emoji: "🦆",
    name: "duck",
    category: "Animals & Nature",
    subcategory: "animal-bird",
  },
  {
    code: ["1F9A2"],
    emoji: "🦢",
    name: "swan",
    category: "Animals & Nature",
    subcategory: "animal-bird",
  },
  {
    code: ["1F989"],
    emoji: "🦉",
    name: "owl",
    category: "Animals & Nature",
    subcategory: "animal-bird",
  },
  {
    code: ["1F9A4"],
    emoji: "🦤",
    name: "dodo",
    category: "Animals & Nature",
    subcategory: "animal-bird",
  },
  {
    code: ["1FAB6"],
    emoji: "🪶",
    name: "feather",
    category: "Animals & Nature",
    subcategory: "animal-bird",
  },
  {
    code: ["1F9A9"],
    emoji: "🦩",
    name: "flamingo",
    category: "Animals & Nature",
    subcategory: "animal-bird",
  },
  {
    code: ["1F99A"],
    emoji: "🦚",
    name: "peacock",
    category: "Animals & Nature",
    subcategory: "animal-bird",
  },
  {
    code: ["1F99C"],
    emoji: "🦜",
    name: "parrot",
    category: "Animals & Nature",
    subcategory: "animal-bird",
  },
  {
    code: ["1FABD"],
    emoji: "🪽",
    name: "wing",
    category: "Animals & Nature",
    subcategory: "animal-bird",
  },
  {
    code: ["1F426", "200D", "2B1B"],
    emoji: "🐦‍⬛",
    name: "black bird",
    category: "Animals & Nature",
    subcategory: "animal-bird",
  },
  {
    code: ["1FABF"],
    emoji: "🪿",
    name: "goose",
    category: "Animals & Nature",
    subcategory: "animal-bird",
  },
  {
    code: ["1F426", "200D", "1F525"],
    emoji: "🐦‍🔥",
    name: "phoenix",
    category: "Animals & Nature",
    subcategory: "animal-bird",
  },
  {
    code: ["1F438"],
    emoji: "🐸",
    name: "frog",
    category: "Animals & Nature",
    subcategory: "animal-amphibian",
  },
  {
    code: ["1F40A"],
    emoji: "🐊",
    name: "crocodile",
    category: "Animals & Nature",
    subcategory: "animal-reptile",
  },
  {
    code: ["1F422"],
    emoji: "🐢",
    name: "turtle",
    category: "Animals & Nature",
    subcategory: "animal-reptile",
  },
  {
    code: ["1F98E"],
    emoji: "🦎",
    name: "lizard",
    category: "Animals & Nature",
    subcategory: "animal-reptile",
  },
  {
    code: ["1F40D"],
    emoji: "🐍",
    name: "snake",
    category: "Animals & Nature",
    subcategory: "animal-reptile",
  },
  {
    code: ["1F432"],
    emoji: "🐲",
    name: "dragon face",
    category: "Animals & Nature",
    subcategory: "animal-reptile",
  },
  {
    code: ["1F409"],
    emoji: "🐉",
    name: "dragon",
    category: "Animals & Nature",
    subcategory: "animal-reptile",
  },
  {
    code: ["1F995"],
    emoji: "🦕",
    name: "sauropod",
    category: "Animals & Nature",
    subcategory: "animal-reptile",
  },
  {
    code: ["1F996"],
    emoji: "🦖",
    name: "T-Rex",
    category: "Animals & Nature",
    subcategory: "animal-reptile",
  },
  {
    code: ["1F433"],
    emoji: "🐳",
    name: "spouting whale",
    category: "Animals & Nature",
    subcategory: "animal-marine",
  },
  {
    code: ["1F40B"],
    emoji: "🐋",
    name: "whale",
    category: "Animals & Nature",
    subcategory: "animal-marine",
  },
  {
    code: ["1F42C"],
    emoji: "🐬",
    name: "dolphin",
    category: "Animals & Nature",
    subcategory: "animal-marine",
  },
  {
    code: ["1F9AD"],
    emoji: "🦭",
    name: "seal",
    category: "Animals & Nature",
    subcategory: "animal-marine",
  },
  {
    code: ["1F41F"],
    emoji: "🐟",
    name: "fish",
    category: "Animals & Nature",
    subcategory: "animal-marine",
  },
  {
    code: ["1F420"],
    emoji: "🐠",
    name: "tropical fish",
    category: "Animals & Nature",
    subcategory: "animal-marine",
  },
  {
    code: ["1F421"],
    emoji: "🐡",
    name: "blowfish",
    category: "Animals & Nature",
    subcategory: "animal-marine",
  },
  {
    code: ["1F988"],
    emoji: "🦈",
    name: "shark",
    category: "Animals & Nature",
    subcategory: "animal-marine",
  },
  {
    code: ["1F419"],
    emoji: "🐙",
    name: "octopus",
    category: "Animals & Nature",
    subcategory: "animal-marine",
  },
  {
    code: ["1F41A"],
    emoji: "🐚",
    name: "spiral shell",
    category: "Animals & Nature",
    subcategory: "animal-marine",
  },
  {
    code: ["1FAB8"],
    emoji: "🪸",
    name: "coral",
    category: "Animals & Nature",
    subcategory: "animal-marine",
  },
  {
    code: ["1FABC"],
    emoji: "🪼",
    name: "jellyfish",
    category: "Animals & Nature",
    subcategory: "animal-marine",
  },
  {
    code: ["1F980"],
    emoji: "🦀",
    name: "crab",
    category: "Animals & Nature",
    subcategory: "animal-marine",
  },
  {
    code: ["1F99E"],
    emoji: "🦞",
    name: "lobster",
    category: "Animals & Nature",
    subcategory: "animal-marine",
  },
  {
    code: ["1F990"],
    emoji: "🦐",
    name: "shrimp",
    category: "Animals & Nature",
    subcategory: "animal-marine",
  },
  {
    code: ["1F991"],
    emoji: "🦑",
    name: "squid",
    category: "Animals & Nature",
    subcategory: "animal-marine",
  },
  {
    code: ["1F9AA"],
    emoji: "🦪",
    name: "oyster",
    category: "Animals & Nature",
    subcategory: "animal-marine",
  },
  {
    code: ["1F40C"],
    emoji: "🐌",
    name: "snail",
    category: "Animals & Nature",
    subcategory: "animal-bug",
  },
  {
    code: ["1F98B"],
    emoji: "🦋",
    name: "butterfly",
    category: "Animals & Nature",
    subcategory: "animal-bug",
  },
  {
    code: ["1F41B"],
    emoji: "🐛",
    name: "bug",
    category: "Animals & Nature",
    subcategory: "animal-bug",
  },
  {
    code: ["1F41C"],
    emoji: "🐜",
    name: "ant",
    category: "Animals & Nature",
    subcategory: "animal-bug",
  },
  {
    code: ["1F41D"],
    emoji: "🐝",
    name: "honeybee",
    category: "Animals & Nature",
    subcategory: "animal-bug",
  },
  {
    code: ["1FAB2"],
    emoji: "🪲",
    name: "beetle",
    category: "Animals & Nature",
    subcategory: "animal-bug",
  },
  {
    code: ["1F41E"],
    emoji: "🐞",
    name: "lady beetle",
    category: "Animals & Nature",
    subcategory: "animal-bug",
  },
  {
    code: ["1F997"],
    emoji: "🦗",
    name: "cricket",
    category: "Animals & Nature",
    subcategory: "animal-bug",
  },
  {
    code: ["1FAB3"],
    emoji: "🪳",
    name: "cockroach",
    category: "Animals & Nature",
    subcategory: "animal-bug",
  },
  {
    code: ["1F577"],
    emoji: "🕷",
    name: "spider",
    category: "Animals & Nature",
    subcategory: "animal-bug",
  },
  {
    code: ["1F578"],
    emoji: "🕸",
    name: "spider web",
    category: "Animals & Nature",
    subcategory: "animal-bug",
  },
  {
    code: ["1F982"],
    emoji: "🦂",
    name: "scorpion",
    category: "Animals & Nature",
    subcategory: "animal-bug",
  },
  {
    code: ["1F99F"],
    emoji: "🦟",
    name: "mosquito",
    category: "Animals & Nature",
    subcategory: "animal-bug",
  },
  {
    code: ["1FAB0"],
    emoji: "🪰",
    name: "fly",
    category: "Animals & Nature",
    subcategory: "animal-bug",
  },
  {
    code: ["1FAB1"],
    emoji: "🪱",
    name: "worm",
    category: "Animals & Nature",
    subcategory: "animal-bug",
  },
  {
    code: ["1F9A0"],
    emoji: "🦠",
    name: "microbe",
    category: "Animals & Nature",
    subcategory: "animal-bug",
  },
  {
    code: ["1F490"],
    emoji: "💐",
    name: "bouquet",
    category: "Animals & Nature",
    subcategory: "plant-flower",
  },
  {
    code: ["1F338"],
    emoji: "🌸",
    name: "cherry blossom",
    category: "Animals & Nature",
    subcategory: "plant-flower",
  },
  {
    code: ["1F4AE"],
    emoji: "💮",
    name: "white flower",
    category: "Animals & Nature",
    subcategory: "plant-flower",
  },
  {
    code: ["1FAB7"],
    emoji: "🪷",
    name: "lotus",
    category: "Animals & Nature",
    subcategory: "plant-flower",
  },
  {
    code: ["1F3F5"],
    emoji: "🏵",
    name: "rosette",
    category: "Animals & Nature",
    subcategory: "plant-flower",
  },
  {
    code: ["1F339"],
    emoji: "🌹",
    name: "rose",
    category: "Animals & Nature",
    subcategory: "plant-flower",
  },
  {
    code: ["1F940"],
    emoji: "🥀",
    name: "wilted flower",
    category: "Animals & Nature",
    subcategory: "plant-flower",
  },
  {
    code: ["1F33A"],
    emoji: "🌺",
    name: "hibiscus",
    category: "Animals & Nature",
    subcategory: "plant-flower",
  },
  {
    code: ["1F33B"],
    emoji: "🌻",
    name: "sunflower",
    category: "Animals & Nature",
    subcategory: "plant-flower",
  },
  {
    code: ["1F33C"],
    emoji: "🌼",
    name: "blossom",
    category: "Animals & Nature",
    subcategory: "plant-flower",
  },
  {
    code: ["1F337"],
    emoji: "🌷",
    name: "tulip",
    category: "Animals & Nature",
    subcategory: "plant-flower",
  },
  {
    code: ["1FABB"],
    emoji: "🪻",
    name: "hyacinth",
    category: "Animals & Nature",
    subcategory: "plant-flower",
  },
  {
    code: ["1F331"],
    emoji: "🌱",
    name: "seedling",
    category: "Animals & Nature",
    subcategory: "plant-other",
  },
  {
    code: ["1FAB4"],
    emoji: "🪴",
    name: "potted plant",
    category: "Animals & Nature",
    subcategory: "plant-other",
  },
  {
    code: ["1F332"],
    emoji: "🌲",
    name: "evergreen tree",
    category: "Animals & Nature",
    subcategory: "plant-other",
  },
  {
    code: ["1F333"],
    emoji: "🌳",
    name: "deciduous tree",
    category: "Animals & Nature",
    subcategory: "plant-other",
  },
  {
    code: ["1F334"],
    emoji: "🌴",
    name: "palm tree",
    category: "Animals & Nature",
    subcategory: "plant-other",
  },
  {
    code: ["1F335"],
    emoji: "🌵",
    name: "cactus",
    category: "Animals & Nature",
    subcategory: "plant-other",
  },
  {
    code: ["1F33E"],
    emoji: "🌾",
    name: "sheaf of rice",
    category: "Animals & Nature",
    subcategory: "plant-other",
  },
  {
    code: ["1F33F"],
    emoji: "🌿",
    name: "herb",
    category: "Animals & Nature",
    subcategory: "plant-other",
  },
  {
    code: ["2618"],
    emoji: "☘",
    name: "shamrock",
    category: "Animals & Nature",
    subcategory: "plant-other",
  },
  {
    code: ["1F340"],
    emoji: "🍀",
    name: "four leaf clover",
    category: "Animals & Nature",
    subcategory: "plant-other",
  },
  {
    code: ["1F341"],
    emoji: "🍁",
    name: "maple leaf",
    category: "Animals & Nature",
    subcategory: "plant-other",
  },
  {
    code: ["1F342"],
    emoji: "🍂",
    name: "fallen leaf",
    category: "Animals & Nature",
    subcategory: "plant-other",
  },
  {
    code: ["1F343"],
    emoji: "🍃",
    name: "leaf fluttering in wind",
    category: "Animals & Nature",
    subcategory: "plant-other",
  },
  {
    code: ["1FAB9"],
    emoji: "🪹",
    name: "empty nest",
    category: "Animals & Nature",
    subcategory: "plant-other",
  },
  {
    code: ["1FABA"],
    emoji: "🪺",
    name: "nest with eggs",
    category: "Animals & Nature",
    subcategory: "plant-other",
  },
  {
    code: ["1F344"],
    emoji: "🍄",
    name: "mushroom",
    category: "Animals & Nature",
    subcategory: "plant-other",
  },
  {
    code: ["1FABE"],
    emoji: "🪾",
    name: "leafless tree",
    category: "Animals & Nature",
    subcategory: "plant-other",
  },
  {
    code: ["1F347"],
    emoji: "🍇",
    name: "grapes",
    category: "Food & Drink",
    subcategory: "food-fruit",
  },
  {
    code: ["1F348"],
    emoji: "🍈",
    name: "melon",
    category: "Food & Drink",
    subcategory: "food-fruit",
  },
  {
    code: ["1F349"],
    emoji: "🍉",
    name: "watermelon",
    category: "Food & Drink",
    subcategory: "food-fruit",
  },
  {
    code: ["1F34A"],
    emoji: "🍊",
    name: "tangerine",
    category: "Food & Drink",
    subcategory: "food-fruit",
  },
  {
    code: ["1F34B"],
    emoji: "🍋",
    name: "lemon",
    category: "Food & Drink",
    subcategory: "food-fruit",
  },
  {
    code: ["1F34B", "200D", "1F7E9"],
    emoji: "🍋‍🟩",
    name: "lime",
    category: "Food & Drink",
    subcategory: "food-fruit",
  },
  {
    code: ["1F34C"],
    emoji: "🍌",
    name: "banana",
    category: "Food & Drink",
    subcategory: "food-fruit",
  },
  {
    code: ["1F34D"],
    emoji: "🍍",
    name: "pineapple",
    category: "Food & Drink",
    subcategory: "food-fruit",
  },
  {
    code: ["1F96D"],
    emoji: "🥭",
    name: "mango",
    category: "Food & Drink",
    subcategory: "food-fruit",
  },
  {
    code: ["1F34E"],
    emoji: "🍎",
    name: "red apple",
    category: "Food & Drink",
    subcategory: "food-fruit",
  },
  {
    code: ["1F34F"],
    emoji: "🍏",
    name: "green apple",
    category: "Food & Drink",
    subcategory: "food-fruit",
  },
  {
    code: ["1F350"],
    emoji: "🍐",
    name: "pear",
    category: "Food & Drink",
    subcategory: "food-fruit",
  },
  {
    code: ["1F351"],
    emoji: "🍑",
    name: "peach",
    category: "Food & Drink",
    subcategory: "food-fruit",
  },
  {
    code: ["1F352"],
    emoji: "🍒",
    name: "cherries",
    category: "Food & Drink",
    subcategory: "food-fruit",
  },
  {
    code: ["1F353"],
    emoji: "🍓",
    name: "strawberry",
    category: "Food & Drink",
    subcategory: "food-fruit",
  },
  {
    code: ["1FAD0"],
    emoji: "🫐",
    name: "blueberries",
    category: "Food & Drink",
    subcategory: "food-fruit",
  },
  {
    code: ["1F95D"],
    emoji: "🥝",
    name: "kiwi fruit",
    category: "Food & Drink",
    subcategory: "food-fruit",
  },
  {
    code: ["1F345"],
    emoji: "🍅",
    name: "tomato",
    category: "Food & Drink",
    subcategory: "food-fruit",
  },
  {
    code: ["1FAD2"],
    emoji: "🫒",
    name: "olive",
    category: "Food & Drink",
    subcategory: "food-fruit",
  },
  {
    code: ["1F965"],
    emoji: "🥥",
    name: "coconut",
    category: "Food & Drink",
    subcategory: "food-fruit",
  },
  {
    code: ["1F951"],
    emoji: "🥑",
    name: "avocado",
    category: "Food & Drink",
    subcategory: "food-vegetable",
  },
  {
    code: ["1F346"],
    emoji: "🍆",
    name: "eggplant",
    category: "Food & Drink",
    subcategory: "food-vegetable",
  },
  {
    code: ["1F954"],
    emoji: "🥔",
    name: "potato",
    category: "Food & Drink",
    subcategory: "food-vegetable",
  },
  {
    code: ["1F955"],
    emoji: "🥕",
    name: "carrot",
    category: "Food & Drink",
    subcategory: "food-vegetable",
  },
  {
    code: ["1F33D"],
    emoji: "🌽",
    name: "ear of corn",
    category: "Food & Drink",
    subcategory: "food-vegetable",
  },
  {
    code: ["1F336"],
    emoji: "🌶",
    name: "hot pepper",
    category: "Food & Drink",
    subcategory: "food-vegetable",
  },
  {
    code: ["1FAD1"],
    emoji: "🫑",
    name: "bell pepper",
    category: "Food & Drink",
    subcategory: "food-vegetable",
  },
  {
    code: ["1F952"],
    emoji: "🥒",
    name: "cucumber",
    category: "Food & Drink",
    subcategory: "food-vegetable",
  },
  {
    code: ["1F96C"],
    emoji: "🥬",
    name: "leafy green",
    category: "Food & Drink",
    subcategory: "food-vegetable",
  },
  {
    code: ["1F966"],
    emoji: "🥦",
    name: "broccoli",
    category: "Food & Drink",
    subcategory: "food-vegetable",
  },
  {
    code: ["1F9C4"],
    emoji: "🧄",
    name: "garlic",
    category: "Food & Drink",
    subcategory: "food-vegetable",
  },
  {
    code: ["1F9C5"],
    emoji: "🧅",
    name: "onion",
    category: "Food & Drink",
    subcategory: "food-vegetable",
  },
  {
    code: ["1F95C"],
    emoji: "🥜",
    name: "peanuts",
    category: "Food & Drink",
    subcategory: "food-vegetable",
  },
  {
    code: ["1FAD8"],
    emoji: "🫘",
    name: "beans",
    category: "Food & Drink",
    subcategory: "food-vegetable",
  },
  {
    code: ["1F330"],
    emoji: "🌰",
    name: "chestnut",
    category: "Food & Drink",
    subcategory: "food-vegetable",
  },
  {
    code: ["1FADA"],
    emoji: "🫚",
    name: "ginger root",
    category: "Food & Drink",
    subcategory: "food-vegetable",
  },
  {
    code: ["1FADB"],
    emoji: "🫛",
    name: "pea pod",
    category: "Food & Drink",
    subcategory: "food-vegetable",
  },
  {
    code: ["1F344", "200D", "1F7EB"],
    emoji: "🍄‍🟫",
    name: "brown mushroom",
    category: "Food & Drink",
    subcategory: "food-vegetable",
  },
  {
    code: ["1FADC"],
    emoji: "🫜",
    name: "root vegetable",
    category: "Food & Drink",
    subcategory: "food-vegetable",
  },
  {
    code: ["1F35E"],
    emoji: "🍞",
    name: "bread",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F950"],
    emoji: "🥐",
    name: "croissant",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F956"],
    emoji: "🥖",
    name: "baguette bread",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1FAD3"],
    emoji: "🫓",
    name: "flatbread",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F968"],
    emoji: "🥨",
    name: "pretzel",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F96F"],
    emoji: "🥯",
    name: "bagel",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F95E"],
    emoji: "🥞",
    name: "pancakes",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F9C7"],
    emoji: "🧇",
    name: "waffle",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F9C0"],
    emoji: "🧀",
    name: "cheese wedge",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F356"],
    emoji: "🍖",
    name: "meat on bone",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F357"],
    emoji: "🍗",
    name: "poultry leg",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F969"],
    emoji: "🥩",
    name: "cut of meat",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F953"],
    emoji: "🥓",
    name: "bacon",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F354"],
    emoji: "🍔",
    name: "hamburger",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F35F"],
    emoji: "🍟",
    name: "french fries",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F355"],
    emoji: "🍕",
    name: "pizza",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F32D"],
    emoji: "🌭",
    name: "hot dog",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F96A"],
    emoji: "🥪",
    name: "sandwich",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F32E"],
    emoji: "🌮",
    name: "taco",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F32F"],
    emoji: "🌯",
    name: "burrito",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1FAD4"],
    emoji: "🫔",
    name: "tamale",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F959"],
    emoji: "🥙",
    name: "stuffed flatbread",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F9C6"],
    emoji: "🧆",
    name: "falafel",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F95A"],
    emoji: "🥚",
    name: "egg",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F373"],
    emoji: "🍳",
    name: "cooking",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F958"],
    emoji: "🥘",
    name: "shallow pan of food",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F372"],
    emoji: "🍲",
    name: "pot of food",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1FAD5"],
    emoji: "🫕",
    name: "fondue",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F963"],
    emoji: "🥣",
    name: "bowl with spoon",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F957"],
    emoji: "🥗",
    name: "green salad",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F37F"],
    emoji: "🍿",
    name: "popcorn",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F9C8"],
    emoji: "🧈",
    name: "butter",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F9C2"],
    emoji: "🧂",
    name: "salt",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F96B"],
    emoji: "🥫",
    name: "canned food",
    category: "Food & Drink",
    subcategory: "food-prepared",
  },
  {
    code: ["1F371"],
    emoji: "🍱",
    name: "bento box",
    category: "Food & Drink",
    subcategory: "food-asian",
  },
  {
    code: ["1F358"],
    emoji: "🍘",
    name: "rice cracker",
    category: "Food & Drink",
    subcategory: "food-asian",
  },
  {
    code: ["1F359"],
    emoji: "🍙",
    name: "rice ball",
    category: "Food & Drink",
    subcategory: "food-asian",
  },
  {
    code: ["1F35A"],
    emoji: "🍚",
    name: "cooked rice",
    category: "Food & Drink",
    subcategory: "food-asian",
  },
  {
    code: ["1F35B"],
    emoji: "🍛",
    name: "curry rice",
    category: "Food & Drink",
    subcategory: "food-asian",
  },
  {
    code: ["1F35C"],
    emoji: "🍜",
    name: "steaming bowl",
    category: "Food & Drink",
    subcategory: "food-asian",
  },
  {
    code: ["1F35D"],
    emoji: "🍝",
    name: "spaghetti",
    category: "Food & Drink",
    subcategory: "food-asian",
  },
  {
    code: ["1F360"],
    emoji: "🍠",
    name: "roasted sweet potato",
    category: "Food & Drink",
    subcategory: "food-asian",
  },
  {
    code: ["1F362"],
    emoji: "🍢",
    name: "oden",
    category: "Food & Drink",
    subcategory: "food-asian",
  },
  {
    code: ["1F363"],
    emoji: "🍣",
    name: "sushi",
    category: "Food & Drink",
    subcategory: "food-asian",
  },
  {
    code: ["1F364"],
    emoji: "🍤",
    name: "fried shrimp",
    category: "Food & Drink",
    subcategory: "food-asian",
  },
  {
    code: ["1F365"],
    emoji: "🍥",
    name: "fish cake with swirl",
    category: "Food & Drink",
    subcategory: "food-asian",
  },
  {
    code: ["1F96E"],
    emoji: "🥮",
    name: "moon cake",
    category: "Food & Drink",
    subcategory: "food-asian",
  },
  {
    code: ["1F361"],
    emoji: "🍡",
    name: "dango",
    category: "Food & Drink",
    subcategory: "food-asian",
  },
  {
    code: ["1F95F"],
    emoji: "🥟",
    name: "dumpling",
    category: "Food & Drink",
    subcategory: "food-asian",
  },
  {
    code: ["1F960"],
    emoji: "🥠",
    name: "fortune cookie",
    category: "Food & Drink",
    subcategory: "food-asian",
  },
  {
    code: ["1F961"],
    emoji: "🥡",
    name: "takeout box",
    category: "Food & Drink",
    subcategory: "food-asian",
  },
  {
    code: ["1F366"],
    emoji: "🍦",
    name: "soft ice cream",
    category: "Food & Drink",
    subcategory: "food-sweet",
  },
  {
    code: ["1F367"],
    emoji: "🍧",
    name: "shaved ice",
    category: "Food & Drink",
    subcategory: "food-sweet",
  },
  {
    code: ["1F368"],
    emoji: "🍨",
    name: "ice cream",
    category: "Food & Drink",
    subcategory: "food-sweet",
  },
  {
    code: ["1F369"],
    emoji: "🍩",
    name: "doughnut",
    category: "Food & Drink",
    subcategory: "food-sweet",
  },
  {
    code: ["1F36A"],
    emoji: "🍪",
    name: "cookie",
    category: "Food & Drink",
    subcategory: "food-sweet",
  },
  {
    code: ["1F382"],
    emoji: "🎂",
    name: "birthday cake",
    category: "Food & Drink",
    subcategory: "food-sweet",
  },
  {
    code: ["1F370"],
    emoji: "🍰",
    name: "shortcake",
    category: "Food & Drink",
    subcategory: "food-sweet",
  },
  {
    code: ["1F9C1"],
    emoji: "🧁",
    name: "cupcake",
    category: "Food & Drink",
    subcategory: "food-sweet",
  },
  {
    code: ["1F967"],
    emoji: "🥧",
    name: "pie",
    category: "Food & Drink",
    subcategory: "food-sweet",
  },
  {
    code: ["1F36B"],
    emoji: "🍫",
    name: "chocolate bar",
    category: "Food & Drink",
    subcategory: "food-sweet",
  },
  {
    code: ["1F36C"],
    emoji: "🍬",
    name: "candy",
    category: "Food & Drink",
    subcategory: "food-sweet",
  },
  {
    code: ["1F36D"],
    emoji: "🍭",
    name: "lollipop",
    category: "Food & Drink",
    subcategory: "food-sweet",
  },
  {
    code: ["1F36E"],
    emoji: "🍮",
    name: "custard",
    category: "Food & Drink",
    subcategory: "food-sweet",
  },
  {
    code: ["1F36F"],
    emoji: "🍯",
    name: "honey pot",
    category: "Food & Drink",
    subcategory: "food-sweet",
  },
  {
    code: ["1F37C"],
    emoji: "🍼",
    name: "baby bottle",
    category: "Food & Drink",
    subcategory: "drink",
  },
  {
    code: ["1F95B"],
    emoji: "🥛",
    name: "glass of milk",
    category: "Food & Drink",
    subcategory: "drink",
  },
  {
    code: ["2615"],
    emoji: "☕",
    name: "hot beverage",
    category: "Food & Drink",
    subcategory: "drink",
  },
  {
    code: ["1FAD6"],
    emoji: "🫖",
    name: "teapot",
    category: "Food & Drink",
    subcategory: "drink",
  },
  {
    code: ["1F375"],
    emoji: "🍵",
    name: "teacup without handle",
    category: "Food & Drink",
    subcategory: "drink",
  },
  {
    code: ["1F376"],
    emoji: "🍶",
    name: "sake",
    category: "Food & Drink",
    subcategory: "drink",
  },
  {
    code: ["1F37E"],
    emoji: "🍾",
    name: "bottle with popping cork",
    category: "Food & Drink",
    subcategory: "drink",
  },
  {
    code: ["1F377"],
    emoji: "🍷",
    name: "wine glass",
    category: "Food & Drink",
    subcategory: "drink",
  },
  {
    code: ["1F378"],
    emoji: "🍸",
    name: "cocktail glass",
    category: "Food & Drink",
    subcategory: "drink",
  },
  {
    code: ["1F379"],
    emoji: "🍹",
    name: "tropical drink",
    category: "Food & Drink",
    subcategory: "drink",
  },
  {
    code: ["1F37A"],
    emoji: "🍺",
    name: "beer mug",
    category: "Food & Drink",
    subcategory: "drink",
  },
  {
    code: ["1F37B"],
    emoji: "🍻",
    name: "clinking beer mugs",
    category: "Food & Drink",
    subcategory: "drink",
  },
  {
    code: ["1F942"],
    emoji: "🥂",
    name: "clinking glasses",
    category: "Food & Drink",
    subcategory: "drink",
  },
  {
    code: ["1F943"],
    emoji: "🥃",
    name: "tumbler glass",
    category: "Food & Drink",
    subcategory: "drink",
  },
  {
    code: ["1FAD7"],
    emoji: "🫗",
    name: "pouring liquid",
    category: "Food & Drink",
    subcategory: "drink",
  },
  {
    code: ["1F964"],
    emoji: "🥤",
    name: "cup with straw",
    category: "Food & Drink",
    subcategory: "drink",
  },
  {
    code: ["1F9CB"],
    emoji: "🧋",
    name: "bubble tea",
    category: "Food & Drink",
    subcategory: "drink",
  },
  {
    code: ["1F9C3"],
    emoji: "🧃",
    name: "beverage box",
    category: "Food & Drink",
    subcategory: "drink",
  },
  {
    code: ["1F9C9"],
    emoji: "🧉",
    name: "mate",
    category: "Food & Drink",
    subcategory: "drink",
  },
  {
    code: ["1F9CA"],
    emoji: "🧊",
    name: "ice",
    category: "Food & Drink",
    subcategory: "drink",
  },
  {
    code: ["1F962"],
    emoji: "🥢",
    name: "chopsticks",
    category: "Food & Drink",
    subcategory: "dishware",
  },
  {
    code: ["1F37D"],
    emoji: "🍽",
    name: "fork and knife with plate",
    category: "Food & Drink",
    subcategory: "dishware",
  },
  {
    code: ["1F374"],
    emoji: "🍴",
    name: "fork and knife",
    category: "Food & Drink",
    subcategory: "dishware",
  },
  {
    code: ["1F944"],
    emoji: "🥄",
    name: "spoon",
    category: "Food & Drink",
    subcategory: "dishware",
  },
  {
    code: ["1F52A"],
    emoji: "🔪",
    name: "kitchen knife",
    category: "Food & Drink",
    subcategory: "dishware",
  },
  {
    code: ["1FAD9"],
    emoji: "🫙",
    name: "jar",
    category: "Food & Drink",
    subcategory: "dishware",
  },
  {
    code: ["1F3FA"],
    emoji: "🏺",
    name: "amphora",
    category: "Food & Drink",
    subcategory: "dishware",
  },
  {
    code: ["1F30D"],
    emoji: "🌍",
    name: "globe showing Europe-Africa",
    category: "Travel & Places",
    subcategory: "place-map",
  },
  {
    code: ["1F30E"],
    emoji: "🌎",
    name: "globe showing Americas",
    category: "Travel & Places",
    subcategory: "place-map",
  },
  {
    code: ["1F30F"],
    emoji: "🌏",
    name: "globe showing Asia-Australia",
    category: "Travel & Places",
    subcategory: "place-map",
  },
  {
    code: ["1F310"],
    emoji: "🌐",
    name: "globe with meridians",
    category: "Travel & Places",
    subcategory: "place-map",
  },
  {
    code: ["1F5FA"],
    emoji: "🗺",
    name: "world map",
    category: "Travel & Places",
    subcategory: "place-map",
  },
  {
    code: ["1F5FE"],
    emoji: "🗾",
    name: "map of Japan",
    category: "Travel & Places",
    subcategory: "place-map",
  },
  {
    code: ["1F9ED"],
    emoji: "🧭",
    name: "compass",
    category: "Travel & Places",
    subcategory: "place-map",
  },
  {
    code: ["1F3D4"],
    emoji: "🏔",
    name: "snow-capped mountain",
    category: "Travel & Places",
    subcategory: "place-geographic",
  },
  {
    code: ["26F0"],
    emoji: "⛰",
    name: "mountain",
    category: "Travel & Places",
    subcategory: "place-geographic",
  },
  {
    code: ["1F30B"],
    emoji: "🌋",
    name: "volcano",
    category: "Travel & Places",
    subcategory: "place-geographic",
  },
  {
    code: ["1F5FB"],
    emoji: "🗻",
    name: "mount fuji",
    category: "Travel & Places",
    subcategory: "place-geographic",
  },
  {
    code: ["1F3D5"],
    emoji: "🏕",
    name: "camping",
    category: "Travel & Places",
    subcategory: "place-geographic",
  },
  {
    code: ["1F3D6"],
    emoji: "🏖",
    name: "beach with umbrella",
    category: "Travel & Places",
    subcategory: "place-geographic",
  },
  {
    code: ["1F3DC"],
    emoji: "🏜",
    name: "desert",
    category: "Travel & Places",
    subcategory: "place-geographic",
  },
  {
    code: ["1F3DD"],
    emoji: "🏝",
    name: "desert island",
    category: "Travel & Places",
    subcategory: "place-geographic",
  },
  {
    code: ["1F3DE"],
    emoji: "🏞",
    name: "national park",
    category: "Travel & Places",
    subcategory: "place-geographic",
  },
  {
    code: ["1F3DF"],
    emoji: "🏟",
    name: "stadium",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F3DB"],
    emoji: "🏛",
    name: "classical building",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F3D7"],
    emoji: "🏗",
    name: "building construction",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F9F1"],
    emoji: "🧱",
    name: "brick",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1FAA8"],
    emoji: "🪨",
    name: "rock",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1FAB5"],
    emoji: "🪵",
    name: "wood",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F6D6"],
    emoji: "🛖",
    name: "hut",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F3D8"],
    emoji: "🏘",
    name: "houses",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F3DA"],
    emoji: "🏚",
    name: "derelict house",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F3E0"],
    emoji: "🏠",
    name: "house",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F3E1"],
    emoji: "🏡",
    name: "house with garden",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F3E2"],
    emoji: "🏢",
    name: "office building",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F3E3"],
    emoji: "🏣",
    name: "Japanese post office",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F3E4"],
    emoji: "🏤",
    name: "post office",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F3E5"],
    emoji: "🏥",
    name: "hospital",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F3E6"],
    emoji: "🏦",
    name: "bank",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F3E8"],
    emoji: "🏨",
    name: "hotel",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F3E9"],
    emoji: "🏩",
    name: "love hotel",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F3EA"],
    emoji: "🏪",
    name: "convenience store",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F3EB"],
    emoji: "🏫",
    name: "school",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F3EC"],
    emoji: "🏬",
    name: "department store",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F3ED"],
    emoji: "🏭",
    name: "factory",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F3EF"],
    emoji: "🏯",
    name: "Japanese castle",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F3F0"],
    emoji: "🏰",
    name: "castle",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F492"],
    emoji: "💒",
    name: "wedding",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F5FC"],
    emoji: "🗼",
    name: "Tokyo tower",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["1F5FD"],
    emoji: "🗽",
    name: "Statue of Liberty",
    category: "Travel & Places",
    subcategory: "place-building",
  },
  {
    code: ["26EA"],
    emoji: "⛪",
    name: "church",
    category: "Travel & Places",
    subcategory: "place-religious",
  },
  {
    code: ["1F54C"],
    emoji: "🕌",
    name: "mosque",
    category: "Travel & Places",
    subcategory: "place-religious",
  },
  {
    code: ["1F6D5"],
    emoji: "🛕",
    name: "hindu temple",
    category: "Travel & Places",
    subcategory: "place-religious",
  },
  {
    code: ["1F54D"],
    emoji: "🕍",
    name: "synagogue",
    category: "Travel & Places",
    subcategory: "place-religious",
  },
  {
    code: ["26E9"],
    emoji: "⛩",
    name: "shinto shrine",
    category: "Travel & Places",
    subcategory: "place-religious",
  },
  {
    code: ["1F54B"],
    emoji: "🕋",
    name: "kaaba",
    category: "Travel & Places",
    subcategory: "place-religious",
  },
  {
    code: ["26F2"],
    emoji: "⛲",
    name: "fountain",
    category: "Travel & Places",
    subcategory: "place-other",
  },
  {
    code: ["26FA"],
    emoji: "⛺",
    name: "tent",
    category: "Travel & Places",
    subcategory: "place-other",
  },
  {
    code: ["1F301"],
    emoji: "🌁",
    name: "foggy",
    category: "Travel & Places",
    subcategory: "place-other",
  },
  {
    code: ["1F303"],
    emoji: "🌃",
    name: "night with stars",
    category: "Travel & Places",
    subcategory: "place-other",
  },
  {
    code: ["1F3D9"],
    emoji: "🏙",
    name: "cityscape",
    category: "Travel & Places",
    subcategory: "place-other",
  },
  {
    code: ["1F304"],
    emoji: "🌄",
    name: "sunrise over mountains",
    category: "Travel & Places",
    subcategory: "place-other",
  },
  {
    code: ["1F305"],
    emoji: "🌅",
    name: "sunrise",
    category: "Travel & Places",
    subcategory: "place-other",
  },
  {
    code: ["1F306"],
    emoji: "🌆",
    name: "cityscape at dusk",
    category: "Travel & Places",
    subcategory: "place-other",
  },
  {
    code: ["1F307"],
    emoji: "🌇",
    name: "sunset",
    category: "Travel & Places",
    subcategory: "place-other",
  },
  {
    code: ["1F309"],
    emoji: "🌉",
    name: "bridge at night",
    category: "Travel & Places",
    subcategory: "place-other",
  },
  {
    code: ["2668"],
    emoji: "♨",
    name: "hot springs",
    category: "Travel & Places",
    subcategory: "place-other",
  },
  {
    code: ["1F3A0"],
    emoji: "🎠",
    name: "carousel horse",
    category: "Travel & Places",
    subcategory: "place-other",
  },
  {
    code: ["1F6DD"],
    emoji: "🛝",
    name: "playground slide",
    category: "Travel & Places",
    subcategory: "place-other",
  },
  {
    code: ["1F3A1"],
    emoji: "🎡",
    name: "ferris wheel",
    category: "Travel & Places",
    subcategory: "place-other",
  },
  {
    code: ["1F3A2"],
    emoji: "🎢",
    name: "roller coaster",
    category: "Travel & Places",
    subcategory: "place-other",
  },
  {
    code: ["1F488"],
    emoji: "💈",
    name: "barber pole",
    category: "Travel & Places",
    subcategory: "place-other",
  },
  {
    code: ["1F3AA"],
    emoji: "🎪",
    name: "circus tent",
    category: "Travel & Places",
    subcategory: "place-other",
  },
  {
    code: ["1F682"],
    emoji: "🚂",
    name: "locomotive",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F683"],
    emoji: "🚃",
    name: "railway car",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F684"],
    emoji: "🚄",
    name: "high-speed train",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F685"],
    emoji: "🚅",
    name: "bullet train",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F686"],
    emoji: "🚆",
    name: "train",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F687"],
    emoji: "🚇",
    name: "metro",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F688"],
    emoji: "🚈",
    name: "light rail",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F689"],
    emoji: "🚉",
    name: "station",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F68A"],
    emoji: "🚊",
    name: "tram",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F69D"],
    emoji: "🚝",
    name: "monorail",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F69E"],
    emoji: "🚞",
    name: "mountain railway",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F68B"],
    emoji: "🚋",
    name: "tram car",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F68C"],
    emoji: "🚌",
    name: "bus",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F68D"],
    emoji: "🚍",
    name: "oncoming bus",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F68E"],
    emoji: "🚎",
    name: "trolleybus",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F690"],
    emoji: "🚐",
    name: "minibus",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F691"],
    emoji: "🚑",
    name: "ambulance",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F692"],
    emoji: "🚒",
    name: "fire engine",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F693"],
    emoji: "🚓",
    name: "police car",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F694"],
    emoji: "🚔",
    name: "oncoming police car",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F695"],
    emoji: "🚕",
    name: "taxi",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F696"],
    emoji: "🚖",
    name: "oncoming taxi",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F697"],
    emoji: "🚗",
    name: "automobile",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F698"],
    emoji: "🚘",
    name: "oncoming automobile",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F699"],
    emoji: "🚙",
    name: "sport utility vehicle",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F6FB"],
    emoji: "🛻",
    name: "pickup truck",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F69A"],
    emoji: "🚚",
    name: "delivery truck",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F69B"],
    emoji: "🚛",
    name: "articulated lorry",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F69C"],
    emoji: "🚜",
    name: "tractor",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F3CE"],
    emoji: "🏎",
    name: "racing car",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F3CD"],
    emoji: "🏍",
    name: "motorcycle",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F6F5"],
    emoji: "🛵",
    name: "motor scooter",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F9BD"],
    emoji: "🦽",
    name: "manual wheelchair",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F9BC"],
    emoji: "🦼",
    name: "motorized wheelchair",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F6FA"],
    emoji: "🛺",
    name: "auto rickshaw",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F6B2"],
    emoji: "🚲",
    name: "bicycle",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F6F4"],
    emoji: "🛴",
    name: "kick scooter",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F6F9"],
    emoji: "🛹",
    name: "skateboard",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F6FC"],
    emoji: "🛼",
    name: "roller skate",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F68F"],
    emoji: "🚏",
    name: "bus stop",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F6E3"],
    emoji: "🛣",
    name: "motorway",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F6E4"],
    emoji: "🛤",
    name: "railway track",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F6E2"],
    emoji: "🛢",
    name: "oil drum",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["26FD"],
    emoji: "⛽",
    name: "fuel pump",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F6DE"],
    emoji: "🛞",
    name: "wheel",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F6A8"],
    emoji: "🚨",
    name: "police car light",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F6A5"],
    emoji: "🚥",
    name: "horizontal traffic light",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F6A6"],
    emoji: "🚦",
    name: "vertical traffic light",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F6D1"],
    emoji: "🛑",
    name: "stop sign",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["1F6A7"],
    emoji: "🚧",
    name: "construction",
    category: "Travel & Places",
    subcategory: "transport-ground",
  },
  {
    code: ["2693"],
    emoji: "⚓",
    name: "anchor",
    category: "Travel & Places",
    subcategory: "transport-water",
  },
  {
    code: ["1F6DF"],
    emoji: "🛟",
    name: "ring buoy",
    category: "Travel & Places",
    subcategory: "transport-water",
  },
  {
    code: ["26F5"],
    emoji: "⛵",
    name: "sailboat",
    category: "Travel & Places",
    subcategory: "transport-water",
  },
  {
    code: ["1F6F6"],
    emoji: "🛶",
    name: "canoe",
    category: "Travel & Places",
    subcategory: "transport-water",
  },
  {
    code: ["1F6A4"],
    emoji: "🚤",
    name: "speedboat",
    category: "Travel & Places",
    subcategory: "transport-water",
  },
  {
    code: ["1F6F3"],
    emoji: "🛳",
    name: "passenger ship",
    category: "Travel & Places",
    subcategory: "transport-water",
  },
  {
    code: ["26F4"],
    emoji: "⛴",
    name: "ferry",
    category: "Travel & Places",
    subcategory: "transport-water",
  },
  {
    code: ["1F6E5"],
    emoji: "🛥",
    name: "motor boat",
    category: "Travel & Places",
    subcategory: "transport-water",
  },
  {
    code: ["1F6A2"],
    emoji: "🚢",
    name: "ship",
    category: "Travel & Places",
    subcategory: "transport-water",
  },
  {
    code: ["2708"],
    emoji: "✈",
    name: "airplane",
    category: "Travel & Places",
    subcategory: "transport-air",
  },
  {
    code: ["1F6E9"],
    emoji: "🛩",
    name: "small airplane",
    category: "Travel & Places",
    subcategory: "transport-air",
  },
  {
    code: ["1F6EB"],
    emoji: "🛫",
    name: "airplane departure",
    category: "Travel & Places",
    subcategory: "transport-air",
  },
  {
    code: ["1F6EC"],
    emoji: "🛬",
    name: "airplane arrival",
    category: "Travel & Places",
    subcategory: "transport-air",
  },
  {
    code: ["1FA82"],
    emoji: "🪂",
    name: "parachute",
    category: "Travel & Places",
    subcategory: "transport-air",
  },
  {
    code: ["1F4BA"],
    emoji: "💺",
    name: "seat",
    category: "Travel & Places",
    subcategory: "transport-air",
  },
  {
    code: ["1F681"],
    emoji: "🚁",
    name: "helicopter",
    category: "Travel & Places",
    subcategory: "transport-air",
  },
  {
    code: ["1F69F"],
    emoji: "🚟",
    name: "suspension railway",
    category: "Travel & Places",
    subcategory: "transport-air",
  },
  {
    code: ["1F6A0"],
    emoji: "🚠",
    name: "mountain cableway",
    category: "Travel & Places",
    subcategory: "transport-air",
  },
  {
    code: ["1F6A1"],
    emoji: "🚡",
    name: "aerial tramway",
    category: "Travel & Places",
    subcategory: "transport-air",
  },
  {
    code: ["1F6F0"],
    emoji: "🛰",
    name: "satellite",
    category: "Travel & Places",
    subcategory: "transport-air",
  },
  {
    code: ["1F680"],
    emoji: "🚀",
    name: "rocket",
    category: "Travel & Places",
    subcategory: "transport-air",
  },
  {
    code: ["1F6F8"],
    emoji: "🛸",
    name: "flying saucer",
    category: "Travel & Places",
    subcategory: "transport-air",
  },
  {
    code: ["1F6CE"],
    emoji: "🛎",
    name: "bellhop bell",
    category: "Travel & Places",
    subcategory: "hotel",
  },
  {
    code: ["1F9F3"],
    emoji: "🧳",
    name: "luggage",
    category: "Travel & Places",
    subcategory: "hotel",
  },
  {
    code: ["231B"],
    emoji: "⌛",
    name: "hourglass done",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["23F3"],
    emoji: "⏳",
    name: "hourglass not done",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["231A"],
    emoji: "⌚",
    name: "watch",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["23F0"],
    emoji: "⏰",
    name: "alarm clock",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["23F1"],
    emoji: "⏱",
    name: "stopwatch",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["23F2"],
    emoji: "⏲",
    name: "timer clock",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F570"],
    emoji: "🕰",
    name: "mantelpiece clock",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F55B"],
    emoji: "🕛",
    name: "twelve o’clock",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F567"],
    emoji: "🕧",
    name: "twelve-thirty",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F550"],
    emoji: "🕐",
    name: "one o’clock",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F55C"],
    emoji: "🕜",
    name: "one-thirty",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F551"],
    emoji: "🕑",
    name: "two o’clock",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F55D"],
    emoji: "🕝",
    name: "two-thirty",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F552"],
    emoji: "🕒",
    name: "three o’clock",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F55E"],
    emoji: "🕞",
    name: "three-thirty",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F553"],
    emoji: "🕓",
    name: "four o’clock",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F55F"],
    emoji: "🕟",
    name: "four-thirty",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F554"],
    emoji: "🕔",
    name: "five o’clock",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F560"],
    emoji: "🕠",
    name: "five-thirty",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F555"],
    emoji: "🕕",
    name: "six o’clock",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F561"],
    emoji: "🕡",
    name: "six-thirty",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F556"],
    emoji: "🕖",
    name: "seven o’clock",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F562"],
    emoji: "🕢",
    name: "seven-thirty",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F557"],
    emoji: "🕗",
    name: "eight o’clock",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F563"],
    emoji: "🕣",
    name: "eight-thirty",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F558"],
    emoji: "🕘",
    name: "nine o’clock",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F564"],
    emoji: "🕤",
    name: "nine-thirty",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F559"],
    emoji: "🕙",
    name: "ten o’clock",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F565"],
    emoji: "🕥",
    name: "ten-thirty",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F55A"],
    emoji: "🕚",
    name: "eleven o’clock",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F566"],
    emoji: "🕦",
    name: "eleven-thirty",
    category: "Travel & Places",
    subcategory: "time",
  },
  {
    code: ["1F311"],
    emoji: "🌑",
    name: "new moon",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F312"],
    emoji: "🌒",
    name: "waxing crescent moon",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F313"],
    emoji: "🌓",
    name: "first quarter moon",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F314"],
    emoji: "🌔",
    name: "waxing gibbous moon",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F315"],
    emoji: "🌕",
    name: "full moon",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F316"],
    emoji: "🌖",
    name: "waning gibbous moon",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F317"],
    emoji: "🌗",
    name: "last quarter moon",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F318"],
    emoji: "🌘",
    name: "waning crescent moon",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F319"],
    emoji: "🌙",
    name: "crescent moon",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F31A"],
    emoji: "🌚",
    name: "new moon face",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F31B"],
    emoji: "🌛",
    name: "first quarter moon face",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F31C"],
    emoji: "🌜",
    name: "last quarter moon face",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F321"],
    emoji: "🌡",
    name: "thermometer",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["2600"],
    emoji: "☀",
    name: "sun",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F31D"],
    emoji: "🌝",
    name: "full moon face",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F31E"],
    emoji: "🌞",
    name: "sun with face",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1FA90"],
    emoji: "🪐",
    name: "ringed planet",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["2B50"],
    emoji: "⭐",
    name: "star",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F31F"],
    emoji: "🌟",
    name: "glowing star",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F320"],
    emoji: "🌠",
    name: "shooting star",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F30C"],
    emoji: "🌌",
    name: "milky way",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["2601"],
    emoji: "☁",
    name: "cloud",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["26C5"],
    emoji: "⛅",
    name: "sun behind cloud",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["26C8"],
    emoji: "⛈",
    name: "cloud with lightning and rain",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F324"],
    emoji: "🌤",
    name: "sun behind small cloud",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F325"],
    emoji: "🌥",
    name: "sun behind large cloud",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F326"],
    emoji: "🌦",
    name: "sun behind rain cloud",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F327"],
    emoji: "🌧",
    name: "cloud with rain",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F328"],
    emoji: "🌨",
    name: "cloud with snow",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F329"],
    emoji: "🌩",
    name: "cloud with lightning",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F32A"],
    emoji: "🌪",
    name: "tornado",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F32B"],
    emoji: "🌫",
    name: "fog",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F32C"],
    emoji: "🌬",
    name: "wind face",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F300"],
    emoji: "🌀",
    name: "cyclone",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F308"],
    emoji: "🌈",
    name: "rainbow",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F302"],
    emoji: "🌂",
    name: "closed umbrella",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["2602"],
    emoji: "☂",
    name: "umbrella",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["2614"],
    emoji: "☔",
    name: "umbrella with rain drops",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["26F1"],
    emoji: "⛱",
    name: "umbrella on ground",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["26A1"],
    emoji: "⚡",
    name: "high voltage",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["2744"],
    emoji: "❄",
    name: "snowflake",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["2603"],
    emoji: "☃",
    name: "snowman",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["26C4"],
    emoji: "⛄",
    name: "snowman without snow",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["2604"],
    emoji: "☄",
    name: "comet",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F525"],
    emoji: "🔥",
    name: "fire",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F4A7"],
    emoji: "💧",
    name: "droplet",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F30A"],
    emoji: "🌊",
    name: "water wave",
    category: "Travel & Places",
    subcategory: "sky & weather",
  },
  {
    code: ["1F383"],
    emoji: "🎃",
    name: "jack-o-lantern",
    category: "Activities",
    subcategory: "event",
  },
  {
    code: ["1F384"],
    emoji: "🎄",
    name: "Christmas tree",
    category: "Activities",
    subcategory: "event",
  },
  {
    code: ["1F386"],
    emoji: "🎆",
    name: "fireworks",
    category: "Activities",
    subcategory: "event",
  },
  {
    code: ["1F387"],
    emoji: "🎇",
    name: "sparkler",
    category: "Activities",
    subcategory: "event",
  },
  {
    code: ["1F9E8"],
    emoji: "🧨",
    name: "firecracker",
    category: "Activities",
    subcategory: "event",
  },
  {
    code: ["2728"],
    emoji: "✨",
    name: "sparkles",
    category: "Activities",
    subcategory: "event",
  },
  {
    code: ["1F388"],
    emoji: "🎈",
    name: "balloon",
    category: "Activities",
    subcategory: "event",
  },
  {
    code: ["1F389"],
    emoji: "🎉",
    name: "party popper",
    category: "Activities",
    subcategory: "event",
  },
  {
    code: ["1F38A"],
    emoji: "🎊",
    name: "confetti ball",
    category: "Activities",
    subcategory: "event",
  },
  {
    code: ["1F38B"],
    emoji: "🎋",
    name: "tanabata tree",
    category: "Activities",
    subcategory: "event",
  },
  {
    code: ["1F38D"],
    emoji: "🎍",
    name: "pine decoration",
    category: "Activities",
    subcategory: "event",
  },
  {
    code: ["1F38E"],
    emoji: "🎎",
    name: "Japanese dolls",
    category: "Activities",
    subcategory: "event",
  },
  {
    code: ["1F38F"],
    emoji: "🎏",
    name: "carp streamer",
    category: "Activities",
    subcategory: "event",
  },
  {
    code: ["1F390"],
    emoji: "🎐",
    name: "wind chime",
    category: "Activities",
    subcategory: "event",
  },
  {
    code: ["1F391"],
    emoji: "🎑",
    name: "moon viewing ceremony",
    category: "Activities",
    subcategory: "event",
  },
  {
    code: ["1F9E7"],
    emoji: "🧧",
    name: "red envelope",
    category: "Activities",
    subcategory: "event",
  },
  {
    code: ["1F380"],
    emoji: "🎀",
    name: "ribbon",
    category: "Activities",
    subcategory: "event",
  },
  {
    code: ["1F381"],
    emoji: "🎁",
    name: "wrapped gift",
    category: "Activities",
    subcategory: "event",
  },
  {
    code: ["1F397"],
    emoji: "🎗",
    name: "reminder ribbon",
    category: "Activities",
    subcategory: "event",
  },
  {
    code: ["1F39F"],
    emoji: "🎟",
    name: "admission tickets",
    category: "Activities",
    subcategory: "event",
  },
  {
    code: ["1F3AB"],
    emoji: "🎫",
    name: "ticket",
    category: "Activities",
    subcategory: "event",
  },
  {
    code: ["1F396"],
    emoji: "🎖",
    name: "military medal",
    category: "Activities",
    subcategory: "award-medal",
  },
  {
    code: ["1F3C6"],
    emoji: "🏆",
    name: "trophy",
    category: "Activities",
    subcategory: "award-medal",
  },
  {
    code: ["1F3C5"],
    emoji: "🏅",
    name: "sports medal",
    category: "Activities",
    subcategory: "award-medal",
  },
  {
    code: ["1F947"],
    emoji: "🥇",
    name: "1st place medal",
    category: "Activities",
    subcategory: "award-medal",
  },
  {
    code: ["1F948"],
    emoji: "🥈",
    name: "2nd place medal",
    category: "Activities",
    subcategory: "award-medal",
  },
  {
    code: ["1F949"],
    emoji: "🥉",
    name: "3rd place medal",
    category: "Activities",
    subcategory: "award-medal",
  },
  {
    code: ["26BD"],
    emoji: "⚽",
    name: "soccer ball",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["26BE"],
    emoji: "⚾",
    name: "baseball",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F94E"],
    emoji: "🥎",
    name: "softball",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F3C0"],
    emoji: "🏀",
    name: "basketball",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F3D0"],
    emoji: "🏐",
    name: "volleyball",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F3C8"],
    emoji: "🏈",
    name: "american football",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F3C9"],
    emoji: "🏉",
    name: "rugby football",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F3BE"],
    emoji: "🎾",
    name: "tennis",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F94F"],
    emoji: "🥏",
    name: "flying disc",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F3B3"],
    emoji: "🎳",
    name: "bowling",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F3CF"],
    emoji: "🏏",
    name: "cricket game",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F3D1"],
    emoji: "🏑",
    name: "field hockey",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F3D2"],
    emoji: "🏒",
    name: "ice hockey",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F94D"],
    emoji: "🥍",
    name: "lacrosse",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F3D3"],
    emoji: "🏓",
    name: "ping pong",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F3F8"],
    emoji: "🏸",
    name: "badminton",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F94A"],
    emoji: "🥊",
    name: "boxing glove",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F94B"],
    emoji: "🥋",
    name: "martial arts uniform",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F945"],
    emoji: "🥅",
    name: "goal net",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["26F3"],
    emoji: "⛳",
    name: "flag in hole",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["26F8"],
    emoji: "⛸",
    name: "ice skate",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F3A3"],
    emoji: "🎣",
    name: "fishing pole",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F93F"],
    emoji: "🤿",
    name: "diving mask",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F3BD"],
    emoji: "🎽",
    name: "running shirt",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F3BF"],
    emoji: "🎿",
    name: "skis",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F6F7"],
    emoji: "🛷",
    name: "sled",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F94C"],
    emoji: "🥌",
    name: "curling stone",
    category: "Activities",
    subcategory: "sport",
  },
  {
    code: ["1F3AF"],
    emoji: "🎯",
    name: "bullseye",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["1FA80"],
    emoji: "🪀",
    name: "yo-yo",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["1FA81"],
    emoji: "🪁",
    name: "kite",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["1F52B"],
    emoji: "🔫",
    name: "water pistol",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["1F3B1"],
    emoji: "🎱",
    name: "pool 8 ball",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["1F52E"],
    emoji: "🔮",
    name: "crystal ball",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["1FA84"],
    emoji: "🪄",
    name: "magic wand",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["1F3AE"],
    emoji: "🎮",
    name: "video game",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["1F579"],
    emoji: "🕹",
    name: "joystick",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["1F3B0"],
    emoji: "🎰",
    name: "slot machine",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["1F3B2"],
    emoji: "🎲",
    name: "game die",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["1F9E9"],
    emoji: "🧩",
    name: "puzzle piece",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["1F9F8"],
    emoji: "🧸",
    name: "teddy bear",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["1FA85"],
    emoji: "🪅",
    name: "piñata",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["1FAA9"],
    emoji: "🪩",
    name: "mirror ball",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["1FA86"],
    emoji: "🪆",
    name: "nesting dolls",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["2660"],
    emoji: "♠",
    name: "spade suit",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["2665"],
    emoji: "♥",
    name: "heart suit",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["2666"],
    emoji: "♦",
    name: "diamond suit",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["2663"],
    emoji: "♣",
    name: "club suit",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["265F"],
    emoji: "♟",
    name: "chess pawn",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["1F0CF"],
    emoji: "🃏",
    name: "joker",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["1F004"],
    emoji: "🀄",
    name: "mahjong red dragon",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["1F3B4"],
    emoji: "🎴",
    name: "flower playing cards",
    category: "Activities",
    subcategory: "game",
  },
  {
    code: ["1F3AD"],
    emoji: "🎭",
    name: "performing arts",
    category: "Activities",
    subcategory: "arts & crafts",
  },
  {
    code: ["1F5BC"],
    emoji: "🖼",
    name: "framed picture",
    category: "Activities",
    subcategory: "arts & crafts",
  },
  {
    code: ["1F3A8"],
    emoji: "🎨",
    name: "artist palette",
    category: "Activities",
    subcategory: "arts & crafts",
  },
  {
    code: ["1F9F5"],
    emoji: "🧵",
    name: "thread",
    category: "Activities",
    subcategory: "arts & crafts",
  },
  {
    code: ["1FAA1"],
    emoji: "🪡",
    name: "sewing needle",
    category: "Activities",
    subcategory: "arts & crafts",
  },
  {
    code: ["1F9F6"],
    emoji: "🧶",
    name: "yarn",
    category: "Activities",
    subcategory: "arts & crafts",
  },
  {
    code: ["1FAA2"],
    emoji: "🪢",
    name: "knot",
    category: "Activities",
    subcategory: "arts & crafts",
  },
  {
    code: ["1F453"],
    emoji: "👓",
    name: "glasses",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F576"],
    emoji: "🕶",
    name: "sunglasses",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F97D"],
    emoji: "🥽",
    name: "goggles",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F97C"],
    emoji: "🥼",
    name: "lab coat",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F9BA"],
    emoji: "🦺",
    name: "safety vest",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F454"],
    emoji: "👔",
    name: "necktie",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F455"],
    emoji: "👕",
    name: "t-shirt",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F456"],
    emoji: "👖",
    name: "jeans",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F9E3"],
    emoji: "🧣",
    name: "scarf",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F9E4"],
    emoji: "🧤",
    name: "gloves",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F9E5"],
    emoji: "🧥",
    name: "coat",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F9E6"],
    emoji: "🧦",
    name: "socks",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F457"],
    emoji: "👗",
    name: "dress",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F458"],
    emoji: "👘",
    name: "kimono",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F97B"],
    emoji: "🥻",
    name: "sari",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1FA71"],
    emoji: "🩱",
    name: "one-piece swimsuit",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1FA72"],
    emoji: "🩲",
    name: "briefs",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1FA73"],
    emoji: "🩳",
    name: "shorts",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F459"],
    emoji: "👙",
    name: "bikini",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F45A"],
    emoji: "👚",
    name: "woman’s clothes",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1FAAD"],
    emoji: "🪭",
    name: "folding hand fan",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F45B"],
    emoji: "👛",
    name: "purse",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F45C"],
    emoji: "👜",
    name: "handbag",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F45D"],
    emoji: "👝",
    name: "clutch bag",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F6CD"],
    emoji: "🛍",
    name: "shopping bags",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F392"],
    emoji: "🎒",
    name: "backpack",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1FA74"],
    emoji: "🩴",
    name: "thong sandal",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F45E"],
    emoji: "👞",
    name: "man’s shoe",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F45F"],
    emoji: "👟",
    name: "running shoe",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F97E"],
    emoji: "🥾",
    name: "hiking boot",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F97F"],
    emoji: "🥿",
    name: "flat shoe",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F460"],
    emoji: "👠",
    name: "high-heeled shoe",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F461"],
    emoji: "👡",
    name: "woman’s sandal",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1FA70"],
    emoji: "🩰",
    name: "ballet shoes",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F462"],
    emoji: "👢",
    name: "woman’s boot",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1FAAE"],
    emoji: "🪮",
    name: "hair pick",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F451"],
    emoji: "👑",
    name: "crown",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F452"],
    emoji: "👒",
    name: "woman’s hat",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F3A9"],
    emoji: "🎩",
    name: "top hat",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F393"],
    emoji: "🎓",
    name: "graduation cap",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F9E2"],
    emoji: "🧢",
    name: "billed cap",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1FA96"],
    emoji: "🪖",
    name: "military helmet",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["26D1"],
    emoji: "⛑",
    name: "rescue worker’s helmet",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F4FF"],
    emoji: "📿",
    name: "prayer beads",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F484"],
    emoji: "💄",
    name: "lipstick",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F48D"],
    emoji: "💍",
    name: "ring",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F48E"],
    emoji: "💎",
    name: "gem stone",
    category: "Objects",
    subcategory: "clothing",
  },
  {
    code: ["1F507"],
    emoji: "🔇",
    name: "muted speaker",
    category: "Objects",
    subcategory: "sound",
  },
  {
    code: ["1F508"],
    emoji: "🔈",
    name: "speaker low volume",
    category: "Objects",
    subcategory: "sound",
  },
  {
    code: ["1F509"],
    emoji: "🔉",
    name: "speaker medium volume",
    category: "Objects",
    subcategory: "sound",
  },
  {
    code: ["1F50A"],
    emoji: "🔊",
    name: "speaker high volume",
    category: "Objects",
    subcategory: "sound",
  },
  {
    code: ["1F4E2"],
    emoji: "📢",
    name: "loudspeaker",
    category: "Objects",
    subcategory: "sound",
  },
  {
    code: ["1F4E3"],
    emoji: "📣",
    name: "megaphone",
    category: "Objects",
    subcategory: "sound",
  },
  {
    code: ["1F4EF"],
    emoji: "📯",
    name: "postal horn",
    category: "Objects",
    subcategory: "sound",
  },
  {
    code: ["1F514"],
    emoji: "🔔",
    name: "bell",
    category: "Objects",
    subcategory: "sound",
  },
  {
    code: ["1F515"],
    emoji: "🔕",
    name: "bell with slash",
    category: "Objects",
    subcategory: "sound",
  },
  {
    code: ["1F3BC"],
    emoji: "🎼",
    name: "musical score",
    category: "Objects",
    subcategory: "music",
  },
  {
    code: ["1F3B5"],
    emoji: "🎵",
    name: "musical note",
    category: "Objects",
    subcategory: "music",
  },
  {
    code: ["1F3B6"],
    emoji: "🎶",
    name: "musical notes",
    category: "Objects",
    subcategory: "music",
  },
  {
    code: ["1F399"],
    emoji: "🎙",
    name: "studio microphone",
    category: "Objects",
    subcategory: "music",
  },
  {
    code: ["1F39A"],
    emoji: "🎚",
    name: "level slider",
    category: "Objects",
    subcategory: "music",
  },
  {
    code: ["1F39B"],
    emoji: "🎛",
    name: "control knobs",
    category: "Objects",
    subcategory: "music",
  },
  {
    code: ["1F3A4"],
    emoji: "🎤",
    name: "microphone",
    category: "Objects",
    subcategory: "music",
  },
  {
    code: ["1F3A7"],
    emoji: "🎧",
    name: "headphone",
    category: "Objects",
    subcategory: "music",
  },
  {
    code: ["1F4FB"],
    emoji: "📻",
    name: "radio",
    category: "Objects",
    subcategory: "music",
  },
  {
    code: ["1F3B7"],
    emoji: "🎷",
    name: "saxophone",
    category: "Objects",
    subcategory: "musical-instrument",
  },
  {
    code: ["1FA97"],
    emoji: "🪗",
    name: "accordion",
    category: "Objects",
    subcategory: "musical-instrument",
  },
  {
    code: ["1F3B8"],
    emoji: "🎸",
    name: "guitar",
    category: "Objects",
    subcategory: "musical-instrument",
  },
  {
    code: ["1F3B9"],
    emoji: "🎹",
    name: "musical keyboard",
    category: "Objects",
    subcategory: "musical-instrument",
  },
  {
    code: ["1F3BA"],
    emoji: "🎺",
    name: "trumpet",
    category: "Objects",
    subcategory: "musical-instrument",
  },
  {
    code: ["1F3BB"],
    emoji: "🎻",
    name: "violin",
    category: "Objects",
    subcategory: "musical-instrument",
  },
  {
    code: ["1FA95"],
    emoji: "🪕",
    name: "banjo",
    category: "Objects",
    subcategory: "musical-instrument",
  },
  {
    code: ["1F941"],
    emoji: "🥁",
    name: "drum",
    category: "Objects",
    subcategory: "musical-instrument",
  },
  {
    code: ["1FA98"],
    emoji: "🪘",
    name: "long drum",
    category: "Objects",
    subcategory: "musical-instrument",
  },
  {
    code: ["1FA87"],
    emoji: "🪇",
    name: "maracas",
    category: "Objects",
    subcategory: "musical-instrument",
  },
  {
    code: ["1FA88"],
    emoji: "🪈",
    name: "flute",
    category: "Objects",
    subcategory: "musical-instrument",
  },
  {
    code: ["1FA89"],
    emoji: "🪉",
    name: "harp",
    category: "Objects",
    subcategory: "musical-instrument",
  },
  {
    code: ["1F4F1"],
    emoji: "📱",
    name: "mobile phone",
    category: "Objects",
    subcategory: "phone",
  },
  {
    code: ["1F4F2"],
    emoji: "📲",
    name: "mobile phone with arrow",
    category: "Objects",
    subcategory: "phone",
  },
  {
    code: ["260E"],
    emoji: "☎",
    name: "telephone",
    category: "Objects",
    subcategory: "phone",
  },
  {
    code: ["1F4DE"],
    emoji: "📞",
    name: "telephone receiver",
    category: "Objects",
    subcategory: "phone",
  },
  {
    code: ["1F4DF"],
    emoji: "📟",
    name: "pager",
    category: "Objects",
    subcategory: "phone",
  },
  {
    code: ["1F4E0"],
    emoji: "📠",
    name: "fax machine",
    category: "Objects",
    subcategory: "phone",
  },
  {
    code: ["1F50B"],
    emoji: "🔋",
    name: "battery",
    category: "Objects",
    subcategory: "computer",
  },
  {
    code: ["1FAAB"],
    emoji: "🪫",
    name: "low battery",
    category: "Objects",
    subcategory: "computer",
  },
  {
    code: ["1F50C"],
    emoji: "🔌",
    name: "electric plug",
    category: "Objects",
    subcategory: "computer",
  },
  {
    code: ["1F4BB"],
    emoji: "💻",
    name: "laptop",
    category: "Objects",
    subcategory: "computer",
  },
  {
    code: ["1F5A5"],
    emoji: "🖥",
    name: "desktop computer",
    category: "Objects",
    subcategory: "computer",
  },
  {
    code: ["1F5A8"],
    emoji: "🖨",
    name: "printer",
    category: "Objects",
    subcategory: "computer",
  },
  {
    code: ["2328"],
    emoji: "⌨",
    name: "keyboard",
    category: "Objects",
    subcategory: "computer",
  },
  {
    code: ["1F5B1"],
    emoji: "🖱",
    name: "computer mouse",
    category: "Objects",
    subcategory: "computer",
  },
  {
    code: ["1F5B2"],
    emoji: "🖲",
    name: "trackball",
    category: "Objects",
    subcategory: "computer",
  },
  {
    code: ["1F4BD"],
    emoji: "💽",
    name: "computer disk",
    category: "Objects",
    subcategory: "computer",
  },
  {
    code: ["1F4BE"],
    emoji: "💾",
    name: "floppy disk",
    category: "Objects",
    subcategory: "computer",
  },
  {
    code: ["1F4BF"],
    emoji: "💿",
    name: "optical disk",
    category: "Objects",
    subcategory: "computer",
  },
  {
    code: ["1F4C0"],
    emoji: "📀",
    name: "dvd",
    category: "Objects",
    subcategory: "computer",
  },
  {
    code: ["1F9EE"],
    emoji: "🧮",
    name: "abacus",
    category: "Objects",
    subcategory: "computer",
  },
  {
    code: ["1F3A5"],
    emoji: "🎥",
    name: "movie camera",
    category: "Objects",
    subcategory: "light & video",
  },
  {
    code: ["1F39E"],
    emoji: "🎞",
    name: "film frames",
    category: "Objects",
    subcategory: "light & video",
  },
  {
    code: ["1F4FD"],
    emoji: "📽",
    name: "film projector",
    category: "Objects",
    subcategory: "light & video",
  },
  {
    code: ["1F3AC"],
    emoji: "🎬",
    name: "clapper board",
    category: "Objects",
    subcategory: "light & video",
  },
  {
    code: ["1F4FA"],
    emoji: "📺",
    name: "television",
    category: "Objects",
    subcategory: "light & video",
  },
  {
    code: ["1F4F7"],
    emoji: "📷",
    name: "camera",
    category: "Objects",
    subcategory: "light & video",
  },
  {
    code: ["1F4F8"],
    emoji: "📸",
    name: "camera with flash",
    category: "Objects",
    subcategory: "light & video",
  },
  {
    code: ["1F4F9"],
    emoji: "📹",
    name: "video camera",
    category: "Objects",
    subcategory: "light & video",
  },
  {
    code: ["1F4FC"],
    emoji: "📼",
    name: "videocassette",
    category: "Objects",
    subcategory: "light & video",
  },
  {
    code: ["1F50D"],
    emoji: "🔍",
    name: "magnifying glass tilted left",
    category: "Objects",
    subcategory: "light & video",
  },
  {
    code: ["1F50E"],
    emoji: "🔎",
    name: "magnifying glass tilted right",
    category: "Objects",
    subcategory: "light & video",
  },
  {
    code: ["1F56F"],
    emoji: "🕯",
    name: "candle",
    category: "Objects",
    subcategory: "light & video",
  },
  {
    code: ["1F4A1"],
    emoji: "💡",
    name: "light bulb",
    category: "Objects",
    subcategory: "light & video",
  },
  {
    code: ["1F526"],
    emoji: "🔦",
    name: "flashlight",
    category: "Objects",
    subcategory: "light & video",
  },
  {
    code: ["1F3EE"],
    emoji: "🏮",
    name: "red paper lantern",
    category: "Objects",
    subcategory: "light & video",
  },
  {
    code: ["1FA94"],
    emoji: "🪔",
    name: "diya lamp",
    category: "Objects",
    subcategory: "light & video",
  },
  {
    code: ["1F4D4"],
    emoji: "📔",
    name: "notebook with decorative cover",
    category: "Objects",
    subcategory: "book-paper",
  },
  {
    code: ["1F4D5"],
    emoji: "📕",
    name: "closed book",
    category: "Objects",
    subcategory: "book-paper",
  },
  {
    code: ["1F4D6"],
    emoji: "📖",
    name: "open book",
    category: "Objects",
    subcategory: "book-paper",
  },
  {
    code: ["1F4D7"],
    emoji: "📗",
    name: "green book",
    category: "Objects",
    subcategory: "book-paper",
  },
  {
    code: ["1F4D8"],
    emoji: "📘",
    name: "blue book",
    category: "Objects",
    subcategory: "book-paper",
  },
  {
    code: ["1F4D9"],
    emoji: "📙",
    name: "orange book",
    category: "Objects",
    subcategory: "book-paper",
  },
  {
    code: ["1F4DA"],
    emoji: "📚",
    name: "books",
    category: "Objects",
    subcategory: "book-paper",
  },
  {
    code: ["1F4D3"],
    emoji: "📓",
    name: "notebook",
    category: "Objects",
    subcategory: "book-paper",
  },
  {
    code: ["1F4D2"],
    emoji: "📒",
    name: "ledger",
    category: "Objects",
    subcategory: "book-paper",
  },
  {
    code: ["1F4C3"],
    emoji: "📃",
    name: "page with curl",
    category: "Objects",
    subcategory: "book-paper",
  },
  {
    code: ["1F4DC"],
    emoji: "📜",
    name: "scroll",
    category: "Objects",
    subcategory: "book-paper",
  },
  {
    code: ["1F4C4"],
    emoji: "📄",
    name: "page facing up",
    category: "Objects",
    subcategory: "book-paper",
  },
  {
    code: ["1F4F0"],
    emoji: "📰",
    name: "newspaper",
    category: "Objects",
    subcategory: "book-paper",
  },
  {
    code: ["1F5DE"],
    emoji: "🗞",
    name: "rolled-up newspaper",
    category: "Objects",
    subcategory: "book-paper",
  },
  {
    code: ["1F4D1"],
    emoji: "📑",
    name: "bookmark tabs",
    category: "Objects",
    subcategory: "book-paper",
  },
  {
    code: ["1F516"],
    emoji: "🔖",
    name: "bookmark",
    category: "Objects",
    subcategory: "book-paper",
  },
  {
    code: ["1F3F7"],
    emoji: "🏷",
    name: "label",
    category: "Objects",
    subcategory: "book-paper",
  },
  {
    code: ["1F4B0"],
    emoji: "💰",
    name: "money bag",
    category: "Objects",
    subcategory: "money",
  },
  {
    code: ["1FA99"],
    emoji: "🪙",
    name: "coin",
    category: "Objects",
    subcategory: "money",
  },
  {
    code: ["1F4B4"],
    emoji: "💴",
    name: "yen banknote",
    category: "Objects",
    subcategory: "money",
  },
  {
    code: ["1F4B5"],
    emoji: "💵",
    name: "dollar banknote",
    category: "Objects",
    subcategory: "money",
  },
  {
    code: ["1F4B6"],
    emoji: "💶",
    name: "euro banknote",
    category: "Objects",
    subcategory: "money",
  },
  {
    code: ["1F4B7"],
    emoji: "💷",
    name: "pound banknote",
    category: "Objects",
    subcategory: "money",
  },
  {
    code: ["1F4B8"],
    emoji: "💸",
    name: "money with wings",
    category: "Objects",
    subcategory: "money",
  },
  {
    code: ["1F4B3"],
    emoji: "💳",
    name: "credit card",
    category: "Objects",
    subcategory: "money",
  },
  {
    code: ["1F9FE"],
    emoji: "🧾",
    name: "receipt",
    category: "Objects",
    subcategory: "money",
  },
  {
    code: ["1F4B9"],
    emoji: "💹",
    name: "chart increasing with yen",
    category: "Objects",
    subcategory: "money",
  },
  {
    code: ["2709"],
    emoji: "✉",
    name: "envelope",
    category: "Objects",
    subcategory: "mail",
  },
  {
    code: ["1F4E7"],
    emoji: "📧",
    name: "e-mail",
    category: "Objects",
    subcategory: "mail",
  },
  {
    code: ["1F4E8"],
    emoji: "📨",
    name: "incoming envelope",
    category: "Objects",
    subcategory: "mail",
  },
  {
    code: ["1F4E9"],
    emoji: "📩",
    name: "envelope with arrow",
    category: "Objects",
    subcategory: "mail",
  },
  {
    code: ["1F4E4"],
    emoji: "📤",
    name: "outbox tray",
    category: "Objects",
    subcategory: "mail",
  },
  {
    code: ["1F4E5"],
    emoji: "📥",
    name: "inbox tray",
    category: "Objects",
    subcategory: "mail",
  },
  {
    code: ["1F4E6"],
    emoji: "📦",
    name: "package",
    category: "Objects",
    subcategory: "mail",
  },
  {
    code: ["1F4EB"],
    emoji: "📫",
    name: "closed mailbox with raised flag",
    category: "Objects",
    subcategory: "mail",
  },
  {
    code: ["1F4EA"],
    emoji: "📪",
    name: "closed mailbox with lowered flag",
    category: "Objects",
    subcategory: "mail",
  },
  {
    code: ["1F4EC"],
    emoji: "📬",
    name: "open mailbox with raised flag",
    category: "Objects",
    subcategory: "mail",
  },
  {
    code: ["1F4ED"],
    emoji: "📭",
    name: "open mailbox with lowered flag",
    category: "Objects",
    subcategory: "mail",
  },
  {
    code: ["1F4EE"],
    emoji: "📮",
    name: "postbox",
    category: "Objects",
    subcategory: "mail",
  },
  {
    code: ["1F5F3"],
    emoji: "🗳",
    name: "ballot box with ballot",
    category: "Objects",
    subcategory: "mail",
  },
  {
    code: ["270F"],
    emoji: "✏",
    name: "pencil",
    category: "Objects",
    subcategory: "writing",
  },
  {
    code: ["2712"],
    emoji: "✒",
    name: "black nib",
    category: "Objects",
    subcategory: "writing",
  },
  {
    code: ["1F58B"],
    emoji: "🖋",
    name: "fountain pen",
    category: "Objects",
    subcategory: "writing",
  },
  {
    code: ["1F58A"],
    emoji: "🖊",
    name: "pen",
    category: "Objects",
    subcategory: "writing",
  },
  {
    code: ["1F58C"],
    emoji: "🖌",
    name: "paintbrush",
    category: "Objects",
    subcategory: "writing",
  },
  {
    code: ["1F58D"],
    emoji: "🖍",
    name: "crayon",
    category: "Objects",
    subcategory: "writing",
  },
  {
    code: ["1F4DD"],
    emoji: "📝",
    name: "memo",
    category: "Objects",
    subcategory: "writing",
  },
  {
    code: ["1F4BC"],
    emoji: "💼",
    name: "briefcase",
    category: "Objects",
    subcategory: "office",
  },
  {
    code: ["1F4C1"],
    emoji: "📁",
    name: "file folder",
    category: "Objects",
    subcategory: "office",
  },
  {
    code: ["1F4C2"],
    emoji: "📂",
    name: "open file folder",
    category: "Objects",
    subcategory: "office",
  },
  {
    code: ["1F5C2"],
    emoji: "🗂",
    name: "card index dividers",
    category: "Objects",
    subcategory: "office",
  },
  {
    code: ["1F4C5"],
    emoji: "📅",
    name: "calendar",
    category: "Objects",
    subcategory: "office",
  },
  {
    code: ["1F4C6"],
    emoji: "📆",
    name: "tear-off calendar",
    category: "Objects",
    subcategory: "office",
  },
  {
    code: ["1F5D2"],
    emoji: "🗒",
    name: "spiral notepad",
    category: "Objects",
    subcategory: "office",
  },
  {
    code: ["1F5D3"],
    emoji: "🗓",
    name: "spiral calendar",
    category: "Objects",
    subcategory: "office",
  },
  {
    code: ["1F4C7"],
    emoji: "📇",
    name: "card index",
    category: "Objects",
    subcategory: "office",
  },
  {
    code: ["1F4C8"],
    emoji: "📈",
    name: "chart increasing",
    category: "Objects",
    subcategory: "office",
  },
  {
    code: ["1F4C9"],
    emoji: "📉",
    name: "chart decreasing",
    category: "Objects",
    subcategory: "office",
  },
  {
    code: ["1F4CA"],
    emoji: "📊",
    name: "bar chart",
    category: "Objects",
    subcategory: "office",
  },
  {
    code: ["1F4CB"],
    emoji: "📋",
    name: "clipboard",
    category: "Objects",
    subcategory: "office",
  },
  {
    code: ["1F4CC"],
    emoji: "📌",
    name: "pushpin",
    category: "Objects",
    subcategory: "office",
  },
  {
    code: ["1F4CD"],
    emoji: "📍",
    name: "round pushpin",
    category: "Objects",
    subcategory: "office",
  },
  {
    code: ["1F4CE"],
    emoji: "📎",
    name: "paperclip",
    category: "Objects",
    subcategory: "office",
  },
  {
    code: ["1F587"],
    emoji: "🖇",
    name: "linked paperclips",
    category: "Objects",
    subcategory: "office",
  },
  {
    code: ["1F4CF"],
    emoji: "📏",
    name: "straight ruler",
    category: "Objects",
    subcategory: "office",
  },
  {
    code: ["1F4D0"],
    emoji: "📐",
    name: "triangular ruler",
    category: "Objects",
    subcategory: "office",
  },
  {
    code: ["2702"],
    emoji: "✂",
    name: "scissors",
    category: "Objects",
    subcategory: "office",
  },
  {
    code: ["1F5C3"],
    emoji: "🗃",
    name: "card file box",
    category: "Objects",
    subcategory: "office",
  },
  {
    code: ["1F5C4"],
    emoji: "🗄",
    name: "file cabinet",
    category: "Objects",
    subcategory: "office",
  },
  {
    code: ["1F5D1"],
    emoji: "🗑",
    name: "wastebasket",
    category: "Objects",
    subcategory: "office",
  },
  {
    code: ["1F512"],
    emoji: "🔒",
    name: "locked",
    category: "Objects",
    subcategory: "lock",
  },
  {
    code: ["1F513"],
    emoji: "🔓",
    name: "unlocked",
    category: "Objects",
    subcategory: "lock",
  },
  {
    code: ["1F50F"],
    emoji: "🔏",
    name: "locked with pen",
    category: "Objects",
    subcategory: "lock",
  },
  {
    code: ["1F510"],
    emoji: "🔐",
    name: "locked with key",
    category: "Objects",
    subcategory: "lock",
  },
  {
    code: ["1F511"],
    emoji: "🔑",
    name: "key",
    category: "Objects",
    subcategory: "lock",
  },
  {
    code: ["1F5DD"],
    emoji: "🗝",
    name: "old key",
    category: "Objects",
    subcategory: "lock",
  },
  {
    code: ["1F528"],
    emoji: "🔨",
    name: "hammer",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["1FA93"],
    emoji: "🪓",
    name: "axe",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["26CF"],
    emoji: "⛏",
    name: "pick",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["2692"],
    emoji: "⚒",
    name: "hammer and pick",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["1F6E0"],
    emoji: "🛠",
    name: "hammer and wrench",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["1F5E1"],
    emoji: "🗡",
    name: "dagger",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["2694"],
    emoji: "⚔",
    name: "crossed swords",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["1F4A3"],
    emoji: "💣",
    name: "bomb",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["1FA83"],
    emoji: "🪃",
    name: "boomerang",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["1F3F9"],
    emoji: "🏹",
    name: "bow and arrow",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["1F6E1"],
    emoji: "🛡",
    name: "shield",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["1FA9A"],
    emoji: "🪚",
    name: "carpentry saw",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["1F527"],
    emoji: "🔧",
    name: "wrench",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["1FA9B"],
    emoji: "🪛",
    name: "screwdriver",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["1F529"],
    emoji: "🔩",
    name: "nut and bolt",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["2699"],
    emoji: "⚙",
    name: "gear",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["1F5DC"],
    emoji: "🗜",
    name: "clamp",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["2696"],
    emoji: "⚖",
    name: "balance scale",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["1F9AF"],
    emoji: "🦯",
    name: "white cane",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["1F517"],
    emoji: "🔗",
    name: "link",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["26D3", "FE0F", "200D", "1F4A5"],
    emoji: "⛓️‍💥",
    name: "broken chain",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["26D3"],
    emoji: "⛓",
    name: "chains",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["1FA9D"],
    emoji: "🪝",
    name: "hook",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["1F9F0"],
    emoji: "🧰",
    name: "toolbox",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["1F9F2"],
    emoji: "🧲",
    name: "magnet",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["1FA9C"],
    emoji: "🪜",
    name: "ladder",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["1FA8F"],
    emoji: "🪏",
    name: "shovel",
    category: "Objects",
    subcategory: "tool",
  },
  {
    code: ["2697"],
    emoji: "⚗",
    name: "alembic",
    category: "Objects",
    subcategory: "science",
  },
  {
    code: ["1F9EA"],
    emoji: "🧪",
    name: "test tube",
    category: "Objects",
    subcategory: "science",
  },
  {
    code: ["1F9EB"],
    emoji: "🧫",
    name: "petri dish",
    category: "Objects",
    subcategory: "science",
  },
  {
    code: ["1F9EC"],
    emoji: "🧬",
    name: "dna",
    category: "Objects",
    subcategory: "science",
  },
  {
    code: ["1F52C"],
    emoji: "🔬",
    name: "microscope",
    category: "Objects",
    subcategory: "science",
  },
  {
    code: ["1F52D"],
    emoji: "🔭",
    name: "telescope",
    category: "Objects",
    subcategory: "science",
  },
  {
    code: ["1F4E1"],
    emoji: "📡",
    name: "satellite antenna",
    category: "Objects",
    subcategory: "science",
  },
  {
    code: ["1F489"],
    emoji: "💉",
    name: "syringe",
    category: "Objects",
    subcategory: "medical",
  },
  {
    code: ["1FA78"],
    emoji: "🩸",
    name: "drop of blood",
    category: "Objects",
    subcategory: "medical",
  },
  {
    code: ["1F48A"],
    emoji: "💊",
    name: "pill",
    category: "Objects",
    subcategory: "medical",
  },
  {
    code: ["1FA79"],
    emoji: "🩹",
    name: "adhesive bandage",
    category: "Objects",
    subcategory: "medical",
  },
  {
    code: ["1FA7C"],
    emoji: "🩼",
    name: "crutch",
    category: "Objects",
    subcategory: "medical",
  },
  {
    code: ["1FA7A"],
    emoji: "🩺",
    name: "stethoscope",
    category: "Objects",
    subcategory: "medical",
  },
  {
    code: ["1FA7B"],
    emoji: "🩻",
    name: "x-ray",
    category: "Objects",
    subcategory: "medical",
  },
  {
    code: ["1F6AA"],
    emoji: "🚪",
    name: "door",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1F6D7"],
    emoji: "🛗",
    name: "elevator",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1FA9E"],
    emoji: "🪞",
    name: "mirror",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1FA9F"],
    emoji: "🪟",
    name: "window",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1F6CF"],
    emoji: "🛏",
    name: "bed",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1F6CB"],
    emoji: "🛋",
    name: "couch and lamp",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1FA91"],
    emoji: "🪑",
    name: "chair",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1F6BD"],
    emoji: "🚽",
    name: "toilet",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1FAA0"],
    emoji: "🪠",
    name: "plunger",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1F6BF"],
    emoji: "🚿",
    name: "shower",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1F6C1"],
    emoji: "🛁",
    name: "bathtub",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1FAA4"],
    emoji: "🪤",
    name: "mouse trap",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1FA92"],
    emoji: "🪒",
    name: "razor",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1F9F4"],
    emoji: "🧴",
    name: "lotion bottle",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1F9F7"],
    emoji: "🧷",
    name: "safety pin",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1F9F9"],
    emoji: "🧹",
    name: "broom",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1F9FA"],
    emoji: "🧺",
    name: "basket",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1F9FB"],
    emoji: "🧻",
    name: "roll of paper",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1FAA3"],
    emoji: "🪣",
    name: "bucket",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1F9FC"],
    emoji: "🧼",
    name: "soap",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1FAE7"],
    emoji: "🫧",
    name: "bubbles",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1FAA5"],
    emoji: "🪥",
    name: "toothbrush",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1F9FD"],
    emoji: "🧽",
    name: "sponge",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1F9EF"],
    emoji: "🧯",
    name: "fire extinguisher",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1F6D2"],
    emoji: "🛒",
    name: "shopping cart",
    category: "Objects",
    subcategory: "household",
  },
  {
    code: ["1F6AC"],
    emoji: "🚬",
    name: "cigarette",
    category: "Objects",
    subcategory: "other-object",
  },
  {
    code: ["26B0"],
    emoji: "⚰",
    name: "coffin",
    category: "Objects",
    subcategory: "other-object",
  },
  {
    code: ["1FAA6"],
    emoji: "🪦",
    name: "headstone",
    category: "Objects",
    subcategory: "other-object",
  },
  {
    code: ["26B1"],
    emoji: "⚱",
    name: "funeral urn",
    category: "Objects",
    subcategory: "other-object",
  },
  {
    code: ["1F9FF"],
    emoji: "🧿",
    name: "nazar amulet",
    category: "Objects",
    subcategory: "other-object",
  },
  {
    code: ["1FAAC"],
    emoji: "🪬",
    name: "hamsa",
    category: "Objects",
    subcategory: "other-object",
  },
  {
    code: ["1F5FF"],
    emoji: "🗿",
    name: "moai",
    category: "Objects",
    subcategory: "other-object",
  },
  {
    code: ["1FAA7"],
    emoji: "🪧",
    name: "placard",
    category: "Objects",
    subcategory: "other-object",
  },
  {
    code: ["1FAAA"],
    emoji: "🪪",
    name: "identification card",
    category: "Objects",
    subcategory: "other-object",
  },
  {
    code: ["1F3E7"],
    emoji: "🏧",
    name: "ATM sign",
    category: "Symbols",
    subcategory: "transport-sign",
  },
  {
    code: ["1F6AE"],
    emoji: "🚮",
    name: "litter in bin sign",
    category: "Symbols",
    subcategory: "transport-sign",
  },
  {
    code: ["1F6B0"],
    emoji: "🚰",
    name: "potable water",
    category: "Symbols",
    subcategory: "transport-sign",
  },
  {
    code: ["267F"],
    emoji: "♿",
    name: "wheelchair symbol",
    category: "Symbols",
    subcategory: "transport-sign",
  },
  {
    code: ["1F6B9"],
    emoji: "🚹",
    name: "men’s room",
    category: "Symbols",
    subcategory: "transport-sign",
  },
  {
    code: ["1F6BA"],
    emoji: "🚺",
    name: "women’s room",
    category: "Symbols",
    subcategory: "transport-sign",
  },
  {
    code: ["1F6BB"],
    emoji: "🚻",
    name: "restroom",
    category: "Symbols",
    subcategory: "transport-sign",
  },
  {
    code: ["1F6BC"],
    emoji: "🚼",
    name: "baby symbol",
    category: "Symbols",
    subcategory: "transport-sign",
  },
  {
    code: ["1F6BE"],
    emoji: "🚾",
    name: "water closet",
    category: "Symbols",
    subcategory: "transport-sign",
  },
  {
    code: ["1F6C2"],
    emoji: "🛂",
    name: "passport control",
    category: "Symbols",
    subcategory: "transport-sign",
  },
  {
    code: ["1F6C3"],
    emoji: "🛃",
    name: "customs",
    category: "Symbols",
    subcategory: "transport-sign",
  },
  {
    code: ["1F6C4"],
    emoji: "🛄",
    name: "baggage claim",
    category: "Symbols",
    subcategory: "transport-sign",
  },
  {
    code: ["1F6C5"],
    emoji: "🛅",
    name: "left luggage",
    category: "Symbols",
    subcategory: "transport-sign",
  },
  {
    code: ["26A0"],
    emoji: "⚠",
    name: "warning",
    category: "Symbols",
    subcategory: "warning",
  },
  {
    code: ["1F6B8"],
    emoji: "🚸",
    name: "children crossing",
    category: "Symbols",
    subcategory: "warning",
  },
  {
    code: ["26D4"],
    emoji: "⛔",
    name: "no entry",
    category: "Symbols",
    subcategory: "warning",
  },
  {
    code: ["1F6AB"],
    emoji: "🚫",
    name: "prohibited",
    category: "Symbols",
    subcategory: "warning",
  },
  {
    code: ["1F6B3"],
    emoji: "🚳",
    name: "no bicycles",
    category: "Symbols",
    subcategory: "warning",
  },
  {
    code: ["1F6AD"],
    emoji: "🚭",
    name: "no smoking",
    category: "Symbols",
    subcategory: "warning",
  },
  {
    code: ["1F6AF"],
    emoji: "🚯",
    name: "no littering",
    category: "Symbols",
    subcategory: "warning",
  },
  {
    code: ["1F6B1"],
    emoji: "🚱",
    name: "non-potable water",
    category: "Symbols",
    subcategory: "warning",
  },
  {
    code: ["1F6B7"],
    emoji: "🚷",
    name: "no pedestrians",
    category: "Symbols",
    subcategory: "warning",
  },
  {
    code: ["1F4F5"],
    emoji: "📵",
    name: "no mobile phones",
    category: "Symbols",
    subcategory: "warning",
  },
  {
    code: ["1F51E"],
    emoji: "🔞",
    name: "no one under eighteen",
    category: "Symbols",
    subcategory: "warning",
  },
  {
    code: ["2622"],
    emoji: "☢",
    name: "radioactive",
    category: "Symbols",
    subcategory: "warning",
  },
  {
    code: ["2623"],
    emoji: "☣",
    name: "biohazard",
    category: "Symbols",
    subcategory: "warning",
  },
  {
    code: ["2B06"],
    emoji: "⬆",
    name: "up arrow",
    category: "Symbols",
    subcategory: "arrow",
  },
  {
    code: ["2197"],
    emoji: "↗",
    name: "up-right arrow",
    category: "Symbols",
    subcategory: "arrow",
  },
  {
    code: ["27A1"],
    emoji: "➡",
    name: "right arrow",
    category: "Symbols",
    subcategory: "arrow",
  },
  {
    code: ["2198"],
    emoji: "↘",
    name: "down-right arrow",
    category: "Symbols",
    subcategory: "arrow",
  },
  {
    code: ["2B07"],
    emoji: "⬇",
    name: "down arrow",
    category: "Symbols",
    subcategory: "arrow",
  },
  {
    code: ["2199"],
    emoji: "↙",
    name: "down-left arrow",
    category: "Symbols",
    subcategory: "arrow",
  },
  {
    code: ["2B05"],
    emoji: "⬅",
    name: "left arrow",
    category: "Symbols",
    subcategory: "arrow",
  },
  {
    code: ["2196"],
    emoji: "↖",
    name: "up-left arrow",
    category: "Symbols",
    subcategory: "arrow",
  },
  {
    code: ["2195"],
    emoji: "↕",
    name: "up-down arrow",
    category: "Symbols",
    subcategory: "arrow",
  },
  {
    code: ["2194"],
    emoji: "↔",
    name: "left-right arrow",
    category: "Symbols",
    subcategory: "arrow",
  },
  {
    code: ["21A9"],
    emoji: "↩",
    name: "right arrow curving left",
    category: "Symbols",
    subcategory: "arrow",
  },
  {
    code: ["21AA"],
    emoji: "↪",
    name: "left arrow curving right",
    category: "Symbols",
    subcategory: "arrow",
  },
  {
    code: ["2934"],
    emoji: "⤴",
    name: "right arrow curving up",
    category: "Symbols",
    subcategory: "arrow",
  },
  {
    code: ["2935"],
    emoji: "⤵",
    name: "right arrow curving down",
    category: "Symbols",
    subcategory: "arrow",
  },
  {
    code: ["1F503"],
    emoji: "🔃",
    name: "clockwise vertical arrows",
    category: "Symbols",
    subcategory: "arrow",
  },
  {
    code: ["1F504"],
    emoji: "🔄",
    name: "counterclockwise arrows button",
    category: "Symbols",
    subcategory: "arrow",
  },
  {
    code: ["1F519"],
    emoji: "🔙",
    name: "BACK arrow",
    category: "Symbols",
    subcategory: "arrow",
  },
  {
    code: ["1F51A"],
    emoji: "🔚",
    name: "END arrow",
    category: "Symbols",
    subcategory: "arrow",
  },
  {
    code: ["1F51B"],
    emoji: "🔛",
    name: "ON! arrow",
    category: "Symbols",
    subcategory: "arrow",
  },
  {
    code: ["1F51C"],
    emoji: "🔜",
    name: "SOON arrow",
    category: "Symbols",
    subcategory: "arrow",
  },
  {
    code: ["1F51D"],
    emoji: "🔝",
    name: "TOP arrow",
    category: "Symbols",
    subcategory: "arrow",
  },
  {
    code: ["1F6D0"],
    emoji: "🛐",
    name: "place of worship",
    category: "Symbols",
    subcategory: "religion",
  },
  {
    code: ["269B"],
    emoji: "⚛",
    name: "atom symbol",
    category: "Symbols",
    subcategory: "religion",
  },
  {
    code: ["1F549"],
    emoji: "🕉",
    name: "om",
    category: "Symbols",
    subcategory: "religion",
  },
  {
    code: ["2721"],
    emoji: "✡",
    name: "star of David",
    category: "Symbols",
    subcategory: "religion",
  },
  {
    code: ["2638"],
    emoji: "☸",
    name: "wheel of dharma",
    category: "Symbols",
    subcategory: "religion",
  },
  {
    code: ["262F"],
    emoji: "☯",
    name: "yin yang",
    category: "Symbols",
    subcategory: "religion",
  },
  {
    code: ["271D"],
    emoji: "✝",
    name: "latin cross",
    category: "Symbols",
    subcategory: "religion",
  },
  {
    code: ["2626"],
    emoji: "☦",
    name: "orthodox cross",
    category: "Symbols",
    subcategory: "religion",
  },
  {
    code: ["262A"],
    emoji: "☪",
    name: "star and crescent",
    category: "Symbols",
    subcategory: "religion",
  },
  {
    code: ["262E"],
    emoji: "☮",
    name: "peace symbol",
    category: "Symbols",
    subcategory: "religion",
  },
  {
    code: ["1F54E"],
    emoji: "🕎",
    name: "menorah",
    category: "Symbols",
    subcategory: "religion",
  },
  {
    code: ["1F52F"],
    emoji: "🔯",
    name: "dotted six-pointed star",
    category: "Symbols",
    subcategory: "religion",
  },
  {
    code: ["1FAAF"],
    emoji: "🪯",
    name: "khanda",
    category: "Symbols",
    subcategory: "religion",
  },
  {
    code: ["2648"],
    emoji: "♈",
    name: "Aries",
    category: "Symbols",
    subcategory: "zodiac",
  },
  {
    code: ["2649"],
    emoji: "♉",
    name: "Taurus",
    category: "Symbols",
    subcategory: "zodiac",
  },
  {
    code: ["264A"],
    emoji: "♊",
    name: "Gemini",
    category: "Symbols",
    subcategory: "zodiac",
  },
  {
    code: ["264B"],
    emoji: "♋",
    name: "Cancer",
    category: "Symbols",
    subcategory: "zodiac",
  },
  {
    code: ["264C"],
    emoji: "♌",
    name: "Leo",
    category: "Symbols",
    subcategory: "zodiac",
  },
  {
    code: ["264D"],
    emoji: "♍",
    name: "Virgo",
    category: "Symbols",
    subcategory: "zodiac",
  },
  {
    code: ["264E"],
    emoji: "♎",
    name: "Libra",
    category: "Symbols",
    subcategory: "zodiac",
  },
  {
    code: ["264F"],
    emoji: "♏",
    name: "Scorpio",
    category: "Symbols",
    subcategory: "zodiac",
  },
  {
    code: ["2650"],
    emoji: "♐",
    name: "Sagittarius",
    category: "Symbols",
    subcategory: "zodiac",
  },
  {
    code: ["2651"],
    emoji: "♑",
    name: "Capricorn",
    category: "Symbols",
    subcategory: "zodiac",
  },
  {
    code: ["2652"],
    emoji: "♒",
    name: "Aquarius",
    category: "Symbols",
    subcategory: "zodiac",
  },
  {
    code: ["2653"],
    emoji: "♓",
    name: "Pisces",
    category: "Symbols",
    subcategory: "zodiac",
  },
  {
    code: ["26CE"],
    emoji: "⛎",
    name: "Ophiuchus",
    category: "Symbols",
    subcategory: "zodiac",
  },
  {
    code: ["1F500"],
    emoji: "🔀",
    name: "shuffle tracks button",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["1F501"],
    emoji: "🔁",
    name: "repeat button",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["1F502"],
    emoji: "🔂",
    name: "repeat single button",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["25B6"],
    emoji: "▶",
    name: "play button",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["23E9"],
    emoji: "⏩",
    name: "fast-forward button",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["23ED"],
    emoji: "⏭",
    name: "next track button",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["23EF"],
    emoji: "⏯",
    name: "play or pause button",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["25C0"],
    emoji: "◀",
    name: "reverse button",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["23EA"],
    emoji: "⏪",
    name: "fast reverse button",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["23EE"],
    emoji: "⏮",
    name: "last track button",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["1F53C"],
    emoji: "🔼",
    name: "upwards button",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["23EB"],
    emoji: "⏫",
    name: "fast up button",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["1F53D"],
    emoji: "🔽",
    name: "downwards button",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["23EC"],
    emoji: "⏬",
    name: "fast down button",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["23F8"],
    emoji: "⏸",
    name: "pause button",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["23F9"],
    emoji: "⏹",
    name: "stop button",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["23FA"],
    emoji: "⏺",
    name: "record button",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["23CF"],
    emoji: "⏏",
    name: "eject button",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["1F3A6"],
    emoji: "🎦",
    name: "cinema",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["1F505"],
    emoji: "🔅",
    name: "dim button",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["1F506"],
    emoji: "🔆",
    name: "bright button",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["1F4F6"],
    emoji: "📶",
    name: "antenna bars",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["1F6DC"],
    emoji: "🛜",
    name: "wireless",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["1F4F3"],
    emoji: "📳",
    name: "vibration mode",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["1F4F4"],
    emoji: "📴",
    name: "mobile phone off",
    category: "Symbols",
    subcategory: "av-symbol",
  },
  {
    code: ["2640"],
    emoji: "♀",
    name: "female sign",
    category: "Symbols",
    subcategory: "gender",
  },
  {
    code: ["2642"],
    emoji: "♂",
    name: "male sign",
    category: "Symbols",
    subcategory: "gender",
  },
  {
    code: ["26A7"],
    emoji: "⚧",
    name: "transgender symbol",
    category: "Symbols",
    subcategory: "gender",
  },
  {
    code: ["2716"],
    emoji: "✖",
    name: "multiply",
    category: "Symbols",
    subcategory: "math",
  },
  {
    code: ["2795"],
    emoji: "➕",
    name: "plus",
    category: "Symbols",
    subcategory: "math",
  },
  {
    code: ["2796"],
    emoji: "➖",
    name: "minus",
    category: "Symbols",
    subcategory: "math",
  },
  {
    code: ["2797"],
    emoji: "➗",
    name: "divide",
    category: "Symbols",
    subcategory: "math",
  },
  {
    code: ["1F7F0"],
    emoji: "🟰",
    name: "heavy equals sign",
    category: "Symbols",
    subcategory: "math",
  },
  {
    code: ["267E"],
    emoji: "♾",
    name: "infinity",
    category: "Symbols",
    subcategory: "math",
  },
  {
    code: ["203C"],
    emoji: "‼",
    name: "double exclamation mark",
    category: "Symbols",
    subcategory: "punctuation",
  },
  {
    code: ["2049"],
    emoji: "⁉",
    name: "exclamation question mark",
    category: "Symbols",
    subcategory: "punctuation",
  },
  {
    code: ["2753"],
    emoji: "❓",
    name: "red question mark",
    category: "Symbols",
    subcategory: "punctuation",
  },
  {
    code: ["2754"],
    emoji: "❔",
    name: "white question mark",
    category: "Symbols",
    subcategory: "punctuation",
  },
  {
    code: ["2755"],
    emoji: "❕",
    name: "white exclamation mark",
    category: "Symbols",
    subcategory: "punctuation",
  },
  {
    code: ["2757"],
    emoji: "❗",
    name: "red exclamation mark",
    category: "Symbols",
    subcategory: "punctuation",
  },
  {
    code: ["3030"],
    emoji: "〰",
    name: "wavy dash",
    category: "Symbols",
    subcategory: "punctuation",
  },
  {
    code: ["1F4B1"],
    emoji: "💱",
    name: "currency exchange",
    category: "Symbols",
    subcategory: "currency",
  },
  {
    code: ["1F4B2"],
    emoji: "💲",
    name: "heavy dollar sign",
    category: "Symbols",
    subcategory: "currency",
  },
  {
    code: ["2695"],
    emoji: "⚕",
    name: "medical symbol",
    category: "Symbols",
    subcategory: "other-symbol",
  },
  {
    code: ["267B"],
    emoji: "♻",
    name: "recycling symbol",
    category: "Symbols",
    subcategory: "other-symbol",
  },
  {
    code: ["269C"],
    emoji: "⚜",
    name: "fleur-de-lis",
    category: "Symbols",
    subcategory: "other-symbol",
  },
  {
    code: ["1F531"],
    emoji: "🔱",
    name: "trident emblem",
    category: "Symbols",
    subcategory: "other-symbol",
  },
  {
    code: ["1F4DB"],
    emoji: "📛",
    name: "name badge",
    category: "Symbols",
    subcategory: "other-symbol",
  },
  {
    code: ["1F530"],
    emoji: "🔰",
    name: "Japanese symbol for beginner",
    category: "Symbols",
    subcategory: "other-symbol",
  },
  {
    code: ["2B55"],
    emoji: "⭕",
    name: "hollow red circle",
    category: "Symbols",
    subcategory: "other-symbol",
  },
  {
    code: ["2705"],
    emoji: "✅",
    name: "check mark button",
    category: "Symbols",
    subcategory: "other-symbol",
  },
  {
    code: ["2611"],
    emoji: "☑",
    name: "check box with check",
    category: "Symbols",
    subcategory: "other-symbol",
  },
  {
    code: ["2714"],
    emoji: "✔",
    name: "check mark",
    category: "Symbols",
    subcategory: "other-symbol",
  },
  {
    code: ["274C"],
    emoji: "❌",
    name: "cross mark",
    category: "Symbols",
    subcategory: "other-symbol",
  },
  {
    code: ["274E"],
    emoji: "❎",
    name: "cross mark button",
    category: "Symbols",
    subcategory: "other-symbol",
  },
  {
    code: ["27B0"],
    emoji: "➰",
    name: "curly loop",
    category: "Symbols",
    subcategory: "other-symbol",
  },
  {
    code: ["27BF"],
    emoji: "➿",
    name: "double curly loop",
    category: "Symbols",
    subcategory: "other-symbol",
  },
  {
    code: ["303D"],
    emoji: "〽",
    name: "part alternation mark",
    category: "Symbols",
    subcategory: "other-symbol",
  },
  {
    code: ["2733"],
    emoji: "✳",
    name: "eight-spoked asterisk",
    category: "Symbols",
    subcategory: "other-symbol",
  },
  {
    code: ["2734"],
    emoji: "✴",
    name: "eight-pointed star",
    category: "Symbols",
    subcategory: "other-symbol",
  },
  {
    code: ["2747"],
    emoji: "❇",
    name: "sparkle",
    category: "Symbols",
    subcategory: "other-symbol",
  },
  {
    code: ["00A9"],
    emoji: "©",
    name: "copyright",
    category: "Symbols",
    subcategory: "other-symbol",
  },
  {
    code: ["00AE"],
    emoji: "®",
    name: "registered",
    category: "Symbols",
    subcategory: "other-symbol",
  },
  {
    code: ["2122"],
    emoji: "™",
    name: "trade mark",
    category: "Symbols",
    subcategory: "other-symbol",
  },
  {
    code: ["1FADF"],
    emoji: "🫟",
    name: "splatter",
    category: "Symbols",
    subcategory: "other-symbol",
  },
  {
    code: ["0023", "FE0F", "20E3"],
    emoji: "#️⃣",
    name: "keycap: #",
    category: "Symbols",
    subcategory: "keycap",
  },
  {
    code: ["002A", "FE0F", "20E3"],
    emoji: "*️⃣",
    name: "keycap: *",
    category: "Symbols",
    subcategory: "keycap",
  },
  {
    code: ["0030", "FE0F", "20E3"],
    emoji: "0️⃣",
    name: "keycap: 0",
    category: "Symbols",
    subcategory: "keycap",
  },
  {
    code: ["0031", "FE0F", "20E3"],
    emoji: "1️⃣",
    name: "keycap: 1",
    category: "Symbols",
    subcategory: "keycap",
  },
  {
    code: ["0032", "FE0F", "20E3"],
    emoji: "2️⃣",
    name: "keycap: 2",
    category: "Symbols",
    subcategory: "keycap",
  },
  {
    code: ["0033", "FE0F", "20E3"],
    emoji: "3️⃣",
    name: "keycap: 3",
    category: "Symbols",
    subcategory: "keycap",
  },
  {
    code: ["0034", "FE0F", "20E3"],
    emoji: "4️⃣",
    name: "keycap: 4",
    category: "Symbols",
    subcategory: "keycap",
  },
  {
    code: ["0035", "FE0F", "20E3"],
    emoji: "5️⃣",
    name: "keycap: 5",
    category: "Symbols",
    subcategory: "keycap",
  },
  {
    code: ["0036", "FE0F", "20E3"],
    emoji: "6️⃣",
    name: "keycap: 6",
    category: "Symbols",
    subcategory: "keycap",
  },
  {
    code: ["0037", "FE0F", "20E3"],
    emoji: "7️⃣",
    name: "keycap: 7",
    category: "Symbols",
    subcategory: "keycap",
  },
  {
    code: ["0038", "FE0F", "20E3"],
    emoji: "8️⃣",
    name: "keycap: 8",
    category: "Symbols",
    subcategory: "keycap",
  },
  {
    code: ["0039", "FE0F", "20E3"],
    emoji: "9️⃣",
    name: "keycap: 9",
    category: "Symbols",
    subcategory: "keycap",
  },
  {
    code: ["1F51F"],
    emoji: "🔟",
    name: "keycap: 10",
    category: "Symbols",
    subcategory: "keycap",
  },
  {
    code: ["1F520"],
    emoji: "🔠",
    name: "input latin uppercase",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F521"],
    emoji: "🔡",
    name: "input latin lowercase",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F522"],
    emoji: "🔢",
    name: "input numbers",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F523"],
    emoji: "🔣",
    name: "input symbols",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F524"],
    emoji: "🔤",
    name: "input latin letters",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F170"],
    emoji: "🅰",
    name: "A button (blood type)",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F18E"],
    emoji: "🆎",
    name: "AB button (blood type)",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F171"],
    emoji: "🅱",
    name: "B button (blood type)",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F191"],
    emoji: "🆑",
    name: "CL button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F192"],
    emoji: "🆒",
    name: "COOL button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F193"],
    emoji: "🆓",
    name: "FREE button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["2139"],
    emoji: "ℹ",
    name: "information",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F194"],
    emoji: "🆔",
    name: "ID button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["24C2"],
    emoji: "Ⓜ",
    name: "circled M",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F195"],
    emoji: "🆕",
    name: "NEW button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F196"],
    emoji: "🆖",
    name: "NG button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F17E"],
    emoji: "🅾",
    name: "O button (blood type)",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F197"],
    emoji: "🆗",
    name: "OK button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F17F"],
    emoji: "🅿",
    name: "P button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F198"],
    emoji: "🆘",
    name: "SOS button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F199"],
    emoji: "🆙",
    name: "UP! button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F19A"],
    emoji: "🆚",
    name: "VS button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F201"],
    emoji: "🈁",
    name: "Japanese “here” button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F202"],
    emoji: "🈂",
    name: "Japanese “service charge” button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F237"],
    emoji: "🈷",
    name: "Japanese “monthly amount” button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F236"],
    emoji: "🈶",
    name: "Japanese “not free of charge” button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F22F"],
    emoji: "🈯",
    name: "Japanese “reserved” button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F250"],
    emoji: "🉐",
    name: "Japanese “bargain” button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F239"],
    emoji: "🈹",
    name: "Japanese “discount” button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F21A"],
    emoji: "🈚",
    name: "Japanese “free of charge” button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F232"],
    emoji: "🈲",
    name: "Japanese “prohibited” button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F251"],
    emoji: "🉑",
    name: "Japanese “acceptable” button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F238"],
    emoji: "🈸",
    name: "Japanese “application” button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F234"],
    emoji: "🈴",
    name: "Japanese “passing grade” button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F233"],
    emoji: "🈳",
    name: "Japanese “vacancy” button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["3297"],
    emoji: "㊗",
    name: "Japanese “congratulations” button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["3299"],
    emoji: "㊙",
    name: "Japanese “secret” button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F23A"],
    emoji: "🈺",
    name: "Japanese “open for business” button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F235"],
    emoji: "🈵",
    name: "Japanese “no vacancy” button",
    category: "Symbols",
    subcategory: "alphanum",
  },
  {
    code: ["1F534"],
    emoji: "🔴",
    name: "red circle",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F7E0"],
    emoji: "🟠",
    name: "orange circle",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F7E1"],
    emoji: "🟡",
    name: "yellow circle",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F7E2"],
    emoji: "🟢",
    name: "green circle",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F535"],
    emoji: "🔵",
    name: "blue circle",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F7E3"],
    emoji: "🟣",
    name: "purple circle",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F7E4"],
    emoji: "🟤",
    name: "brown circle",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["26AB"],
    emoji: "⚫",
    name: "black circle",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["26AA"],
    emoji: "⚪",
    name: "white circle",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F7E5"],
    emoji: "🟥",
    name: "red square",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F7E7"],
    emoji: "🟧",
    name: "orange square",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F7E8"],
    emoji: "🟨",
    name: "yellow square",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F7E9"],
    emoji: "🟩",
    name: "green square",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F7E6"],
    emoji: "🟦",
    name: "blue square",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F7EA"],
    emoji: "🟪",
    name: "purple square",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F7EB"],
    emoji: "🟫",
    name: "brown square",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["2B1B"],
    emoji: "⬛",
    name: "black large square",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["2B1C"],
    emoji: "⬜",
    name: "white large square",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["25FC"],
    emoji: "◼",
    name: "black medium square",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["25FB"],
    emoji: "◻",
    name: "white medium square",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["25FE"],
    emoji: "◾",
    name: "black medium-small square",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["25FD"],
    emoji: "◽",
    name: "white medium-small square",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["25AA"],
    emoji: "▪",
    name: "black small square",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["25AB"],
    emoji: "▫",
    name: "white small square",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F536"],
    emoji: "🔶",
    name: "large orange diamond",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F537"],
    emoji: "🔷",
    name: "large blue diamond",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F538"],
    emoji: "🔸",
    name: "small orange diamond",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F539"],
    emoji: "🔹",
    name: "small blue diamond",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F53A"],
    emoji: "🔺",
    name: "red triangle pointed up",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F53B"],
    emoji: "🔻",
    name: "red triangle pointed down",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F4A0"],
    emoji: "💠",
    name: "diamond with a dot",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F518"],
    emoji: "🔘",
    name: "radio button",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F533"],
    emoji: "🔳",
    name: "white square button",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F532"],
    emoji: "🔲",
    name: "black square button",
    category: "Symbols",
    subcategory: "geometric",
  },
  {
    code: ["1F3C1"],
    emoji: "🏁",
    name: "chequered flag",
    category: "Flags",
    subcategory: "flag",
  },
  {
    code: ["1F6A9"],
    emoji: "🚩",
    name: "triangular flag",
    category: "Flags",
    subcategory: "flag",
  },
  {
    code: ["1F38C"],
    emoji: "🎌",
    name: "crossed flags",
    category: "Flags",
    subcategory: "flag",
  },
  {
    code: ["1F3F4"],
    emoji: "🏴",
    name: "black flag",
    category: "Flags",
    subcategory: "flag",
  },
  {
    code: ["1F3F3"],
    emoji: "🏳",
    name: "white flag",
    category: "Flags",
    subcategory: "flag",
  },
  {
    code: ["1F3F3", "FE0F", "200D", "1F308"],
    emoji: "🏳️‍🌈",
    name: "rainbow flag",
    category: "Flags",
    subcategory: "flag",
  },
  {
    code: ["1F3F3", "FE0F", "200D", "26A7", "FE0F"],
    emoji: "🏳️‍⚧️",
    name: "transgender flag",
    category: "Flags",
    subcategory: "flag",
  },
  {
    code: ["1F3F4", "200D", "2620", "FE0F"],
    emoji: "🏴‍☠️",
    name: "pirate flag",
    category: "Flags",
    subcategory: "flag",
  },
  {
    code: ["1F1E6", "1F1E8"],
    emoji: "🇦🇨",
    name: "flag: Ascension Island",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E6", "1F1E9"],
    emoji: "🇦🇩",
    name: "flag: Andorra",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E6", "1F1EA"],
    emoji: "🇦🇪",
    name: "flag: United Arab Emirates",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E6", "1F1EB"],
    emoji: "🇦🇫",
    name: "flag: Afghanistan",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E6", "1F1EC"],
    emoji: "🇦🇬",
    name: "flag: Antigua & Barbuda",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E6", "1F1EE"],
    emoji: "🇦🇮",
    name: "flag: Anguilla",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E6", "1F1F1"],
    emoji: "🇦🇱",
    name: "flag: Albania",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E6", "1F1F2"],
    emoji: "🇦🇲",
    name: "flag: Armenia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E6", "1F1F4"],
    emoji: "🇦🇴",
    name: "flag: Angola",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E6", "1F1F6"],
    emoji: "🇦🇶",
    name: "flag: Antarctica",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E6", "1F1F7"],
    emoji: "🇦🇷",
    name: "flag: Argentina",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E6", "1F1F8"],
    emoji: "🇦🇸",
    name: "flag: American Samoa",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E6", "1F1F9"],
    emoji: "🇦🇹",
    name: "flag: Austria",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E6", "1F1FA"],
    emoji: "🇦🇺",
    name: "flag: Australia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E6", "1F1FC"],
    emoji: "🇦🇼",
    name: "flag: Aruba",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E6", "1F1FD"],
    emoji: "🇦🇽",
    name: "flag: Åland Islands",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E6", "1F1FF"],
    emoji: "🇦🇿",
    name: "flag: Azerbaijan",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E7", "1F1E6"],
    emoji: "🇧🇦",
    name: "flag: Bosnia & Herzegovina",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E7", "1F1E7"],
    emoji: "🇧🇧",
    name: "flag: Barbados",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E7", "1F1E9"],
    emoji: "🇧🇩",
    name: "flag: Bangladesh",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E7", "1F1EA"],
    emoji: "🇧🇪",
    name: "flag: Belgium",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E7", "1F1EB"],
    emoji: "🇧🇫",
    name: "flag: Burkina Faso",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E7", "1F1EC"],
    emoji: "🇧🇬",
    name: "flag: Bulgaria",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E7", "1F1ED"],
    emoji: "🇧🇭",
    name: "flag: Bahrain",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E7", "1F1EE"],
    emoji: "🇧🇮",
    name: "flag: Burundi",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E7", "1F1EF"],
    emoji: "🇧🇯",
    name: "flag: Benin",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E7", "1F1F1"],
    emoji: "🇧🇱",
    name: "flag: St. Barthélemy",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E7", "1F1F2"],
    emoji: "🇧🇲",
    name: "flag: Bermuda",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E7", "1F1F3"],
    emoji: "🇧🇳",
    name: "flag: Brunei",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E7", "1F1F4"],
    emoji: "🇧🇴",
    name: "flag: Bolivia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E7", "1F1F6"],
    emoji: "🇧🇶",
    name: "flag: Caribbean Netherlands",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E7", "1F1F7"],
    emoji: "🇧🇷",
    name: "flag: Brazil",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E7", "1F1F8"],
    emoji: "🇧🇸",
    name: "flag: Bahamas",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E7", "1F1F9"],
    emoji: "🇧🇹",
    name: "flag: Bhutan",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E7", "1F1FB"],
    emoji: "🇧🇻",
    name: "flag: Bouvet Island",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E7", "1F1FC"],
    emoji: "🇧🇼",
    name: "flag: Botswana",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E7", "1F1FE"],
    emoji: "🇧🇾",
    name: "flag: Belarus",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E7", "1F1FF"],
    emoji: "🇧🇿",
    name: "flag: Belize",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E8", "1F1E6"],
    emoji: "🇨🇦",
    name: "flag: Canada",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E8", "1F1E8"],
    emoji: "🇨🇨",
    name: "flag: Cocos (Keeling) Islands",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E8", "1F1E9"],
    emoji: "🇨🇩",
    name: "flag: Congo - Kinshasa",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E8", "1F1EB"],
    emoji: "🇨🇫",
    name: "flag: Central African Republic",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E8", "1F1EC"],
    emoji: "🇨🇬",
    name: "flag: Congo - Brazzaville",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E8", "1F1ED"],
    emoji: "🇨🇭",
    name: "flag: Switzerland",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E8", "1F1EE"],
    emoji: "🇨🇮",
    name: "flag: Côte d’Ivoire",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E8", "1F1F0"],
    emoji: "🇨🇰",
    name: "flag: Cook Islands",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E8", "1F1F1"],
    emoji: "🇨🇱",
    name: "flag: Chile",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E8", "1F1F2"],
    emoji: "🇨🇲",
    name: "flag: Cameroon",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E8", "1F1F3"],
    emoji: "🇨🇳",
    name: "flag: China",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E8", "1F1F4"],
    emoji: "🇨🇴",
    name: "flag: Colombia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E8", "1F1F5"],
    emoji: "🇨🇵",
    name: "flag: Clipperton Island",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E8", "1F1F6"],
    emoji: "🇨🇶",
    name: "flag: Sark",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E8", "1F1F7"],
    emoji: "🇨🇷",
    name: "flag: Costa Rica",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E8", "1F1FA"],
    emoji: "🇨🇺",
    name: "flag: Cuba",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E8", "1F1FB"],
    emoji: "🇨🇻",
    name: "flag: Cape Verde",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E8", "1F1FC"],
    emoji: "🇨🇼",
    name: "flag: Curaçao",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E8", "1F1FD"],
    emoji: "🇨🇽",
    name: "flag: Christmas Island",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E8", "1F1FE"],
    emoji: "🇨🇾",
    name: "flag: Cyprus",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E8", "1F1FF"],
    emoji: "🇨🇿",
    name: "flag: Czechia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E9", "1F1EA"],
    emoji: "🇩🇪",
    name: "flag: Germany",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E9", "1F1EC"],
    emoji: "🇩🇬",
    name: "flag: Diego Garcia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E9", "1F1EF"],
    emoji: "🇩🇯",
    name: "flag: Djibouti",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E9", "1F1F0"],
    emoji: "🇩🇰",
    name: "flag: Denmark",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E9", "1F1F2"],
    emoji: "🇩🇲",
    name: "flag: Dominica",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E9", "1F1F4"],
    emoji: "🇩🇴",
    name: "flag: Dominican Republic",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1E9", "1F1FF"],
    emoji: "🇩🇿",
    name: "flag: Algeria",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EA", "1F1E6"],
    emoji: "🇪🇦",
    name: "flag: Ceuta & Melilla",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EA", "1F1E8"],
    emoji: "🇪🇨",
    name: "flag: Ecuador",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EA", "1F1EA"],
    emoji: "🇪🇪",
    name: "flag: Estonia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EA", "1F1EC"],
    emoji: "🇪🇬",
    name: "flag: Egypt",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EA", "1F1ED"],
    emoji: "🇪🇭",
    name: "flag: Western Sahara",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EA", "1F1F7"],
    emoji: "🇪🇷",
    name: "flag: Eritrea",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EA", "1F1F8"],
    emoji: "🇪🇸",
    name: "flag: Spain",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EA", "1F1F9"],
    emoji: "🇪🇹",
    name: "flag: Ethiopia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EA", "1F1FA"],
    emoji: "🇪🇺",
    name: "flag: European Union",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EB", "1F1EE"],
    emoji: "🇫🇮",
    name: "flag: Finland",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EB", "1F1EF"],
    emoji: "🇫🇯",
    name: "flag: Fiji",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EB", "1F1F0"],
    emoji: "🇫🇰",
    name: "flag: Falkland Islands",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EB", "1F1F2"],
    emoji: "🇫🇲",
    name: "flag: Micronesia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EB", "1F1F4"],
    emoji: "🇫🇴",
    name: "flag: Faroe Islands",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EB", "1F1F7"],
    emoji: "🇫🇷",
    name: "flag: France",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EC", "1F1E6"],
    emoji: "🇬🇦",
    name: "flag: Gabon",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EC", "1F1E7"],
    emoji: "🇬🇧",
    name: "flag: United Kingdom",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EC", "1F1E9"],
    emoji: "🇬🇩",
    name: "flag: Grenada",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EC", "1F1EA"],
    emoji: "🇬🇪",
    name: "flag: Georgia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EC", "1F1EB"],
    emoji: "🇬🇫",
    name: "flag: French Guiana",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EC", "1F1EC"],
    emoji: "🇬🇬",
    name: "flag: Guernsey",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EC", "1F1ED"],
    emoji: "🇬🇭",
    name: "flag: Ghana",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EC", "1F1EE"],
    emoji: "🇬🇮",
    name: "flag: Gibraltar",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EC", "1F1F1"],
    emoji: "🇬🇱",
    name: "flag: Greenland",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EC", "1F1F2"],
    emoji: "🇬🇲",
    name: "flag: Gambia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EC", "1F1F3"],
    emoji: "🇬🇳",
    name: "flag: Guinea",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EC", "1F1F5"],
    emoji: "🇬🇵",
    name: "flag: Guadeloupe",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EC", "1F1F6"],
    emoji: "🇬🇶",
    name: "flag: Equatorial Guinea",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EC", "1F1F7"],
    emoji: "🇬🇷",
    name: "flag: Greece",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EC", "1F1F8"],
    emoji: "🇬🇸",
    name: "flag: South Georgia & South Sandwich Islands",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EC", "1F1F9"],
    emoji: "🇬🇹",
    name: "flag: Guatemala",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EC", "1F1FA"],
    emoji: "🇬🇺",
    name: "flag: Guam",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EC", "1F1FC"],
    emoji: "🇬🇼",
    name: "flag: Guinea-Bissau",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EC", "1F1FE"],
    emoji: "🇬🇾",
    name: "flag: Guyana",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1ED", "1F1F0"],
    emoji: "🇭🇰",
    name: "flag: Hong Kong SAR China",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1ED", "1F1F2"],
    emoji: "🇭🇲",
    name: "flag: Heard & McDonald Islands",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1ED", "1F1F3"],
    emoji: "🇭🇳",
    name: "flag: Honduras",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1ED", "1F1F7"],
    emoji: "🇭🇷",
    name: "flag: Croatia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1ED", "1F1F9"],
    emoji: "🇭🇹",
    name: "flag: Haiti",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1ED", "1F1FA"],
    emoji: "🇭🇺",
    name: "flag: Hungary",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EE", "1F1E8"],
    emoji: "🇮🇨",
    name: "flag: Canary Islands",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EE", "1F1E9"],
    emoji: "🇮🇩",
    name: "flag: Indonesia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EE", "1F1EA"],
    emoji: "🇮🇪",
    name: "flag: Ireland",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EE", "1F1F1"],
    emoji: "🇮🇱",
    name: "flag: Israel",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EE", "1F1F2"],
    emoji: "🇮🇲",
    name: "flag: Isle of Man",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EE", "1F1F3"],
    emoji: "🇮🇳",
    name: "flag: India",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EE", "1F1F4"],
    emoji: "🇮🇴",
    name: "flag: British Indian Ocean Territory",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EE", "1F1F6"],
    emoji: "🇮🇶",
    name: "flag: Iraq",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EE", "1F1F7"],
    emoji: "🇮🇷",
    name: "flag: Iran",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EE", "1F1F8"],
    emoji: "🇮🇸",
    name: "flag: Iceland",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EE", "1F1F9"],
    emoji: "🇮🇹",
    name: "flag: Italy",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EF", "1F1EA"],
    emoji: "🇯🇪",
    name: "flag: Jersey",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EF", "1F1F2"],
    emoji: "🇯🇲",
    name: "flag: Jamaica",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EF", "1F1F4"],
    emoji: "🇯🇴",
    name: "flag: Jordan",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1EF", "1F1F5"],
    emoji: "🇯🇵",
    name: "flag: Japan",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F0", "1F1EA"],
    emoji: "🇰🇪",
    name: "flag: Kenya",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F0", "1F1EC"],
    emoji: "🇰🇬",
    name: "flag: Kyrgyzstan",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F0", "1F1ED"],
    emoji: "🇰🇭",
    name: "flag: Cambodia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F0", "1F1EE"],
    emoji: "🇰🇮",
    name: "flag: Kiribati",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F0", "1F1F2"],
    emoji: "🇰🇲",
    name: "flag: Comoros",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F0", "1F1F3"],
    emoji: "🇰🇳",
    name: "flag: St. Kitts & Nevis",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F0", "1F1F5"],
    emoji: "🇰🇵",
    name: "flag: North Korea",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F0", "1F1F7"],
    emoji: "🇰🇷",
    name: "flag: South Korea",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F0", "1F1FC"],
    emoji: "🇰🇼",
    name: "flag: Kuwait",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F0", "1F1FE"],
    emoji: "🇰🇾",
    name: "flag: Cayman Islands",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F0", "1F1FF"],
    emoji: "🇰🇿",
    name: "flag: Kazakhstan",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F1", "1F1E6"],
    emoji: "🇱🇦",
    name: "flag: Laos",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F1", "1F1E7"],
    emoji: "🇱🇧",
    name: "flag: Lebanon",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F1", "1F1E8"],
    emoji: "🇱🇨",
    name: "flag: St. Lucia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F1", "1F1EE"],
    emoji: "🇱🇮",
    name: "flag: Liechtenstein",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F1", "1F1F0"],
    emoji: "🇱🇰",
    name: "flag: Sri Lanka",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F1", "1F1F7"],
    emoji: "🇱🇷",
    name: "flag: Liberia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F1", "1F1F8"],
    emoji: "🇱🇸",
    name: "flag: Lesotho",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F1", "1F1F9"],
    emoji: "🇱🇹",
    name: "flag: Lithuania",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F1", "1F1FA"],
    emoji: "🇱🇺",
    name: "flag: Luxembourg",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F1", "1F1FB"],
    emoji: "🇱🇻",
    name: "flag: Latvia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F1", "1F1FE"],
    emoji: "🇱🇾",
    name: "flag: Libya",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F2", "1F1E6"],
    emoji: "🇲🇦",
    name: "flag: Morocco",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F2", "1F1E8"],
    emoji: "🇲🇨",
    name: "flag: Monaco",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F2", "1F1E9"],
    emoji: "🇲🇩",
    name: "flag: Moldova",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F2", "1F1EA"],
    emoji: "🇲🇪",
    name: "flag: Montenegro",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F2", "1F1EB"],
    emoji: "🇲🇫",
    name: "flag: St. Martin",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F2", "1F1EC"],
    emoji: "🇲🇬",
    name: "flag: Madagascar",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F2", "1F1ED"],
    emoji: "🇲🇭",
    name: "flag: Marshall Islands",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F2", "1F1F0"],
    emoji: "🇲🇰",
    name: "flag: North Macedonia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F2", "1F1F1"],
    emoji: "🇲🇱",
    name: "flag: Mali",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F2", "1F1F2"],
    emoji: "🇲🇲",
    name: "flag: Myanmar (Burma)",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F2", "1F1F3"],
    emoji: "🇲🇳",
    name: "flag: Mongolia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F2", "1F1F4"],
    emoji: "🇲🇴",
    name: "flag: Macao SAR China",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F2", "1F1F5"],
    emoji: "🇲🇵",
    name: "flag: Northern Mariana Islands",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F2", "1F1F6"],
    emoji: "🇲🇶",
    name: "flag: Martinique",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F2", "1F1F7"],
    emoji: "🇲🇷",
    name: "flag: Mauritania",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F2", "1F1F8"],
    emoji: "🇲🇸",
    name: "flag: Montserrat",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F2", "1F1F9"],
    emoji: "🇲🇹",
    name: "flag: Malta",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F2", "1F1FA"],
    emoji: "🇲🇺",
    name: "flag: Mauritius",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F2", "1F1FB"],
    emoji: "🇲🇻",
    name: "flag: Maldives",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F2", "1F1FC"],
    emoji: "🇲🇼",
    name: "flag: Malawi",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F2", "1F1FD"],
    emoji: "🇲🇽",
    name: "flag: Mexico",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F2", "1F1FE"],
    emoji: "🇲🇾",
    name: "flag: Malaysia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F2", "1F1FF"],
    emoji: "🇲🇿",
    name: "flag: Mozambique",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F3", "1F1E6"],
    emoji: "🇳🇦",
    name: "flag: Namibia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F3", "1F1E8"],
    emoji: "🇳🇨",
    name: "flag: New Caledonia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F3", "1F1EA"],
    emoji: "🇳🇪",
    name: "flag: Niger",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F3", "1F1EB"],
    emoji: "🇳🇫",
    name: "flag: Norfolk Island",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F3", "1F1EC"],
    emoji: "🇳🇬",
    name: "flag: Nigeria",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F3", "1F1EE"],
    emoji: "🇳🇮",
    name: "flag: Nicaragua",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F3", "1F1F1"],
    emoji: "🇳🇱",
    name: "flag: Netherlands",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F3", "1F1F4"],
    emoji: "🇳🇴",
    name: "flag: Norway",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F3", "1F1F5"],
    emoji: "🇳🇵",
    name: "flag: Nepal",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F3", "1F1F7"],
    emoji: "🇳🇷",
    name: "flag: Nauru",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F3", "1F1FA"],
    emoji: "🇳🇺",
    name: "flag: Niue",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F3", "1F1FF"],
    emoji: "🇳🇿",
    name: "flag: New Zealand",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F4", "1F1F2"],
    emoji: "🇴🇲",
    name: "flag: Oman",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F5", "1F1E6"],
    emoji: "🇵🇦",
    name: "flag: Panama",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F5", "1F1EA"],
    emoji: "🇵🇪",
    name: "flag: Peru",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F5", "1F1EB"],
    emoji: "🇵🇫",
    name: "flag: French Polynesia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F5", "1F1EC"],
    emoji: "🇵🇬",
    name: "flag: Papua New Guinea",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F5", "1F1ED"],
    emoji: "🇵🇭",
    name: "flag: Philippines",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F5", "1F1F0"],
    emoji: "🇵🇰",
    name: "flag: Pakistan",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F5", "1F1F1"],
    emoji: "🇵🇱",
    name: "flag: Poland",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F5", "1F1F2"],
    emoji: "🇵🇲",
    name: "flag: St. Pierre & Miquelon",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F5", "1F1F3"],
    emoji: "🇵🇳",
    name: "flag: Pitcairn Islands",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F5", "1F1F7"],
    emoji: "🇵🇷",
    name: "flag: Puerto Rico",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F5", "1F1F8"],
    emoji: "🇵🇸",
    name: "flag: Palestinian Territories",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F5", "1F1F9"],
    emoji: "🇵🇹",
    name: "flag: Portugal",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F5", "1F1FC"],
    emoji: "🇵🇼",
    name: "flag: Palau",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F5", "1F1FE"],
    emoji: "🇵🇾",
    name: "flag: Paraguay",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F6", "1F1E6"],
    emoji: "🇶🇦",
    name: "flag: Qatar",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F7", "1F1EA"],
    emoji: "🇷🇪",
    name: "flag: Réunion",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F7", "1F1F4"],
    emoji: "🇷🇴",
    name: "flag: Romania",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F7", "1F1F8"],
    emoji: "🇷🇸",
    name: "flag: Serbia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F7", "1F1FA"],
    emoji: "🇷🇺",
    name: "flag: Russia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F7", "1F1FC"],
    emoji: "🇷🇼",
    name: "flag: Rwanda",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F8", "1F1E6"],
    emoji: "🇸🇦",
    name: "flag: Saudi Arabia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F8", "1F1E7"],
    emoji: "🇸🇧",
    name: "flag: Solomon Islands",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F8", "1F1E8"],
    emoji: "🇸🇨",
    name: "flag: Seychelles",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F8", "1F1E9"],
    emoji: "🇸🇩",
    name: "flag: Sudan",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F8", "1F1EA"],
    emoji: "🇸🇪",
    name: "flag: Sweden",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F8", "1F1EC"],
    emoji: "🇸🇬",
    name: "flag: Singapore",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F8", "1F1ED"],
    emoji: "🇸🇭",
    name: "flag: St. Helena",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F8", "1F1EE"],
    emoji: "🇸🇮",
    name: "flag: Slovenia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F8", "1F1EF"],
    emoji: "🇸🇯",
    name: "flag: Svalbard & Jan Mayen",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F8", "1F1F0"],
    emoji: "🇸🇰",
    name: "flag: Slovakia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F8", "1F1F1"],
    emoji: "🇸🇱",
    name: "flag: Sierra Leone",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F8", "1F1F2"],
    emoji: "🇸🇲",
    name: "flag: San Marino",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F8", "1F1F3"],
    emoji: "🇸🇳",
    name: "flag: Senegal",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F8", "1F1F4"],
    emoji: "🇸🇴",
    name: "flag: Somalia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F8", "1F1F7"],
    emoji: "🇸🇷",
    name: "flag: Suriname",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F8", "1F1F8"],
    emoji: "🇸🇸",
    name: "flag: South Sudan",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F8", "1F1F9"],
    emoji: "🇸🇹",
    name: "flag: São Tomé & Príncipe",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F8", "1F1FB"],
    emoji: "🇸🇻",
    name: "flag: El Salvador",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F8", "1F1FD"],
    emoji: "🇸🇽",
    name: "flag: Sint Maarten",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F8", "1F1FE"],
    emoji: "🇸🇾",
    name: "flag: Syria",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F8", "1F1FF"],
    emoji: "🇸🇿",
    name: "flag: Eswatini",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F9", "1F1E6"],
    emoji: "🇹🇦",
    name: "flag: Tristan da Cunha",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F9", "1F1E8"],
    emoji: "🇹🇨",
    name: "flag: Turks & Caicos Islands",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F9", "1F1E9"],
    emoji: "🇹🇩",
    name: "flag: Chad",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F9", "1F1EB"],
    emoji: "🇹🇫",
    name: "flag: French Southern Territories",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F9", "1F1EC"],
    emoji: "🇹🇬",
    name: "flag: Togo",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F9", "1F1ED"],
    emoji: "🇹🇭",
    name: "flag: Thailand",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F9", "1F1EF"],
    emoji: "🇹🇯",
    name: "flag: Tajikistan",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F9", "1F1F0"],
    emoji: "🇹🇰",
    name: "flag: Tokelau",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F9", "1F1F1"],
    emoji: "🇹🇱",
    name: "flag: Timor-Leste",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F9", "1F1F2"],
    emoji: "🇹🇲",
    name: "flag: Turkmenistan",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F9", "1F1F3"],
    emoji: "🇹🇳",
    name: "flag: Tunisia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F9", "1F1F4"],
    emoji: "🇹🇴",
    name: "flag: Tonga",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F9", "1F1F7"],
    emoji: "🇹🇷",
    name: "flag: Türkiye",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F9", "1F1F9"],
    emoji: "🇹🇹",
    name: "flag: Trinidad & Tobago",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F9", "1F1FB"],
    emoji: "🇹🇻",
    name: "flag: Tuvalu",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F9", "1F1FC"],
    emoji: "🇹🇼",
    name: "flag: Taiwan",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1F9", "1F1FF"],
    emoji: "🇹🇿",
    name: "flag: Tanzania",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1FA", "1F1E6"],
    emoji: "🇺🇦",
    name: "flag: Ukraine",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1FA", "1F1EC"],
    emoji: "🇺🇬",
    name: "flag: Uganda",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1FA", "1F1F2"],
    emoji: "🇺🇲",
    name: "flag: U.S. Outlying Islands",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1FA", "1F1F3"],
    emoji: "🇺🇳",
    name: "flag: United Nations",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1FA", "1F1F8"],
    emoji: "🇺🇸",
    name: "flag: United States",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1FA", "1F1FE"],
    emoji: "🇺🇾",
    name: "flag: Uruguay",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1FA", "1F1FF"],
    emoji: "🇺🇿",
    name: "flag: Uzbekistan",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1FB", "1F1E6"],
    emoji: "🇻🇦",
    name: "flag: Vatican City",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1FB", "1F1E8"],
    emoji: "🇻🇨",
    name: "flag: St. Vincent & Grenadines",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1FB", "1F1EA"],
    emoji: "🇻🇪",
    name: "flag: Venezuela",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1FB", "1F1EC"],
    emoji: "🇻🇬",
    name: "flag: British Virgin Islands",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1FB", "1F1EE"],
    emoji: "🇻🇮",
    name: "flag: U.S. Virgin Islands",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1FB", "1F1F3"],
    emoji: "🇻🇳",
    name: "flag: Vietnam",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1FB", "1F1FA"],
    emoji: "🇻🇺",
    name: "flag: Vanuatu",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1FC", "1F1EB"],
    emoji: "🇼🇫",
    name: "flag: Wallis & Futuna",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1FC", "1F1F8"],
    emoji: "🇼🇸",
    name: "flag: Samoa",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1FD", "1F1F0"],
    emoji: "🇽🇰",
    name: "flag: Kosovo",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1FE", "1F1EA"],
    emoji: "🇾🇪",
    name: "flag: Yemen",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1FE", "1F1F9"],
    emoji: "🇾🇹",
    name: "flag: Mayotte",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1FF", "1F1E6"],
    emoji: "🇿🇦",
    name: "flag: South Africa",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1FF", "1F1F2"],
    emoji: "🇿🇲",
    name: "flag: Zambia",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F1FF", "1F1FC"],
    emoji: "🇿🇼",
    name: "flag: Zimbabwe",
    category: "Flags",
    subcategory: "country-flag",
  },
  {
    code: ["1F3F4", "E0067", "E0062", "E0065", "E006E", "E0067", "E007F"],
    emoji: "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
    name: "flag: England",
    category: "Flags",
    subcategory: "subdivision-flag",
  },
  {
    code: ["1F3F4", "E0067", "E0062", "E0073", "E0063", "E0074", "E007F"],
    emoji: "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
    name: "flag: Scotland",
    category: "Flags",
    subcategory: "subdivision-flag",
  },
  {
    code: ["1F3F4", "E0067", "E0062", "E0077", "E006C", "E0073", "E007F"],
    emoji: "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
    name: "flag: Wales",
    category: "Flags",
    subcategory: "subdivision-flag",
  },
];
